import TopNav from "../components/core/Topnavigation.vue";
import Pagination from "vue-pagination-2";
import uploadWindow from "../components/files/Upload.vue";
import createCatalog from "../components/categories/createCatalog.vue";
import createPhotoAlbum from "../components/categories/createCatalog.vue";
import createAssetPackageAlbum from "../components/categories/createCatalog.vue";
import FusionAssetBrowserComponent from "../components/files/filesBrowse.vue"
import DragSelect from "drag-select-vue"
import EditCategory from '../components/categories/EditCategory.vue'
import RetrieveAs from "../components/core/RetrieveAs.vue";
// import NewTasksIssues from "../PAM/newTasksIssues.vue";
import fileBrowseModel from "../components/files/filesBrowse.vue";
import highlightMixin from '../mixins/highlightMixin.js';
// import MetadataRequestor from "../files/MetadataRequestor.vue";
// import EditAndShare from "../components/share/EditAndShare.vue";
import modifyTTL from "../components/actions/ModifyTTL.vue";
import OpenCatalogBrowse from "../components/categories/OpenInCatalogBrowse.vue";
//import ManageVersion from "../ManageVersions/ManageVersionsDialog.vue";
import StoryBoardImagePreview from '../components/core/StoryboardOnThumbnail.vue';
import CatalogsBinsCommonMixins from '../mixins/CatalogsBinsCommonMixin.js';
import svgIconsBrowser from "../components/core/SvgIconBrowser.vue";
import departmentsCommonComponent from "../components/miscellaneous/departmentsCommonComponent.vue";
import ManageAssetsLink from "../components/AssetsLinks/AssetsLinkViewOrEdit.vue";
import setLabelToAssetDialog from "../components/files/SetLabelDialog.vue";
import ImageAnnotationWithComments from '../components/core/assetAnnotationWithComments.vue';
import "../../src/assets/common.scss"
import customAlertMessage from "../components/actions/customAlertMessage.vue";
import Utils from '../components.utils';
import Constants from "../components.constants.js";
import {NotifierConstants} from "../components.constants.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BinContextMenu } from "../registry/plugins.js";
import customPerPage from "../components/core/customizePagination.vue";
import setUserDialog from "../components/userGroups/AddSingleUserFromBrowse.vue";
const METADATA_TABLE_COLUMNS_STORAGE_KEY = 'metadata_table_column_preferences';

export default{
    mixins:[highlightMixin,CatalogsBinsCommonMixins],
    props: ["refreshFileInfoAndShowAsset", "catalogSelected","viewType","rootPathPermission","isAdvancedSearchEnabled", "getCookieValueOfJobPanel", "workspace", "rootCatalogInfo"],
    components: {
      "top-nav": TopNav,
      pagination: Pagination,
      'drag-select-container': DragSelect,
      "edit-catalog": EditCategory,
      "retrieve-as":RetrieveAs,
      upload: uploadWindow,
      "create-catalog":createCatalog, 
      "create-photo-album":createPhotoAlbum,
      "create-asset-package":createAssetPackageAlbum,
      "fusion-assets-browser":FusionAssetBrowserComponent,
      "svg-icon-browser":svgIconsBrowser,
      // "new-tasks-issues":NewTasksIssues,
      "files-browser":fileBrowseModel,
      // "metadata-requestor":MetadataRequestor,
      // "edit-and-share":EditAndShare,
      "modify-ttl": modifyTTL,
      "OCBrowse":OpenCatalogBrowse,
      //"manage-version":ManageVersion,
      StoryBoardImagePreview,
      departmentsCommonComponent,
      "manage-assets-link": ManageAssetsLink,
      "set-label-to-asset":setLabelToAssetDialog,
      "image-annotation-with-comments":ImageAnnotationWithComments,
      customAlertMessage,
      "custom-per-page":customPerPage,
      "set-user-dialog":setUserDialog,
    },
    computed: {
      allStartUpData() {
        return this.$store.state.startUpData.startUpDataDetails || {};
      },
      
      enabledMetadataColumns() {
        const customMetadatas = this.allStartUpData.custom_metadatas || [];
      
        return customMetadatas.filter(field =>
          this.enabledMetadataColumnIds.includes(field._id)
        );
      },
      selectedFilesDetails(){
        return {"singlefile":this.selectedFileInfo, "multiplefiles":{}}
      },
      dirs() {
        // if(this.workspace && this.workspace == 'Projects'){
        //   if(this.catalogTraverseStructure.length > 1){
        //     let split_id = this.rootCatalogInfo.asset_id;
        //     let split_index = this.catalogTraverseStructure.findIndex(item => item._id === split_id);
        //     let right_side_list = split_index !== -1 ? this.catalogTraverseStructure.slice(split_index + 1) : [];
        //     console.log("right_side_listright_side_listright_side_list",right_side_list)
        //     return right_side_list;
        //   }else{
        //     return this.catalogTraverseStructure;
        //   }
        // }else{
          return this.catalogTraverseStructure;
        // }
      },
      contextMenuOptions() {
        let contextMenuOptions = this.contextMenuItems;
        if(this.workspace && this.workspace == 'Projects'){
          contextMenuOptions = contextMenuOptions.filter(e => ['Upload','tag-metadata','copy-link','manage-catalogs'].includes(e.action_name) || e.label == 'New');
        }
        return contextMenuOptions.sort(function(a, b){return a.position_priority - b.position_priority})
      },
      contextMenuMoreOptions() {
        let moreContextMenuOptions = this.subMenuItems;
        return moreContextMenuOptions.sort(function(a, b){return a.position_priority - b.position_priority})
      },
      contextMenuExportOptions() {
        return this.subMenuExportItems;
      },
      contextMenuOpenWithOptions(){
        return this.subMenuOpenWithItems;
      },
      contextMenuExportProxyOptions(){
        return this.subMenuExportProxyItems;
      },
      contextMenuShareOptions() {
        return this.subMenuShareItems;
      },
      contextMenuCatalogIconOptions(){
        return this.subMenuCatalogIconItems;
      },
      contextMenuAIToolOptions(){
        return this.subMenuAIToolItems;
      },
      contextMenuArchiveOptions(){
          return this.subMenuArchiveItems;
      },
      contextMenuRetrieveOptions(){
          return this.subMenuRetrieveItems;
      },
      getTargetBinIcon(){
        return Utils.getBinsSvg("",16,16);
      },
      contextMenuNewOptions() {
        return this.subMenuNewItems;
      },
      contextMenuImportOptions() {
        return this.subMenuImportItems;
      },
      barcodeInfoFromStartup:{
          get(){
              return this.$store.state.startUpData.startUpDataDetails;
          }
      },
      currentProperties() {                                        //Dynamically send props
        if(this.openTagMetadataModel == "set-label-to-asset"){
          let properties = {}
          if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
            properties['seletedAssetIdList'] = [this.selectedFileInfo.asset_id];
            properties['selectedAssetInfo'] = this.selectedFileInfo
          }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
            properties['seletedAssetIdList'] = Object.values(this.selectedFiles).map(obj => obj.asset_id);
            properties['selectedAssetInfo'] = null
          }
          return  properties
        }else if(this.openTagMetadataModel == "files-browser"){
          return {enableAssetMultiSelect:true, enableBinsWorkspace:true, enableCatalogsWorkspace:true, workspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS] }
        }else if (["retrieve-as","svg-icon-browser","metadata-manager", "properties","metadata-requestor", "share-in-chat", "edit-and-share"].includes(this.openTagMetadataModel) || this.openSubclips) {
          return { fileInfo : this.selectedFileInfo, context:"catalog"}              
        }else if (["edit-catalog"].includes(this.openTagMetadataModel) || this.openSubclips) {
          return { selectedCategory : this.selectedFileInfo}              
        }else if(["bulk-tagmetadata-manager","move-catalog-manager","OCR","OBD","facedetection","AudioTranscript","VideoTranscript","share-with-user","share-via-email"].includes(this.openTagMetadataModel) || this.openVideoTranscript){
          if(Object.keys(this.selectedFileInfo).length)
            return { filesInfo : [this.selectedFileInfo], updateType:"asset_list",fileInfo:[this.selectedFileInfo]}
          return { filesInfo : this.getSelectedMultipleFilesAsList(this.selectedFiles), updateType:"asset_list"}
        }else if(this.openTagMetadataModel == "create-catalog"){
          return {
                  parentCalalog: Object.assign({}, this.selectedCatalog), 
                  isCatalogExists: this.isCatalogExists,
                  // refreshCatalogList: this.updateCatalogChildren
                  }
        }else if(this.openTagMetadataModel == "create-photo-album"){
          return {parentCalalog: Object.assign({}, this.selectedCatalog),isCatalogExists: this.isCatalogExists,catalogType:'photo_album'}
        }else if(this.openTagMetadataModel == "create-asset-package"){
          return {parentCalalog: Object.assign({}, this.selectedCatalog),isCatalogExists: this.isCatalogExists,catalogType:'package'}
        }else if(this.openTagMetadataModel == "fusion-assets-browser"){
          let propsMap = {enableBinsWorkspace:true, enableCatalogsWorkspace:true, workspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS], supportedBrowseMimeType:['image'] }
          if(this.browseCoverPhoto){
            propsMap["enableAssetMultiSelect"] = false
          }else{
            propsMap["enableAssetMultiSelect"] = true
          }
          if(this.browseInPackage){
            propsMap['supportedBrowseMimeType'] = []
          }
          return propsMap
        }else if(this.openTagMetadataModel === 'PartialRetrieve' || this.openTagMetadataModel == 'new-review' || this.openTagMetadataModel == 'manage-version'){
            if(Object.keys(this.selectedFileInfo).length) return { fileInfo : this.selectedFileInfo,newReview:true}
            return { fileInfo : this.selectedFiles,newReview:true}
        }else if(this.openTagMetadataModel == "modify-ttl"){
          if(Object.keys(this.selectedFileInfo).length){  
            return { filesInfo : [this.selectedFileInfo], context:"catalog"} 
          } 
          return { filesInfo : this.getSelectedMultipleFilesAsList(this.selectedFiles), context:"catalog"}  
        }else if(this.openTagMetadataModel == "manage-assets-link"){
          if(Object.keys(this.selectedFileInfo).length){
            return {fileInfo:this.selectedFileInfo, viewOnly:false}
          }
          return {fileInfo:null}
        }
        // else if(this.openTagMetadataModel == 'new-tasks-issues'){
        //     console.log("checking****************************catalogNewTask");
            
        //     if(Object.keys(this.selectedFileInfo).length) return { fileInfo : this.selectedFileInfo, newTaskIssue:true}
        //     return { fileInfo : this.selectedFiles, newTaskIssue:true }
        // }
        else{
            return {}
        }
      },
      getDefaultPoolfromInMem() {
          for (const pool of Object.values(this.getPoolsfromInMem())) {
              if (pool.default){
                  return pool
              }
          }
          if (Object.values(this.getPoolsfromInMem()).length){
              return Object.values(this.getPoolsfromInMem())[0]
          }
          return {}
      },
      alertMessageProperties(){
        return {
          "messageTitle":this.$t("Access Denied"),
          "messageType": "",
          "displayMessage":`${this.$t("You do not have the required privileges to access this feature. Please reach out to your administrator for assistance")}.`,
          "getUserConfirmation":false}
      },
      ...mapGetters("users", ["getIsMetadataDockVisible","getIsAssetsDetailsPanelVisible","getLoggedInUserAccessControl","getLoggedInUserPrivilege","getLoggedInUserId","getUsersBasicInfoFromStore"]),
      ...mapGetters("privileges",["getActionListFromInMem"]),
    },
    methods: {  
      handleMetadataViewColumnsUpdated(columns) {
        this.handleColumnsUpdated(columns);
      },
      shouldShowMultilineToggleForValue(value) {
        if (!value || value === '-') return false;
      
        const text = Array.isArray(value) ? value.join(', ') : String(value);
      
        return text.split(/\r?\n/).length > 2 || text.length > 120;
      },
      getMultilineExpandKey(asset, column) {
        const assetId = asset && (asset._id || asset.file_uid || asset.catalog_uid)
          ? (asset._id || asset.file_uid || asset.catalog_uid)
          : 'asset';
      
        const columnId = column && (column._id || column.key_id || column.id || column.key)
          ? (column._id || column.key_id || column.id || column.key)
          : 'column';
      
        return `${assetId}_${columnId}`;
      },
      
      isMultilineExpanded(asset, column) {
        return !!this.expandedMultilineFields[this.getMultilineExpandKey(asset, column)];
      },
      
      toggleMultilineExpand(asset, column) {
        const key = this.getMultilineExpandKey(asset, column);
      
        this.$set(this.expandedMultilineFields, key, !this.expandedMultilineFields[key]);
      },
      
      shouldShowMultilineToggle(asset, column) {
        const value = this.getMetadataColumnValue(asset, column);
      
        if (!value || value === "-") return false;
      
        const lines = String(value).split(/\r?\n/);
      
        return lines.length > 2 || String(value).length > 120;
      },
      
      getDockMetadataRefreshKey(asset) {
        if (!asset) return "";
      
        const customMetadata =
          asset.custom_metadata ||
          asset.custom_metadatas ||
          (asset.metadata && asset.metadata.custom_metadata) ||
          [];
      
        try {
          return JSON.stringify(customMetadata);
        } catch (e) {
          return Date.now();
        }
      },
      shouldUseTwoLineMetadataDisplayByType(metadata) {
        return metadata && (
          metadata.type === 'FREETEXT_MULTILINE' ||
          metadata.type === 'FREETEXT_MULTIVALUE'
        );
      },
      isDockMetadataWide(item) {
        if (!item) {
          return false;
        }
      
        const key = String(item.key || "").toLowerCase();
        const value = this.getDockMetadataDisplayValue
          ? this.getDockMetadataDisplayValue(item)
          : String(item.value || "");
      
        return (
          this.isDockMetadataMultiline(item) ||
          value.length > 35 ||
          key.includes("story") ||
          key.includes("script") ||
          key.includes("line") ||
          key.includes("location")
        );
      },
      isDockMetadataMultiline(item) {
        return item && ["FREETEXT_MULTILINE", "FREETEXT_MULTIVALUE"].includes(item.type);
      },
      getDockMetadataDisplayValue(item) {
        if (!item || item.value === undefined || item.value === null) {
          return "";
        }
  
        if (Array.isArray(item.value)) {
          return item.value
            .filter(value => value !== undefined && value !== null && String(value).trim())
            .map(value => String(value))
            .join(", ");
        }
  
        return String(item.value);
      },
      shouldShowDockMetadataToggle(item) {
        const value = this.getDockMetadataDisplayValue(item);
  
        if (!value) {
          return false;
        }
  
        if (typeof this.shouldShowMultilineToggleForValue === "function") {
          return this.shouldShowMultilineToggleForValue(value);
        }
  
        return value.length > 140 || value.split(/\r?\n/).length > 2;
      },  
      getMetadataHighlight() {
        // if (!asset || !asset.highlight || !asset.highlight["custom_metadata.text_value"]) {
        //   return null;
        // }
      
        // const values = this.getMetadataDisplayValues(asset, column);
        // if (!values.length) return null;
      
        // const plainValues = values
        //   .map(v => String(v).replace(/\s+/g, " ").trim())
        //   .filter(Boolean);
      
        // const highlights = asset.highlight["custom_metadata.text_value"].filter((highlightText) => {
        //   const plainHighlight = String(highlightText)
        //     .replace(/<[^>]+>/g, "")
        //     .replace(/\s+/g, " ")
        //     .trim();
      
        //   return plainValues.some((value) => {
        //     return (
        //       value.includes(plainHighlight) ||
        //       plainHighlight.includes(value) ||
        //       this.hasCommonWords(value, plainHighlight)
        //     );
        //   });
        // });
      
        // return highlights.length ? highlights.join("<br>") : null;
        return null;
      },
      
      hasCommonWords(sourceText, highlightText) {
        const sourceWords = String(sourceText).toLowerCase().match(/[a-z0-9]+/g) || [];
        const highlightWords = String(highlightText).toLowerCase().match(/[a-z0-9]+/g) || [];
      
        const sourceSet = new Set(sourceWords);
        const matchedWords = highlightWords.filter(word => sourceSet.has(word));
      
        return matchedWords.length >= 3;
      },
      getDockMetadataItems(asset) {
        if (!asset || !this.enabledMetadataColumns || !this.enabledMetadataColumns.length) {
          return [];
        }
      
        return this.enabledMetadataColumns
          .map((column) => {
            const value = this.getMetadataInlineDisplayValue(asset, column);
      
            return {
              key: column.name || column.label || column.key || "Metadata",
              value,
              type: column.type,
              _id: column._id,
              id: column.id,
              key_id: column.key_id,
              field_id: column.field_id
            };
          })
          .filter((item) => item.value && item.value !== "-");
      },
      getMetadataInlineDisplayValue(asset, column) {
        let value = "";

        const values = this.getMetadataDisplayValues(asset, column);

        if (values && values.length) {
          value = values.join(", ");
        }

        if (!value) {
          value = this.getMetadataColumnValue(asset, column);
        }

        if (Array.isArray(value)) {
          value = value.join(", ");
        }

        value = value === null || value === undefined ? "" : String(value);

        return value
          .replace(/\n+/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      },
      getCustomMetadataEntry(asset, column) {
        if (!asset || !column) return null;
      
        const customMetadataList =
          asset.custom_metadata ||
          asset.custom_metadatas ||
          (asset.metadata && asset.metadata.custom_metadata) ||
          [];
      
        const columnIds = [
          column._id,
          column.id,
          column.key_id,
          column.field_id,
          column.custom_metadata_id
        ]
          .filter(Boolean)
          .map((id) => String(id));
      
        return customMetadataList.find((metadata) => {
          if (!metadata) return false;
      
          const metadataIds = [
            metadata.key_id,
            metadata._id,
            metadata.id,
            metadata.field_id,
            metadata.custom_metadata_id,
            metadata.metadata_id
          ]
            .filter(Boolean)
            .map((id) => String(id));
      
          return metadataIds.some((id) => columnIds.includes(id));
        }) || null;
      },
      
      getMetadataFieldInfoList(asset, metadata, column) {
        if (!asset || !metadata) {
          return [];
        }
      
        const metadataIds = [
          metadata.key_id,
          metadata._id,
          metadata.id,
          metadata.field_id,
          column && column._id,
          column && column.id,
          column && column.key_id,
          column && column.field_id
        ]
          .filter(Boolean)
          .map(id => String(id));
      
        const normalizeOptions = (source) => {
          if (!source) {
            return [];
          }
      
          if (Array.isArray(source)) {
            return source;
          }
      
          if (typeof source === "object") {
            return (
              source.field_info ||
              source.options ||
              source.values ||
              source.value_list ||
              source.picklist_values ||
              source.items ||
              []
            );
          }
      
          return [];
        };
      
        // Priority 1: field_info inside the custom metadata entry itself
        let fieldInfoList = normalizeOptions(metadata.field_info);
      
        if (fieldInfoList.length) {
          return fieldInfoList;
        }
      
        // Priority 2: field_info inside file/catalog details
        const assetFieldInfo = asset.field_info || asset.fields_info || asset.metadata_field_info;
      
        if (!assetFieldInfo) {
          return [];
        }
      
        if (Array.isArray(assetFieldInfo)) {
          const matchedFieldInfo = assetFieldInfo.find((field) => {
            if (!field || typeof field !== "object") {
              return false;
            }
      
            const fieldIds = [
              field.key_id,
              field._id,
              field.id,
              field.field_id,
              field.custom_metadata_id,
              field.metadata_id
            ]
              .filter(Boolean)
              .map(id => String(id));
      
            return fieldIds.some(id => metadataIds.includes(id));
          });
      
          if (matchedFieldInfo) {
            return normalizeOptions(matchedFieldInfo);
          }
      
          // Some websocket payloads may send flat option list directly
          return assetFieldInfo.filter(item => item && item.value_id && item.value);
        }
      
        if (typeof assetFieldInfo === "object") {
          for (const id of metadataIds) {
            if (assetFieldInfo[id]) {
              return normalizeOptions(assetFieldInfo[id]);
            }
          }
        }
      
        return [];
      },
      
      getMappedPicklistValues(asset, metadata, column) {
        const rawValue = metadata && metadata.value !== undefined
          ? metadata.value
          : [];
      
        const selectedIds = Array.isArray(rawValue)
          ? rawValue.map(value => String(value))
          : [String(rawValue)];
      
        const fieldInfoList = this.getMetadataFieldInfoList(asset, metadata, column);
      
        if (!selectedIds.length || !fieldInfoList.length) {
          return [];
        }
      
        return selectedIds
          .map((selectedId) => {
            const matchedInfo = fieldInfoList.find((info) => {
              if (!info || typeof info !== "object") {
                return false;
              }
      
              const valueId = info.value_id || info.id || info._id || info.key || info.valueId;
      
              return String(valueId) === selectedId;
            });
      
            if (!matchedInfo) {
              return "";
            }
      
            return (
              matchedInfo.value ||
              matchedInfo.label ||
              matchedInfo.name ||
              matchedInfo.text ||
              ""
            );
          })
          .filter(value => value !== null && value !== undefined && String(value).trim() !== "")
          .map(value => String(value));
      },
      
      normalizeCustomMetadataDisplayValue(value) {
        if (Array.isArray(value)) {
          return value
            .map((item) => {
              if (item && typeof item === "object") {
                return item.name || item.label || item.value || item.text || "";
              }
      
              return item;
            })
            .filter(item => item !== null && item !== undefined && String(item).trim() !== "")
            .map(item => String(item));
        }
      
        if (value && typeof value === "object") {
          value = value.name || value.label || value.value || value.text || "";
        }
      
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          return [String(value)];
        }
      
        return [];
      },
      
      getMetadataDisplayValues(asset, column) {
        const metadata = this.getCustomMetadataEntry(asset, column);
      
        if (!metadata) {
          return [];
        }
      
        const metadataType = metadata.type || column.type;
      
        // Normal API response case: backend sends display value directly
        if (metadata.text_value !== undefined && metadata.text_value !== null) {
          return this.normalizeCustomMetadataDisplayValue(metadata.text_value);
        }
      
        // Websocket case: PICKLIST/PICKLIST_MULTIVALUE value contains ids.
        // Use field_info as mapper to show labels instead of ids.
        if (["PICKLIST", "PICKLIST_MULTIVALUE"].includes(metadataType)) {
          const mappedValues = this.getMappedPicklistValues(asset, metadata, column);
      
          if (mappedValues.length) {
            return mappedValues;
          }
        }
      
        // Websocket case for FREETEXT, DATE, DATETIME, NUMBER, FREETEXT_MULTILINE etc.
        // Backend sends value as list, so unwrap and show actual value.
        const value =
          metadata.value !== undefined ? metadata.value :
          metadata.values !== undefined ? metadata.values :
          metadata.field_value !== undefined ? metadata.field_value :
          metadata.display_value !== undefined ? metadata.display_value :
          metadata.selected_values !== undefined ? metadata.selected_values :
          "";
      
        return this.normalizeCustomMetadataDisplayValue(value);
      },
      
      getMetadataColumnValue(asset, column) {
        const values = this.getMetadataDisplayValues(asset, column);
      
        if (!values.length) {
          return "-";
        }
      
        const metadata = this.getCustomMetadataEntry(asset, column);
        const metadataType = metadata && metadata.type ? metadata.type : column.type;
      
        if (metadataType === "FREETEXT_MULTILINE") {
          return values.join("\n");
        }
      
        return values.join(", ");
      },
      
      isMetadataMultiValue(asset, column) {
        const metadata = this.getCustomMetadataEntry(asset, column);
      
        if (!metadata) {
          return false;
        }
      
        const metadataType = metadata.type || column.type;
      
        return ["PICKLIST_MULTIVALUE", "FREETEXT_MULTIVALUE"].includes(metadataType);
      },
      
      
      isMetadataMultiline(asset, column) {
        const metadata = this.getCustomMetadataEntry(asset, column);
      
        const metadataType =
          metadata && metadata.type
            ? metadata.type
            : column && column.type
              ? column.type
              : "";
      
        return ["FREETEXT_MULTILINE", "FREETEXT_MULTIVALUE"].includes(metadataType);
      },
      
      getListTableColumnStyle(columnKey, defaultWidth, isMetadataColumn = false) {
        if (!this.shouldUseFlexibleSlugColumn()) {
          return {
            width: this.getColumnWidth(columnKey, defaultWidth)
          };
        }
      
        const configuredColumnCount = Array.isArray(this.enabledMetadataColumns)
          ? this.enabledMetadataColumns.length
          : 0;
      
        if (columnKey === "slugname") {
          return {
            width: "auto"
          };
        }
      
        if (isMetadataColumn) {
          return {
            width: configuredColumnCount === 1
              ? this.getColumnWidth(columnKey, "220px")
              : this.getColumnWidth(columnKey, "180px")
          };
        }
      
        const fixedWidths = {
          preview: this.getColumnWidth("preview", "110px"),
          created_datetime: this.getColumnWidth("created_datetime", "150px"),
          added_datetime: this.getColumnWidth("added_datetime", "150px"),
          size: this.getColumnWidth("size", "115px")
        };
      
        return {
          width: fixedWidths[columnKey] || defaultWidth
        };
      },

      getNormalListColumnWidth(columnId) {
        const defaultWidths = this.getDefaultListColumnWidths();
        const width =
          this.columnResizeWidths && this.columnResizeWidths[columnId]
            ? this.columnResizeWidths[columnId]
            : defaultWidths[columnId] || 160;
      
        return `${width}px`;
      },

      getColumnMinimumWidth(columnId) {
        const minWidths = this.getMinimumListColumnWidths();
      
        if (minWidths[columnId]) {
          return minWidths[columnId];
        }
      
        return minWidths.metadata;
      },

      getDefaultListColumnWidths() {
        return {
          preview: 140,
          slugname: 520,
          created_datetime: 140,
          added_datetime: 140,
          size: 105
        };
      },
      getColumnResizeStorageKey() {
        const userId = this.$store &&
          this.$store.state &&
          this.$store.state.user &&
          this.$store.state.user.userDetails &&
          this.$store.state.user.userDetails._id
            ? this.$store.state.user.userDetails._id
            : 'default_user';
      
        const catalogId = this.rootCatalogInfo && this.rootCatalogInfo._id
          ? this.rootCatalogInfo._id
          : 'default_catalog';
      
        return `catalog_list_column_resize_widths_${userId}_${catalogId}`;
      },
      
      saveColumnResizeWidths() {
        localStorage.setItem(
          this.getColumnResizeStorageKey(),
          JSON.stringify(this.columnResizeWidths || {})
        );
      },
      
      loadColumnResizeWidths() {
        const savedWidths = localStorage.getItem(this.getColumnResizeStorageKey());
      
        if (!savedWidths) return;
      
        try {
          const parsedWidths = JSON.parse(savedWidths);
      
          if (parsedWidths && typeof parsedWidths === 'object') {
            this.columnResizeWidths = parsedWidths;
          }
        } catch (e) {
          this.columnResizeWidths = {};
        }
      },
      startColumnResize(e, columnKey) {
        if (this.isDockPanelOpen()) return;
      
        this.isResizingColumn = true;
      
        const startX = e.clientX;
        const startWidth = parseInt(this.getNormalListColumnWidth(columnKey), 10);
        const minWidth = this.getColumnMinimumWidth(columnKey);
        const isRTL = this.isResizeRTL();
      
        const onMouseMove = (event) => {
          const dragDistance = isRTL
            ? startX - event.clientX
            : event.clientX - startX;
      
          const nextWidth = Math.max(
            minWidth,
            startWidth + dragDistance
          );
      
          this.$set(this.columnResizeWidths, columnKey, nextWidth);
        };
      
        const stopResize = () => {
          this.isResizingColumn = false;
          this.saveColumnResizeWidths();
      
          document.removeEventListener("mousemove", onMouseMove);
          document.removeEventListener("mouseup", stopResize);
        };
      
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", stopResize);
      },
      isResizeRTL() {
        const htmlDir = document.documentElement.getAttribute("dir");
        const bodyDir = document.body && document.body.getAttribute("dir");
        const componentDirection = this.$el
          ? window.getComputedStyle(this.$el).direction
          : "";
      
        return htmlDir === "rtl" || bodyDir === "rtl" || componentDirection === "rtl";
      },
      getResizableTableStyle() {
        const fixedColumns = ['preview', 'slugname', 'created_datetime', 'added_datetime', 'size'];
      
        let totalWidth = fixedColumns.reduce((total, columnId) => {
          const width = this.columnResizeWidths && this.columnResizeWidths[columnId]
            ? this.columnResizeWidths[columnId]
            : this.getDefaultListColumnWidths()[columnId];
      
          return total + width;
        }, 0);
      
        if (this.enabledMetadataColumns && this.enabledMetadataColumns.length) {
          this.enabledMetadataColumns.forEach((column) => {
            totalWidth += this.columnResizeWidths && this.columnResizeWidths[column._id]
              ? this.columnResizeWidths[column._id]
              : 160;
          });
        }
      
        return {
          width: `${totalWidth}px`,
          minWidth: `${totalWidth}px`,
          tableLayout: 'fixed'
        };
      },      
      
      getMinimumListColumnWidths() {
        return {
          preview: 105,
          slugname: 520, // fixed minimum: same as current width
          created_datetime: 115,
          added_datetime: 115,
          size: 85,
          metadata: 120
        };
      },
      
      getNormalListTableMinWidth() {
        const baseWidth =
          150 + // preview
          520 + // slugname
          150 + // date created
          150 + // date added
          120;  // size
      
        const metadataWidth = Array.isArray(this.enabledMetadataColumns)
          ? this.enabledMetadataColumns.reduce((total, column) => {
              return total + this.getColumnWidthNumber(column._id, 180);
            }, 0)
          : 0;
      
        return baseWidth + metadataWidth;
      },
      
      getColumnWidthNumber(columnKey, fallbackWidth) {
        let width = fallbackWidth;
      
        if (typeof this.getColumnWidth === "function") {
          const configuredWidth = this.getColumnWidth(columnKey, `${fallbackWidth}px`);
          const parsedWidth = parseInt(String(configuredWidth).replace("px", ""), 10);
      
          if (!Number.isNaN(parsedWidth) && parsedWidth > 0) {
            width = parsedWidth;
          }
        }
      
        return width;
      },
      
      getCatalogNormalTableMinWidth() {
        const defaultColumnsWidth =
          this.getColumnWidthInPx("preview", 110) +
          this.getColumnWidthInPx("slugname", 520) +
          this.getColumnWidthInPx("created_datetime", 150) +
          this.getColumnWidthInPx("added_datetime", 150) +
          this.getColumnWidthInPx("size", 115);
      
        const metadataColumnsWidth = Array.isArray(this.enabledMetadataColumns)
          ? this.enabledMetadataColumns.reduce((total, column) => {
              return total + this.getColumnWidthInPx(column._id, 180);
            }, 0)
          : 0;
      
        return defaultColumnsWidth + metadataColumnsWidth;
      },
      
      getColumnWidthInPx(columnKey, fallbackWidth) {
        let width = fallbackWidth;
      
        if (typeof this.getColumnWidth === "function") {
          const configuredWidth = this.getColumnWidth(columnKey, `${fallbackWidth}px`);
          const parsedWidth = parseInt(String(configuredWidth).replace("px", ""), 10);
      
          if (!Number.isNaN(parsedWidth) && parsedWidth > 0) {
            width = parsedWidth;
          }
        }
      
        return width;
      },
      getTableMinWidth() {
        const baseWidth = 120 + 420 + 150 + 150 + 120;
        const dynamicWidth = this.enabledMetadataColumns.length * 180;
      
        return `${baseWidth + dynamicWidth}px`;
      },
      getColumnWidth(columnKey, defaultWidth) {
        return this.columnWidths[columnKey] || defaultWidth;
      },
      
      resizeColumn(event) {
        if (!this.resizingColumnKey) return;
      
        const diff = event.clientX - this.resizeStartX;
        const newWidth = Math.max(90, this.resizeStartWidth + diff);
      
        this.$set(this.columnWidths, this.resizingColumnKey, `${newWidth}px`);
      },
      
      stopColumnResize() {
        this.resizingColumnKey = null;
        document.removeEventListener("mousemove", this.resizeColumn);
        document.removeEventListener("mouseup", this.stopColumnResize);
      },
      loadEnabledMetadataColumns() {
        try {
          const storedData = localStorage.getItem(METADATA_TABLE_COLUMNS_STORAGE_KEY);
          const parsedData = storedData ? JSON.parse(storedData) : [];
      
          this.enabledMetadataColumnIds = Array.isArray(parsedData) ? parsedData : [];
        } catch (e) {
          this.enabledMetadataColumnIds = [];
        }
      },

      isDockPanelOpen() {
        return this.getIsMetadataDockVisible || this.getIsAssetsDetailsPanelVisible;
      },

      handleColumnsUpdated(columnIds) {
        this.enabledMetadataColumnIds = [...columnIds];
      },
    
      resetContextMenuOptions(){
        this.showMoreSubMenu = false;
        this.showMoreSubMenu = false;
        this.showArchiveToSubMenu = false;
        this.showOpenWithToolSubmenu = false;
        this.showRetrieveFromSubmenu = false;
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        this.showShareSubmenu = false;
        this.showCatalogsIconSubmenu = false;
        this.showAIToolsSubmenu = false;
        this.showNewSubMenu = false;
        this.showImportSubMenu = false;
        this.showMenu = false;
      },
      playTranscriptFromSearchResults(transcriptInfo){
        this.transcriptSearchEntry=transcriptInfo;
        this.transcriptSearchEntry['state'] = 'playing';
        this.$emit("updateSearchedTranscriptSelection",transcriptInfo)
      },
      pauseTranscriptPlay(transcriptInfo){
        if(this.transcriptSearchEntry.uid == transcriptInfo.uid){
          this.transcriptSearchEntry['state'] = 'paused';
        }
        this.$emit("updateSearchedTranscriptSelection",this.transcriptSearchEntry, true)
      },
      getDurationFormatAsHHorMMSS(duration){
        return Utils.getDurationInHHorMMSS(duration / 1000);
      },
      getComponent(){
        return this;
      },
      lockRestrictedAction(actionName, fileInfo){
        return Utils.lockRestrictedAction(fileInfo, actionName, this.getActionListFromInMem, this.barcodeInfoFromStartup)
      },
      applyBorder(label){
        if(label && label.color){
          return {'border':'2px solid'+label.color+'!important','color':label.color}
        }
        return {'border':'2px solid #363636 !important','color':'EEE !important'}
      },
      applyBackground(label){
        if(label && label.color){
          return {'background':label.color+'!important','color':Utils.textColor(label.color)}
        }
        return {'background':'#363636 !important','color':Utils.textColor('EEE')}
      },
      updateDepartmentsFunc(){
        this.updateDepartments = true;
      },
        getColorBasedOnExpiry(locationInfo){
          if(Object.keys(locationInfo).includes('aws') && Object.keys(locationInfo.aws).includes('restoration_expiry_datetime')){
            let currentDate = new Date();
            // Create the given date (replace with your desired date)
            let givenDate = new Date(locationInfo.aws.restoration_expiry_datetime);
            // Compare the dates
            if (currentDate > givenDate) {
              return 'currentColor'
            } else {
              return '#28a745'
            }
          }
          return 'currentColor'
        },
          getFileMimeType(file){
            return Utils.getFileMediaType(file);
          },
          traverseToAIComp(compName){
            if (compName == 'ai_ocr'){
              this.submitOCRAction();
            }else if(compName == 'ai_obd'){
              this.submitOBDAction();
            }else if(compName == 'ai_face_detection'){
              this.submitFaceDetectionAction();
            }else if(compName == 'ai_transcript'){
              this.submitTranscript();
            }
          },
          getTranscriptHighlightContent(content){
            if(content && content.includes("\n")){
              content = content.replace("\n", "")
            }
              return content+'&nbsp;';
          },
          setRouterUrl(catalogId, catalogName, catalogType){
              this.closeOCBrowser();
              Utils.updateCookieByKeyName("context","catalogs-display");
              let query = {advanceFilter:JSON.stringify({fields:JSON.stringify({}), asset_id:this.selectedAssetId})}
              if(this.barcodeInfoFromStartup.enable_department){
                query = {advanceFilter:JSON.stringify({fields:{}, asset_id:this.selectedAssetId}), 'projects':'all', 'fromchild':true}
              }
              this.$router.push({
                  name: 'catalogs-display',
                  params:{
                      _id: catalogId, 
                      catalog_name: catalogName,
                      catalog_id: catalogId,
                      catalog_type:catalogType
                  },
                  query: query
              })
              this.$emit("openAdvancedSearch")
          },
          openAssetInCatalog(file){
              this.parentIPList = [];
              this.eOMenu = !this.eOMenu
              if(file.asset_type == "subclip" &&  "master_asset_id" in file &&
                 file.master_asset_id != undefined && file.master_asset_id.length > 0){
                  this.selectedAssetId = file.master_asset_id;
                  let payload = {params:{assetId: file.master_asset_id}}
                  this.getAssetInfoFromServer(payload).then((data) => {
                      if (data.statusCode==200){
                          let selectedAssetDetails = data["asset"];
                          if(selectedAssetDetails){
                            if("parent_id_path" in selectedAssetDetails &&
                                selectedAssetDetails.parent_id_path.length > 0){
                                    this.parentIPList = selectedAssetDetails.parent_path;
                                if(selectedAssetDetails.parent_id_path.length == 1){
                                    let pIPath = selectedAssetDetails.parent_id_path[0]
                                    let cIdList = pIPath.split("/");
                                    let catInfo = this.parentIPList[0];
                                    this.setRouterUrl(cIdList[cIdList.length - 1],catInfo[catInfo.catalog_name], selectedAssetDetails['catalog_type'])
                                }else{
                                    this.enableOICBrowse = true;
                                }
                            }
                          }else{
                            alert("Unable to open parent asset. ")
                            return
                          }
                      }else{
                          this.$toast.error(data.message);
                      }
                  })
              }else if("asset_id" in file && file.asset_id != undefined && file.asset_id.length > 0){
                  this.selectedAssetId = file.asset_id;
                  let payload = {params:{assetId: file.asset_id}}
                  this.getAssetInfoFromServer(payload).then((data) => {
                      if (data.statusCode==200){
                          let selectedAssetDetails = data["asset"];
                          if("parent_id_path" in selectedAssetDetails &&
                              selectedAssetDetails.parent_id_path.length > 0){
                                  this.parentIPList = selectedAssetDetails.parent_path;
                              if(selectedAssetDetails.parent_id_path.length == 1){
                                  let pIPath = selectedAssetDetails.parent_id_path[0]
                                  let cIdList = pIPath.split("/");
                                  let catInfo = this.parentIPList[0];
                                  this.setRouterUrl(cIdList[cIdList.length - 1],catInfo[catInfo.catalog_name], selectedAssetDetails.catalog_type)
                              }else{
                                  this.enableOICBrowse = true;
                              }
                          }
                      }else{
                          this.$toast.error(data.message);
                          this.eOMenu = !this.eOMenu
                      }
                  })
                }
          },
      setHeightOfTheTable(){
        if(this.$refs["top_nav_bar"] && this.$refs["top_nav_bar"].$el){
          let isTopNavBarVisible = this.$refs["top_nav_bar"].$el.clientHeight;
          if(isTopNavBarVisible){
            let addNumber = 50;
            if(this.barcodeInfoFromStartup.enable_department){
              addNumber = 100;
            }
            let heightCalc = isTopNavBarVisible + addNumber;
            return `height:calc(100% - ${heightCalc}px )`;
          }else{
            return `height:calc(100% - ${this.barcodeInfoFromStartup.enable_department?'150px':'100px'})`;
          }
        }
        return `height:calc(100% - ${this.barcodeInfoFromStartup.enable_department?'150px':'100px'})`;
      },
      loadTTLIcons(date){
        let timeNow = Math.floor(Date. now() / 1000);
        let ttlDateTime = new Date(date);
        ttlDateTime = Math.floor(ttlDateTime.getTime() / 1000);
  
        if(Math.floor((ttlDateTime - timeNow)/3600 <= 48 && (ttlDateTime - timeNow)/3600 >= 24)){
          return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#c7c700" class="bi bi-hourglass-split" viewBox="0 0 16 16">
                    <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                    <title>Expires in 2 days</title>
                  </svg>`
        }else if(Math.floor((ttlDateTime - timeNow)/3600 <= 24 && (ttlDateTime - timeNow)/3600 >= 0)){
          return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#f16d06" class="bi bi-hourglass-split" viewBox="0 0 16 16">
                    <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"/>
                    <title>Expries in 1 day</title>
                  </svg>`
        }else if(Math.floor((ttlDateTime - timeNow)/3600 < 0)){
          return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ff0000" class="bi bi-hourglass-bottom" viewBox="0 0 16 16">
                    <path d="M2 1.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1-.5-.5zm2.5.5v1a3.5 3.5 0 0 0 1.989 3.158c.533.256 1.011.791 1.011 1.491v.702s.18.149.5.149.5-.15.5-.15v-.7c0-.701.478-1.236 1.011-1.492A3.5 3.5 0 0 0 11.5 3V2h-7z"/>
                    <title>Expired</title>
                  </svg>`
        }else{
          return false;
        } 
      },
      selectAllFiles(event){
          if(event.target.checked){
            for(let i = 0; i< this.assetsList.length; i++){
              this.multiSelectElemet(this.assetsList[i], true);
            }
          }else{
              this.unselectElement();
              this.unselectAllFiles();
              this.deselectFileAndContextMenu();
          }
      },
      seeMoreDescription(id){
        if(!this.descriptionVisibilityArr.includes(id)){
          this.descriptionVisibilityArr.push(id)
        }
      },
      seeLessDescription(id){
        if(this.descriptionVisibilityArr.includes(id)){
          this.descriptionVisibilityArr = this.descriptionVisibilityArr.filter(e => e != id)
        }
      },
      getNormalizedParentPathItems(asset) {
        if (!asset || !asset.parent_path) {
          return [];
        }
      
        const parentPath = Array.isArray(asset.parent_path)
          ? asset.parent_path
          : [asset.parent_path];
      
        return parentPath
          .map((path) => {
            if (!path) {
              return null;
            }
      
            // Websocket format:
            // { catalog_name: "CATALOG", parent_path: { id: "...", value: "catalog://0" } }
            if (path.parent_path && typeof path.parent_path === "object") {
              return {
                id: path.parent_path.id || path.id || path._id,
                value: path.parent_path.value || path.value,
                catalog_name: path.catalog_name || path.name || ""
              };
            }
      
            // Existing API format:
            // { id: "...", value: "catalog://0/CATALOG" }
            return {
              id: path.id || path._id,
              value: path.value || path.name_path || path.catalog_path || "",
              catalog_name: path.catalog_name || path.name || ""
            };
          })
          .filter(Boolean);
      },

      shouldShowPaginationControls() {
        const total = Number(this.totalAssets || 0);
        const perPage = Number(this.assetsPerpage || this.perPage || 0);
      
        return total > 0 && perPage > 0 && total > perPage;
      },
      
      modifyTextFormat(pathInfo) {
        if (!pathInfo) {
          return "";
        }
      
        let value = "";
        let catalogName = "";
      
        if (typeof pathInfo === "object") {
          value = pathInfo.value || "";
          catalogName = pathInfo.catalog_name || pathInfo.name || "";
        } else {
          value = String(pathInfo);
        }
      
        value = String(value || "");
      
        // catalog://0/CATALOG/Davinci -> CATALOG/Davinci
        let displayValue = value
          .replace(/^catalog:\/\/0\/?/i, "")
          .replace(/^\/+/, "")
          .replace(/\/+/g, "/")
          .trim();
      
        // When websocket sends only catalog://0, use catalog_name as display text
        if (!displayValue && catalogName) {
          displayValue = catalogName;
        }
      
        return displayValue;
      },
      getParentPathText(asset) {
        const pathItems = this.getNormalizedParentPathItems(asset);
      
        if (!pathItems.length) {
          return "";
        }
      
        return pathItems
          .map((path) => this.modifyTextFormat(path))
          .filter((value) => value && value.trim())
          .join(" / ");
      },
      getCatalogCoverPhoto(catalog){
        if('catalog_cover_photo_path' in catalog){
          return Utils.convertToLoginIPDomainName(catalog.catalog_cover_photo_path)
        }
        return Utils.getNoThumbnailImg();
      },
      replaceByDefaultImage(e,fileInfo,forsvgThumbnail = ''){
          e.target.onerror = null
          if(fileInfo && fileInfo.mime_type && fileInfo.mime_type.startsWith('audio')){
              e.target.src = Utils.getAudioWaveformSvg();
              return;
          }
          try{
            if(forsvgThumbnail && forsvgThumbnail == 'FOR_SVG_THUMBNAIL'){
              let svgIcon = Utils.determineSvgIconForType(fileInfo);
              if(!svgIcon){ 
                e.target.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Utils.getDefaultUnknowIcon())}`;
              }else{
                 e.target.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgIcon)}`;
              }
              return;
            }
          }catch(err){console.log(err)}
          e.target.src = Utils.getNoThumbnailImg();
      },
      getPoolLabel(pool){
          return `${pool.pool_name}-(${pool.pool_owner})`
      },
      getSelectedMultipleFilesAsList(files){
        let selectedFilesPathsList = [];
        if (files){
            for (let i of Object.keys(files)){
              selectedFilesPathsList.push(files[i])
            }
        }
        return selectedFilesPathsList;
      },
      openSubclipWindow(selectedAssetDetails){
        this.selectedFileInfo = selectedAssetDetails;
        this.openTagMetadataModel  = 'sub-clips-manager-as-child';
        this.$router.push({
          name:"sub-clips-manager-as-child",
          params:{assetId: this.selectedFileInfo._id, fileInfo:Object.assign({}, this.selectedFileInfo),parentinfo:Object.assign({forceRedirect:true},this.$route)}
        })
        this.openSubclips = true;
      },
      openVideoTranscriptWindow(subclipInfo){
        this.selectedFileInfo = subclipInfo;
        this.openTagMetadataModel  = 'video-transcript-as-child';
        this.$router.push({
          name:"video-transcript-as-child",
          params:{assetId: this.selectedFileInfo._id, fileInfo:Object.assign({}, this.selectedFileInfo),parentinfo:Object.assign({forceRedirect:true},this.$route)}
        })
        this.openVideoTranscript = true;
      },
      handleAssetVersionUpdate(assetInfo){
        if(Object.keys(this.selectedFileInfo).length){
          let payload = {params:{}}
          payload.params.asset_id = this.selectedFileInfo.asset_id;
          payload.attach_file_ids = [assetInfo.file_uid];
          this.updateAssetVersionDetails(payload).then((data) => {
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
          });
        }
      },
      sortCatalogTable(option){
           this.sortBy = option;
           localStorage.setItem("catalogs_sort_by_value", JSON.stringify(option));
           this.refreshAssetsList(this.selectedCatalog);
      },
      updateFileStateFilter(statesArr){
        if(statesArr && Object.keys(statesArr).length){
          this.fileStateCheck = statesArr;
        }else{
          this.fileStateCheck = null;
        }
        this.refreshAssetsList(this.selectedCatalog);
      },
      downloadAssetsReport(){
        let assetIds = null;
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          assetIds = JSON.stringify([this.selectedFileInfo.asset_id]);
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          assetIds = JSON.stringify(Object.values(this.selectedFiles).map(obj => obj.asset_id));
        }
        if(assetIds && assetIds.length > 0){
          this.downloadAssetsReportFromServer({params:{asset_id: assetIds}}).then((data)=>{
            if('asset_report' in data && data.asset_report.length <= 0){
              this.$toast.info("No  data to download")
            }else if (Constants.acceptedStatusCodes.includes(data.statusCode)){
              this.$toast.info("You will be notified once the report is ready to download");
            }else{
              this.$toast.error(data.message);
            }
          })
        }else{
          alert("Please select valid files.")
        }
        this.unselectElement();
        this.unselectAllFiles();
        this.deselectFileAndContextMenu();
      },
      exportAssetstoOutbox(){
        let fileVersionIds = null;
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          fileVersionIds = [this.selectedFileInfo.version_id];
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          fileVersionIds = Object.values(this.selectedFiles).map(obj => obj.version_id);
        }
        if(fileVersionIds && fileVersionIds.length > 0){
          this.exportFilesToOutbox({params:{user_id:this.getLoggedInUserId}, add_file_version_ids:fileVersionIds}).then((data)=>{
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              if('message' in data){
                this.$toast.success(data.message);
              }else{
                this.$toast.success("Exported successfully")
              }
            } else {
                this.$toast.error(data.message);
            }
          })
        }else{
          alert("Please select valid files.")
        }
        this.unselectElement();
        this.unselectAllFiles();
        this.deselectFileAndContextMenu();
      },
      closeUserAddition(info){
        if(info && info.username){
          if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
            let payload = {params:{}}
            payload.params['fileId'] = this.selectedFileInfo.file_uid;
            payload['user_id'] = info._id;
            this.updateFileInfo(payload).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            })
          }else if(Object.keys(this.selectedFiles).length){
            for (const asset_id of Object.keys(this.selectedFiles)) {
              let payload = {params:{}}
              payload.params['fileId'] = this.selectedFiles[asset_id].file_uid;
              payload['user_id'] = info._id;
              this.updateFileInfo(payload).then((data)=>{
                if (data.statusCode == 200) {
                  this.$toast.success(data.message);
                } else {
                  this.$toast.error(data.message);
                }
              });
            }
          }
        }else{
          this.isMetadataManagerVisible=false;
          this.openTagMetadataModel = null;
        }
      },
      closeModal(){
          this.isMetadataManagerVisible=false;
          if (!this.vdialogComponents.includes(this.openTagMetadataModel)){
            if(this.ModalParentRoute){
                this.lastClosedDialogMap.modalName = this.$route.name;
                this.lastClosedDialogMap.isAssetUnselectRequired = this.determineUnselectOfAssets(this.$route);
              }
            this.$router.replace({
              name:this.ModalParentRoute.name,
              params: this.ModalParentRoute.params,
              query: this.ModalParentRoute.query
            })
            this.ModalParentRoute = {}
          }
          this.browseCoverPhoto = false;
          this.browseInPackage = false;
          this.openSubclips = false;
          this.openVideoTranscript = false;
          this.openTagMetadataModel = null;
          this.$emit('checkIfAdvancedSearchVisible');
      },
      closeSubclip(){
        this.openSubclips = false;
      },
      humaniseSize(file){
        if(file.size){
          let data = Utils.humanizeSize(file.size);
          return `${data["value"]} ${data["unit"]}`;
        }else{
          return '-'
        }
      },
      isProxyPresent(file){
         if(typeof file.proxy_info == 'object' && file.proxy_info && file.proxy_info.thumbnail_uri) return true;
         return false;
      },
      isSubclipMarkersPresent(file){
        if(typeof file.markers == 'object' && file.markers && file.markers.frame_thumbnail_uri) return true;
         return false;
      },
      getThumbnailPath(file,forsvgThumbnail = '') {
        try{
          if(forsvgThumbnail && forsvgThumbnail == 'FOR_SVG_THUMBNAIL'){
              if(!this.isProxyPresent(file) && !this.isSubclipMarkersPresent(file)){
                let svgIcon = Utils.determineSvgIconForType(file);
                if(!svgIcon) return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(Utils.getDefaultUnknowIcon())}`;
                return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgIcon)}`;
              }
          }
        }catch(err){console.log(err)}
        return Utils.getThumbnailPathfromFileInfo(file);
      },
      getHumanReadableDuration(duration){
        return Utils.getDurationInSeconds(duration)
      },
      is4K(fileWidth, fileHeight) {
        return fileWidth >= 3840 || fileHeight >= 3840
      },
      isFHD(fileWidth, fileHeight) {
        return fileWidth >= 1920 || fileHeight >= 1920
      },
      isHD(fileWidth, fileHeight) {
        return fileWidth >= 1280 || fileHeight >= 1280
      },
      isSD(fileWidth, fileHeight) {
        return fileWidth >= 720 || fileHeight >= 720
      },
      getReadableResolutionValue(file){
        let resKey = null
        let newClassName = null
        if('width' in file && 'height' in file){
          if(this.is4K(file.width, file.height)){
            newClassName = "res-fourK";
            resKey = "4K"
          }else if (this.isFHD(file.width, file.height)) {
            newClassName = "res-FHD"
            resKey = "FHD"
          }else if(this.isHD(file.width, file.height)){
            newClassName = "res-HD"
            resKey = "HD"
          }else if(this.isSD(file.width, file.height)){
            newClassName = "res-SD"
            resKey = "SD"
          }
          if(newClassName){
            this.$nextTick(()=>{
              let divId = "assetResolution_"+file["_id"];
              if(document.querySelector("#"+divId))document.querySelector("#"+divId).classList.add(newClassName)
            });
          }
        }
        if(!resKey && document.getElementById("assetResolution")){
          document.getElementById("assetResolution").remove()
        }
        return resKey
      },
      checkIfDisabled(file){
        if(file.mime_type && file.mime_type.startsWith('image')){
          if(this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().disable_resolution_display_for_image){
            return false;
          }
        }
        if(file.mime_type && file.mime_type.startsWith('video')){
          if(this.getStartUpDataFromInCache() && this.getStartUpDataFromInCache().disable_resolution_display_for_video){
            return false;
          }
        }
        return true;
      },
      getFileName(file) {
        return file.slug_name;
      },
      formatedDate(date){
        return Utils.getDateFormat(date);
      },
      formatedDateandTime(date){
        return Utils.getDateAndTimeFormat(date)
      },
      determineUnselectOfAssets(routeObj){
          let routeName = String(routeObj.name).trim();
          let dontUnselectAssetsOnList = ['properties','asset-properties','PAM-asset-metadata-manager',
           'asset-metadata-manager','asset-bulk-tagmetadata-manager','share','asset-move-catalog-manager',
           'sub-clips-manager','asset-new-review','asset-share-in-chat','asset-share-with-user','asset-share-via-email', 'asset-object-detection', 'file-object-detection',
           'asset-facedetection','asset-OBD', 'asset-OCR', 'asset-audio-transcript', 'asset-video-transcript','asset-image-annotation-with-comment','PAM-asset-properties','asset-livemedia-comment-review'
          ];
          let subclipReg = /sub-clips-manager/igm;
          if(subclipReg.test(routeName)){
             return false;
          }
          let partialRetriveReg = /partial(-?)retrieve/igm;
          if(partialRetriveReg.test(routeName)){
            return false;
          }
          if(routeObj && dontUnselectAssetsOnList.indexOf(routeName) > -1){
             return false
          } 
          return true;
      },
      scrollToTheSelectedFile(){
        let selector = '', wrapper = '', fileInfo = {};
        if(Object.keys(this.selectedFileInfo).length){
           fileInfo = this.selectedFileInfo;
        }else if(Object.keys(this.selectedFiles).length >= 1){
          fileInfo = Object.values(this.selectedFiles)[0];
        }
        if(this.viewType) {
            selector = `li[attr="${fileInfo._id}"]`;
            wrapper = '.assets-view-wrapper';
        }else{
           selector = `tr[attr="${fileInfo._id}"]`;
            wrapper = '.list-view-wrapper';
        }
        try{
          if(!this.lastClosedDialogMap.isAssetUnselectRequired && Object.keys(fileInfo).length){
            setTimeout(() => {
                Utils.scrollToElement(document.querySelector(selector),document.querySelector(wrapper));
            },0);
          }
        }catch(e){console.log(e)}
        this.lastClosedDialogMap.isAssetUnselectRequired = true;
        return true;
      },
      isEnabled(priv) {
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
      },
      isFileActionEnabled(userAction, filePermission){
        let binFilesActionsList = this.getRegisteredBinsContextMenu();
        let indx = binFilesActionsList.findIndex(
          (op) =>
            (op.action_name == userAction &&
              (op.requiredPermissions.includes(filePermission)))
        );
        if(indx < 0){
          return false
        }else{
          return true
        }
      },
      getLabelForAction(actionName){
        let allPriv = []
        for (let priv of  Object.values(this.getPrivilegeFromInMem())) {
          Array.prototype.push.apply(allPriv, priv)   
        }
        let label = allPriv.filter((action)=>action.action_name == actionName) 
        return label.length !=0?label[0].label:actionName
      },
      paginate(page){
        if (page){
          this.deselectFileAndContextMenu(null,true);
          this.currentPage = page;
          //this.page = page
          // this.totalPages = -1
          // this.totalAssets = -1
          // this.perPage = -1
          // this.assetsPerpage = -1
          this.unselectElement();
          this.unselectAllFiles();
          this.$emit("hideMiniPlayerOnContextMenuDeselect")
          let query = Object.assign({},this.$route.query)
          query.page = this.currentPage
          this.$router.push({
            "query": query
          })
        }
      },
      updatePerPageValue(perPageVal){
        this.perPage = perPageVal;
        this.refreshAssetsList();
      },
  
      unselectAllFiles(){
        this.selectedFiles = {}
        this.allFilesSelected = false;
        this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles));
        this.dragSelected = false
      },
      getFileInfoByAssetIdFromInMem(asset_id){
        let fileinfo = this.assetsList.filter((file_)=>file_._id==asset_id);
        if(fileinfo.length != 0){
            return fileinfo[0]
        }
      
        return {}
      },
      changeCatalog(catalogInfo){
        this.unselectAllFiles()
        if(this.workspace && this.workspace == 'Projects'){
            let currentRoute = this.$route;
            this.$router.push({
                name:"assets-projects", 
                params:{
                  _id: catalogInfo._id, 
                  pid: catalogInfo.pid,
                  file_name: catalogInfo.catalog_name,
                  catalog_name: catalogInfo.catalog_name,
                  catalog_id:catalogInfo._id,
                  permissions:catalogInfo.permissions,
                  catalog_type:catalogInfo.catalog_type,
                  asset_state:catalogInfo.asset_state
                },
                query:{
                  project_id:currentRoute.params.projectId
                }
              }
            )
          }else{
            this.$router.push({
              name:"catalogs-display", 
              params:{
                _id: catalogInfo._id, 
                pid: catalogInfo.pid,
                file_name: catalogInfo.catalog_name,
                catalog_name: catalogInfo.catalog_name,
                catalog_id:catalogInfo._id,
                permissions:catalogInfo.permissions,
                catalog_type:catalogInfo.catalog_type,
                asset_state:catalogInfo.asset_state
                }
              }
            )
          }
        this.$emit("clearSearchData");
        this.searchKeyword = null;
      },
      dragSelect(event){
        if (event.length<=1){
          return
        }
        const clearSelection = ()=>{
          if(window.getSelection) {
            window.getSelection().removeAllRanges();
          } else if (document.selection) { // legacy IE
            document.selection.empty();
          }
        }
        clearSelection();
        if(event && event.length>= 1)
           this.unselectElement();
        let assetIdlist = [].concat(event)
        this.unselectAllFiles()
        for (const assetId of assetIdlist) {
          let fileInfo = this.getFileInfoByAssetIdFromInMem(assetId)
          if (Object.keys(fileInfo).length !=0){
            this.selectedFiles[fileInfo._id] = fileInfo 
            this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles));
            this.dragSelected = true
          }
        }
      },
      isFileSelected(fileInfo){
        if(!Object.keys(fileInfo).includes("_id")){
          return false;
        }
        if(Object.keys(this.selectedFiles).length == 0 && Object.keys(this.selectedFileInfo).length == 0){
          return false;
        }
        if (fileInfo._id in this.selectedFiles){
          return true
        }
        return this.isActive == fileInfo._id
      },
      multiSelectElemet(fileInfo, checkedSelectAll = false){
        if (!checkedSelectAll && this.selectedFiles[fileInfo._id]){
            delete this.selectedFiles[fileInfo._id]
            this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles));
            return true;
        }
  /*       if (Object.keys(this.selectedFileInfo).length !=0){
          this.selectedFiles[fileInfo._id] = fileInfo
        }
        if (fileInfo._id in this.selectedFiles){
          delete this.selectedFiles[fileInfo._id]
          this.$emit("selectedMultipleFiles", {})
        }else{
          this.selectedFiles[fileInfo._id] = fileInfo
          this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles))
        } */
        if (Object.keys(this.selectedFileInfo).length != 0){
          this.selectedFiles[fileInfo._id] = fileInfo;
          this.selectedFiles[this.selectedFileInfo._id] = this.selectedFileInfo;
        }
        this.selectedFiles[fileInfo._id] = fileInfo;
        this.$emit("selectedMultipleFiles", Object.assign({},this.selectedFiles))
        if(Object.keys(this.selectedFiles) <= 1 && this.eOMenu){
          this.eOMenu = false;
        }
        if((Object.keys(this.selectedFiles) <= 1|| Object.keys(this.selectedFileInfo).length ) && this.eOMenu){
          this.eOMenu = false;
        }
      },
      preventSubMenuDisplay(){
          this.closeSubmenu();
      },
      openProperties() {
        this.ModalParentRoute = Object.assign({}, this.$route)
        // let name = "asset-properties"
        // if(this.workspace == 'Projects'){
        //   name = "PAM-asset-properties"
        // }
        let name = this.workspace && this.workspace == 'Projects'?'PAM-asset-properties':"asset-properties"
        let params = {assetId:this.selectedFileInfo.asset_id?this.selectedFileInfo.asset_id:this.$route.params.assetId, fileInfo:this.selectedFileInfo,parentinfo:this.$route}
        if(this.workspace && this.workspace == 'Projects'){
          params['projectId'] = this.$route.params.projectId;
        }
        this.$router.push({
          name:name,
          params:params
        })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "properties";
      },
      openShareInChat(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-share-in-chat",
        })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "share-in-chat";
      }, 
      closeSubmenu() {
        this.showMoreSubMenu = false;
        this.showNewSubMenu = false;
        this.showImportSubMenu = false;
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        this.showArchiveToSubMenu = false;
        this.showRetrieveFromSubmenu = false;
        this.showShareSubmenu = false;
        this.showAIToolsSubmenu = false;
        this.showCatalogsIconSubmenu = false;
      },
      showSubmenu(item, event) {
        if (item.sub_menu != undefined && item.sub_menu != "DEFAULT") {
          this.getEventHandler(item, "onClick", item.onEvents, true, true)(event);
        } else {
          this.closeSubmenu();
        }
      },
      getMediaTypeIcons(item){
        if (item.startsWith("audio"))return Utils.getAudioPlayIcon();
        if (item.startsWith("video"))return Utils.getVideoPlayIcon();
        if (item.startsWith("image"))return Utils.getImageIcon();
      },

      setHeightOfMetadataView(){
        return `height:calc(100% - ${this.barcodeInfoFromStartup.enable_department?'52px':'00px'})`;
      },

      selectElement(event, fileInfo, showInfo=true, metadataView=false){
        if (event != null){
          event.stopImmediatePropagation()
        }
        // this.closeContextMenu()
        this.unselectAllFiles()
        this.isActive = fileInfo._id
        this.selectedFileInfo = fileInfo;
        this.$emit("selectedSingleFile", Object.assign({},this.selectedFileInfo), this.transcriptSearchEntry);
        if (showInfo) {
          let metadata = this.getIsMetadataDockVisible;
          let assetsInfo = this.getIsAssetsDetailsPanelVisible;
          let miniPlayer = this.getisMiniplayerVisible
        
          if(metadata || assetsInfo || miniPlayer || metadataView){
            this.refreshFileInfoAndShowAsset(fileInfo._id,null, false, this.transcriptSearchEntry,true);
          }
        }
      },
      showAssetDetails(file) {
        this.$emit("PreviewAsset",Object.assign({},file))
        this.closeContextMenu()
        this.selectElement(null,file)
        this.refreshFileInfoAndShowAsset(file._id, null,false,this.transcriptSearchEntry);
      },
      unselectElement(){
        this.isActive = null
        this.selectedInfo = {}
        this.selectedFileInfo ={}
        this.transcriptSearchEntry = null
        this.$emit("selectedSingleFile", Object.assign({},this.selectedFileInfo));
      },
      deselectFileAndContextMenu(event=null,hardReload=null){
        // if clicked on contextmenu item then don't proceed further to diselect element
          if(this.$parent.$refs.globalButtonDropdown){
            this.$parent.$refs.globalButtonDropdown.classList.remove('show')
          }
  
          if(!event){
            return;
          }
          this.allFilesSelected = false;
          try{
            if(event && event.target && event.target.closest('.v-dialog__content.v-dialog__content--active')) return true;
          }catch(e){console.log(e)}
          try{
            if(event && event.target && event.target.closest('.modal')) return true;
          }catch(e){console.log(e)}
          try{
            if(event && event.target.closest('.v-list-item') && event.target.closest('.v-list-item').getAttribute('role') == 'menuitem') return true;
          }catch(e){console.log(e)}  

          try{
             if(event && event.target.getAttribute('name') === 'drag-select-container') return true;
          }catch(e){console.log(e)}

          try{
             if(event && event.target.closest('.tabletable-with-border.metadata-config-table')) return true;
          }catch(e){console.log(e)}
  
          if (hardReload){
              event = {ctrlKey: false}
          }
        if (this.dragSelected){
              this.dragSelected = false
              return
        }
  
        if (event){
            try{
              event.stopImmediatePropagation()
            }catch(error){
              console.log("error",error)
           }
          if(this.viewType == true && !(event.ctrlKey)){
              this.unselectAllFiles();
              this.$emit("hideMiniPlayerOnContextMenuDeselect")
            }
            else if(!(event.ctrlKey)){
              this.unselectAllFiles();
            }
         }
        this.allFilesSelected = false;
        this.closeContextMenu()
        this.unselectElement()
      },
      closeContextMenu() {
        this.eOMenu = false;
        this.showMenu = false;
        this.showMoreSubMenu = false;
        this.showNewSubMenu = false;
        this.showImportSubMenu = false;
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        this.showShareSubmenu = false
        this.showAIToolsSubmenu = false;
        this.showCatalogsIconSubmenu = false;
        this.x = 0;
        this.y = 0;
        this.submenuNewX = 0;
        this.submenuImportX = 0;
        this.submenuX = 0;
        this.submenuNewY = 0;
        this.submenuImportY = 0;
        this.submenuY = 0;
        this.contextMenuItems = [];
        this.subMenuItems = [];
        this.subMenuNewItems = [];
        this.subMenuImportItems = [];
      },
      submitUploadAction() {
        this.fileUploadAction(false);
        this.eOMenu = false;
      },
      fileUploadAction(newVersion){
        if(Object.keys(this.getStartUpDataFromInCache()).includes("upload_settings")){
          let query = {
            path: this.getStartUpDataFromInCache()["upload_settings"][0].upload_path, 
            newVersion:newVersion?newVersion:false,
            catalog_id:this.$route.params.catalog_id
            }
          if (Object.keys(this.selectedFileInfo).length!=0 && Object.keys(this.selectedFiles).length ==0){
            Object.assign(query, {parentfileUid: this.selectedFileInfo.file_uid})
          }
          this.$router.push({
            name: "upload",
            params:{
              parentinfo: this.$route,
            },
            query:query
          })
        }
      },
      uploadAssetNewVersion(){
        this.fileUploadAction(true);
        this.eOMenu = false;
      },
      updateAssetNewVersion(){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "files-browser";
        this.eOMenu = false;
      },
      archiveto(pool_id){
          let payload = {};
        if(Object.keys(this.selectedFileInfo).length){
        payload.bin_id = this.selectedFileInfo.bin_id;
        payload.file_name = this.selectedFileInfo.file_name;
        payload.path = this.selectedFileInfo.path;
        payload.element_type = "file";
        payload.job_name = "Archive";
        payload.file_uid = this.selectedFileInfo.file_uid;
        payload.pool_id = pool_id
        this.createNewJob(payload).then((data) => {
          if (data.statusCode == 200) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });
        }else{
          for (const asset_id of Object.keys(this.selectedFiles)) {
            payload.bin_id = this.selectedFiles[asset_id].bin_id;
            payload.file_name = this.selectedFiles[asset_id].file_name;
            payload.path = this.selectedFiles[asset_id].path;
            payload.element_type = "file";
            payload.job_name = "Archive";
            payload.file_uid = this.selectedFiles[asset_id].file_uid;
            payload.pool_id = pool_id
            this.createNewJob(payload).then((data) => {
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            });
          }
        }
      },
      submitArchiveAction(){
        let postData = (fileInfo) => {
            let payload = {};
            payload.bin_id = fileInfo.bin_id;
            payload.element_type = "file";
            payload.job_name = "Archive";
            payload.file_name = fileInfo.file_name;
            payload.path = fileInfo.path;
            payload.file_uid = fileInfo.file_uid;
            // payload.pool_id = this.getDefaultPoolfromInMem.pool_id
            this.createNewJob(payload).then((data) => {
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            });
        }
  
         if(Object.keys(this.selectedFileInfo).length){
             postData(this.selectedFileInfo);
         }else{
            for(let _id in this.selectedFiles){
              if(this.selectedFiles[_id].asset_type == 'subclip' && ((this.selectedFiles[_id].subclip_type && this.selectedFiles[_id].subclip_type == 'soft') || !this.selectedFiles[_id].subclip_type)){
                continue;
              }
                postData(this.selectedFiles[_id])
            }
         }
  
      },

      style(name){
          let style = {
              'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
              'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
          }
      return style
      },

      getDisplayDataOfUserUsingId(userId){
        return Utils.getDisplayDataOfUser(userId, this.getUsersBasicInfoFromStore);
      },
  
      submitFolderArchiveAction(){
        let postData = (fileInfo) => {
          let payload = {};
          payload.element_type = "file";
          payload.job_name = "Folder Archive";
          payload.file_uid = fileInfo.file_uid;
          this.createNewJob(payload).then((data) => {
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          });
        }
        if(Object.keys(this.selectedFileInfo).length){
            postData(this.selectedFileInfo);
        }else{
            for(let _id in this.selectedFiles){
                postData(this.selectedFiles[_id])
            }
        }
      },
  
      uploadSvgIconAsCover(icon){
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          let payload = {params:{_id:this.selectedFileInfo._id},catalog_cover_photo_file_uid:'svg-'+icon}
          this.updatePhotoAlbum(payload).then((data)=>{
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          })
        }
        this.closeModal();
      },
      retrieveFrom(pool_id){
        let payload = {};
        if(Object.keys(this.selectedFileInfo).length){
        payload.bin_id = this.selectedFileInfo.bin_id;
        payload.file_name = this.selectedFileInfo.file_name;
        payload.path = this.selectedFileInfo.path;
        payload.element_type = "file";
        payload.job_name = "Retrieve";
        payload.file_uid = this.selectedFileInfo.file_uid;
        payload.pool_id = pool_id
        this.createNewJob(payload).then((data) => {
          console.log(" retrieveFrom : resp keys ",Object.keys(data) )
          if (data.statusCode == 200) {
            this.$toast.success("Retrieve job submitted");
          } else {
            this.$toast.error(data.message);
          }
        });
        }else{
          let postedJobs = []
          for (const asset_id of Object.keys(this.selectedFiles)) {
            payload.bin_id = this.selectedFiles[asset_id].bin_id;
            payload.file_name = this.selectedFiles[asset_id].file_name;
            payload.path = this.selectedFiles[asset_id].path;
            payload.element_type = "file";
            payload.job_name = "Retrieve";
            payload.file_uid = this.selectedFiles[asset_id].file_uid;
            payload.pool_id = pool_id;
            let jobsPostPromise = this.createNewJob(payload)
            jobsPostPromise.file_name = this.selectedFiles[asset_id].file_name;
            postedJobs.push(jobsPostPromise)
          }
          Promise.all(postedJobs).then(allJobsList=>{
              let failedEntries = []
              let retrievedEntries = []
              for(let i=0; i<allJobsList.length ; i++){
                let eachJob  = allJobsList[i]
                if (eachJob.statusCode == 200) {
                  retrievedEntries.push(eachJob)
                } else {
                  failedEntries.push(eachJob.message)
                }
              }
              if(retrievedEntries && retrievedEntries.length > 0){
                this.$toast.success("Retrieve job submitted");
              }
              if(failedEntries && failedEntries.length > 0){
                if(failedEntries.length == 1){
                  this.$toast.error(`Failed to retrieve ${failedEntries[0]}.`)
                }else{
                  this.$toast.error(`${failedEntries[0]} \n + Failed to retrieve  ${failedEntries.length-1} More files`);
                }
              }
          })
        }  
      },
      getPoolByPriority(){
          for (const device of Object.values(this.getPoolDevicesfromInMem()).sort((a,b)=>a.priority-b.priority) ){
              let selected_pool = Object.values(this.getPoolsfromInMem()).filter((pool)=>pool.pool_owner==device.device_id)
              if (selected_pool.length){
                  return selected_pool[0]
              }
          }
          return this.getDefaultPoolfromInMem
      },
      submitFolderRetrieveAction(){
        if(Object.keys(this.selectedFileInfo).length <= 0){
          alert("Please select valid catalog to retrieve.")
          return
        }
        let payload = {
                      job_name:"Folder Retrieve",
                      id_path:this.selectedFileInfo['parent_id_path'][0]+"/"+this.selectedFileInfo._id,
                      element_type:"file"}
        this.createNewJob(payload).then((data) => {
          if (data.statusCode == 200) {
            if('message' in data){
              this.$toast.success(data.message);
            }else{
              this.$toast.success('Folder retrieve action submitted');
            }
          } else {
            this.$toast.error(data.message);
          }
        });
      },
      submitRetrieveAction(){
        let postedJobs = []
        let postData = (fileInfo) => {
            let payload = {};
            payload.bin_id = fileInfo.bin_id;
            payload.element_type = "file";
            payload.job_name = "Retrieve";
            payload.file_name = fileInfo.file_name;
            payload.path = fileInfo.path;
            payload.file_uid = fileInfo.file_uid;
            payload.pool_id = this.getPoolByPriority().pool_id
            let jobsPostPromise = this.createNewJob(payload)
            jobsPostPromise.file_name = fileInfo.file_name
            postedJobs.push(jobsPostPromise)
        }
        this.eOMenu = false;
  
        if(Object.keys(this.selectedFileInfo).length){
             postData(this.selectedFileInfo);
         }else{
            for(let _id in this.selectedFiles){
              if(this.selectedFiles[_id].asset_type == 'subclip' && ((this.selectedFiles[_id].subclip_type && this.selectedFiles[_id].subclip_type == 'soft') || !this.selectedFiles[_id].subclip_type)){
                  continue;
                }
                postData(this.selectedFiles[_id])
            }
         }
         Promise.all(postedJobs).then(allJobsList=>{
              let failedEntries = []
              let retrievedEntries = []
              for(let i=0; i<allJobsList.length ; i++){
                let eachJob  = allJobsList[i]
                if (eachJob.statusCode == 200) {
                  retrievedEntries.push(eachJob)
                } else {
                  failedEntries.push(eachJob.message)
                }
              }
              if(retrievedEntries && retrievedEntries.length > 0){
                this.$toast.success("Retrieve job submitted");
              }
              if(failedEntries && failedEntries.length > 0){
                if(failedEntries.length == 1){
                  this.$toast.error(`Failed to retrieve ${failedEntries[0]}.`)
                }else{
                  this.$toast.error(`${failedEntries[0]} \n + Failed to retrieve ${failedEntries.length-1} More files.`);
                }
              }
            })
      },
      lockOrUnlockAssets(lockState=false){
        let selectedAssetIdList = []
        if(Object.keys(this.selectedFileInfo).length){
          selectedAssetIdList.push(this.selectedFileInfo.asset_id);
        }else{
          for(let _id in this.selectedFiles){
            if(this.selectedFiles[_id].asset_type == 'subclip'){
              continue;
            }
            selectedAssetIdList.push(this.selectedFiles[_id].asset_id);
          }
        }
        let payload = {asset_id:selectedAssetIdList,element_type: "assets",job_name: "Lock/Unlock",asset_lock: lockState}
        this.createNewJob(payload).then((data) => {
          if (data.statusCode == 200) {
            this.$toast.success("Job submitted successfully");
          } else {
            this.$toast.error(data.message);
          }
        });
      },
      lockSelectedAsset(){
        this.lockOrUnlockAssets(true)
      },
      unlockSelectedAsset(){
        this.lockOrUnlockAssets()
      },
      postJob(payload){
        this.createNewJob(payload).then((data) => {
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message);
        }
        });
      },
      handleMarkForDeleteEvents(){
        let postData = (fileInfo) => {
            let payload = {};
            payload.file_type = fileInfo.asset_type
            payload.parent_id_path = fileInfo.parent_id_path
            payload.element_type = "file";
            payload.job_name = "Mark For Delete";
            payload.from_context = "catalog";
            payload.resource_name = fileInfo.file_name || fileInfo.catalog_name;
            payload.size = fileInfo.size;
            payload.file_uid = fileInfo.file_uid;
            payload.version_id = fileInfo.latest_version_id;
            payload.asset_id = fileInfo.asset_id;
            payload._id = fileInfo._id;
            payload.catalog_id = this.selectedCatalog._id;
            this.postJob(payload)
        }
  
        if(Object.keys(this.selectedFileInfo).length){
          postData(this.selectedFileInfo);
        }else{
          for(let _id in this.selectedFiles)
            postData(this.selectedFiles[_id])
        }
        this.eOMenu = false;
      },
      handleRestore(){
        let postData = (fileInfo) => {
            let payload = {};
            payload.file_type = fileInfo.asset_type
            payload.parent_id_path = fileInfo.parent_id_path
            payload.element_type = "file";
            payload.job_name = "Restore";
            payload.from_context = "catalog";
            payload.resource_name = fileInfo.file_name || fileInfo.catalog_name;
            payload.size = fileInfo.size;
            payload.file_uid = fileInfo.file_uid;
            payload.version_id = fileInfo.latest_version_id;
            payload.asset_id = fileInfo._id;
            this.createNewJob(payload).then((data) => {
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            });
        }
        if(Object.keys(this.selectedFileInfo).length){
             postData(this.selectedFileInfo);
         }else{
            for(let _id in this.selectedFiles)
                postData(this.selectedFiles[_id])
         }
        this.eOMenu = false;
      },
      handleDeletePermanently(){
        let postData = (fileInfo) => {
            let payload = {};
            payload.file_type = fileInfo.asset_type
            payload.parent_id_path = fileInfo.parent_id_path
            payload.element_type = "file";
            payload.job_name = "Delete Permanently";
            payload.from_context = "catalog";
            payload.resource_name = fileInfo.slug_name || fileInfo.catalog_name;
            payload.size = fileInfo.size;
            payload.file_uid = fileInfo.file_uid;
            payload.version_id = fileInfo.latest_version_id;
            payload.asset_id = fileInfo._id;
            payload.catalog_id = this.selectedCatalog._id;
            this.postJob(payload)
        }
  
        if(Object.keys(this.selectedFileInfo).length){
          let message = "Are you sure you want to delete selected asset "+ (this.selectedFileInfo.slug_name || this.selectedFileInfo.catalog_name) +" permanently?"
          // if (Object.keys(this.selectedFileInfo).includes('archived') && this.selectedFileInfo.archived == true){
            // message = "Are you sure you want to delete selected asset "+ (this.selectedFileInfo.file_name || this.selectedFileInfo.catalog_name) +" and their associated archived files permanently?"
          // }
          if(confirm(message)){
            postData(this.selectedFileInfo)
          }
        }else{
          let message = "Are you sure you want to delete "+ Object.keys(this.selectedFiles).length +" selected assets permanently?"
          // let archivedFiles = Object.values(this.selectedFiles).map(item => item.archived == true)
          // if (archivedFiles && archivedFiles.includes(true)){
            // message = "Are you sure you want to delete selected assets and their associated archived files permanently?"
          // }
          if(confirm(message)){
            for(let _id in this.selectedFiles)
              postData(this.selectedFiles[_id])
          }
        }
        this.eOMenu = false;
      },
      handleForceDeletePermanently(){
        let postData = (fileInfo) => {
            let payload = {};
            payload.file_type = fileInfo.asset_type
            payload.parent_id_path = fileInfo.parent_id_path
            payload.element_type = "file";
            payload.job_name = "Force Delete Permanently";
            payload.from_context = "catalog";
            payload.resource_name = fileInfo.slug_name || fileInfo.catalog_name;
            payload.size = fileInfo.size;
            payload.file_uid = fileInfo.file_uid;
            payload.version_id = fileInfo.latest_version_id;
            payload.asset_id = fileInfo._id;
            payload.catalog_id = this.selectedCatalog._id;
            this.postJob(payload)
        }
        
        if(Object.keys(this.selectedFileInfo).length){
          let message = "Are you sure you want to delete selected asset "+ (this.selectedFileInfo.slug_name || this.selectedFileInfo.catalog_name) +" permanently?"
          // if (Object.keys(this.selectedFileInfo).includes('archived') && this.selectedFileInfo.archived == true){
            // message = "Are you sure you want to delete selected asset "+ (this.selectedFileInfo.file_name || this.selectedFileInfo.catalog_name) +" and their associated archived files permanently?"
          // }
          if(confirm(message)){
            postData(this.selectedFileInfo)
          }
        }else{
          let message = "Are you sure you want to delete "+ Object.keys(this.selectedFiles).length +" selected assets permanently?"
          // let archivedFiles = Object.values(this.selectedFiles).map(item => item.archived == true)
          // if (archivedFiles && archivedFiles.includes(true)){
            // message = "Are you sure you want to delete selected assets and their associated archived files permanently?"
          // }
          if(confirm(message)){
            for(let _id in this.selectedFiles)
              postData(this.selectedFiles[_id])
          }
        }
        this.eOMenu = false;
      },
      submitPartialRetrieveAction(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-PartialRetrieve",
          params:{fileInfo:Object.keys(this.selectedFileInfo).length?this.selectedFileInfo:this.selectedFiles,isMultipleFilesSelected:this.selectedFiles & Object.keys(this.selectedFiles).length?true:false,parentinfo:this.$route}
        })
        this.openTagMetadataModel = 'asset-PartialRetrieve';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
      submitPartialRetrieveActionFromMetadataDock(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"PartialRetrieve-from-metadata-dock",
          params:{fileInfo:Object.keys(this.selectedFileInfo).length?this.selectedFileInfo:this.selectedFiles,isMultipleFilesSelected:this.selectedFiles & Object.keys(this.selectedFiles).length?true:false,parentinfo:this.$route}
        })
        this.openTagMetadataModel = 'PartialRetrieve-from-metadata-dock';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
      submitSubclipTranscript(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"metadata-dock-video-transcript-manager",
          params:{fileInfo:Object.keys(this.selectedFileInfo).length?this.selectedFileInfo:this.selectedFiles,isMultipleFilesSelected:this.selectedFiles & Object.keys(this.selectedFiles).length?true:false,parentinfo:this.$route}
        })
        this.openTagMetadataModel = "metadata-dock-video-transcript-manager"
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
      submitOCRAction(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-OCR",
        })
        this.openTagMetadataModel = 'OCR';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
      submitFaceDetectionAction(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-facedetection",
        })
        this.openTagMetadataModel = 'facedetection';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },  
      submitTranscript(){
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length){
          if(this.selectedFileInfo.mime_type.startsWith("video/")){
            this.ModalParentRoute = Object.assign({}, this.$route)
            this.$router.push({
              name:"asset-video-transcript",
            })
            this.openTagMetadataModel = 'VideoTranscript';
            this.isMetadataManagerVisible = true;
            this.eOMenu = false;
          }else if(this.selectedFileInfo.mime_type.startsWith("audio/")){
            this.ModalParentRoute = Object.assign({}, this.$route)
            this.$router.push({
              name:"asset-audio-transcript",
            })
            this.openTagMetadataModel = 'AudioTranscript';
            this.isMetadataManagerVisible = true;
            this.eOMenu = false;
          }
        }
      },
      async handleDownloadAction(file, downloadProxy=false){
        if(this.selectedFiles && Object.keys(this.selectedFiles).length){
          let filesList = Object.values(this.selectedFiles).map(file => ({...file,download_proxy: downloadProxy}));
          this.setDownloadFilesArr({key:Utils.getUUID(),value:filesList})
        }else{
          let payload = {};
          let fileName = file.slug_name;
          if(file.asset_type && file.asset_type == "subclip"){
              let that = this;
              let myPromise = new Promise(function(resolve) {
              let payloadTemp = {params:{assetId: file.master_asset_id}}
              that.getAssetInfoFromServer(payloadTemp).then((data) => {
                if(data["asset"]){
                  resolve(data["asset"]);
                }
              })
            });
            let parentInfo = await myPromise;
            payload.bin_id = parentInfo.bin_id;
            payload.path = parentInfo.path;
            payload.file_name = parentInfo.file_name;
            fileName = parentInfo.slug_name;
          }else{
            payload.bin_id = file.bin_id;
            payload.path = file.path;
            payload.file_name = file.file_name;
          }
          payload.element_type = "file";
          if(downloadProxy){
            payload.job_name = "Download Proxy"
          }else{
            payload.job_name = "Download";
          }
          // let fileMimeType = file.mime_type;
          this.initiateDownloadJob(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              let jobIdFromResponse = data.job_id;
              let jobFileName = data.file_name;
              let payload = {};
              payload = { job_id: "job_id=" + jobIdFromResponse };
              
              /*        this.downloadFile(payload).then((data) => {
                const blob = new Blob([data], {
                  type: fileMimeType,
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
              }); */
  
              /*         let iframe = document.createElement('iframe');
              iframe.style.display = "none";
              iframe.src = downnloadUrl;
              document.body.appendChild(iframe); */
  
              const link = document.createElement("a");
              if(downloadProxy){
                link.href = `${Constants.downloadProxyUrl}?${payload.job_id}`;
                link.download = jobFileName;
              }else{
                link.href = `${Constants.downloadUrl}?${payload.job_id}`;
                link.download = fileName;
              }
              link.click(); 
              
              console.log("Download initiated");
            } else {
              this.$toast.error(data.message);
            }
          });
        }
        this.eOMenu = false;
      },
      copyAssetURL(){
        this.setClipBoardText(this.selectedFileInfo);
        this.eOMenu = false;
      },
      setClipBoardText(file){
        let copiedLink = ""
        if(Object.keys(file).length && "access_url" in file){
          copiedLink = file.access_url;
        }
        if(copiedLink.trim().length <= 0){
          alert("Link is not avaialble.");
        }else{
          navigator.clipboard.writeText(copiedLink);
        }
        this.eOMenu = !this.eOMenu;
      },
      submitDownloadAction(){
        this.handleDownloadAction(this.selectedFileInfo);
        this.eOMenu = false;
      },
      submitDownloadProxyAction(){
        this.handleDownloadAction(this.selectedFileInfo, true);
        this.eOMenu = false;
      },
      handlePreviewAction(){
        let newUrl = new URL(`/assets/${this.selectedFileInfo._id}/view`, location.href);
        window.open(newUrl,'_blank');
        this.eOMenu = false;
      },
      createFolderAction(){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "create-folder";
      },
      editCatalogAction(){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "edit-catalog";
        this.eOMenu = false;
      }, 
      imageAnnotationAction(){
        this.ModalParentRoute = Object.assign({}, this.$route);
          let annotationData = {thumbnail:'',asset:{}};
          annotationData.asset = this.selectedFileInfo;
          annotationData.thumbnail = Utils.convertToLoginIPDomainName(this.selectedFileInfo.proxy_info.thumbnail_uri);
          this.$router.push({
            name:"asset-image-annotation-with-comment",
            params:{
              id:this.selectedFileInfo.asset_id,
              annotationData:annotationData,
              parentinfo: this.$route,
            }
          })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "asset-image-annotation-with-comment";
        this.eOMenu = false;
      },
      manageMediaVersion(){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = 'manage-version';
        this.eOMenu = false;
      },  
      modifyTTLAction(){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "modify-ttl";
        this.eOMenu = false;
      },
      async findTheFileInfoFromAssetsList(){
        if(this.$route.params && this.$route.params.assetId){
          this.promiseAssetsList = {'assetsArrayOnResolve': []};
          this.tempAssetsList = new Promise((resolve, reject) =>{
              this.promiseAssetsList.assetsArrayOnResolve = {resolve: resolve, reject: reject};
          });
          if(this.tempAssetsList){
            await this.tempAssetsList;
            return this.assetsList.find(e => e.asset_id == this.$route.params.assetId);
          }
        }
      },
      async handleTagMetadataAssetHoverAction(file){
        if(file){
          this.selectedFileInfo = file;
        }else{
          this.selectedFileInfo = await this.findTheFileInfoFromAssetsList()
        }
        if(this.isFileActionEnabled('tag-metadata', this.selectedFileInfo.permissions)){
          this.tagMetadataAction();
        }else{
          this.tMRuestorAction();
        }
        this.eOMenu = false;
      },
      archiveRequest(){
        let assetIds = []
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          assetIds.push(this.selectedFileInfo.asset_id)
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          assetIds = Object.keys(this.selectedFiles)
        }
        if(assetIds && assetIds.length > 0){
          this.updateLabelsForArchiveRequest({"asset_ids":assetIds}).then((data)=>{
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              if('message' in data){
                this.$toast.success(data.message);
              }else{
                this.$toast.success("Archive Request submitted successfully")
              }
            } else {
                this.$toast.error(data.message);
            }
          })
        }
      },
      retrieveRequest(){
        let assetIds = []
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          assetIds.push(this.selectedFileInfo.asset_id)
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          assetIds = Object.keys(this.selectedFiles)
        }
        if(assetIds && assetIds.length > 0){
          this.updateLabelsForRetrieveRequest({"asset_ids":assetIds}).then((data)=>{
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              if('message' in data){
                this.$toast.success(data.message);
              }else{
                this.$toast.success("Retrieve Request submitted successfully")
              }
            } else {
                this.$toast.error(data.message);
            }
          })
        }
      },
      transcoderTarget1Request(){
        let assetIds = []
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          assetIds.push(this.selectedFileInfo.asset_id)
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          assetIds = Object.keys(this.selectedFiles)
        }
        if(assetIds && assetIds.length > 0){
          this.updateLabelsForTranscoderTarget1Request({"asset_ids":assetIds}).then((data)=>{
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              if('message' in data){
                this.$toast.success(data.message);
              }else{
                this.$toast.success("Transcode Target-1 Request submitted successfully")
              }
            } else {
                this.$toast.error(data.message);
            }
          })
        }
      },
      transcoderTarget2Request(){
        let assetIds = []
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          assetIds.push(this.selectedFileInfo.asset_id)
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          assetIds = Object.keys(this.selectedFiles)
        }
        if(assetIds && assetIds.length > 0){
          this.updateLabelsForTranscoderTarget2Request({"asset_ids":assetIds}).then((data)=>{
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
              if('message' in data){
                this.$toast.success(data.message);
              }else{
                this.$toast.success("Transcode Target-2 Request submitted successfully")
              }
            } else {
                this.$toast.error(data.message);
            }
          })
        }
      },
      manageAssetLinks(){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = 'manage-assets-link';
        this.eOMenu = false;
      },
      tagMetadataAction(){
        this.ModalParentRoute = Object.assign({}, this.$route);
        let name = 'asset-metadata-manager';
        // if(this.workspace && this.workspace == 'Projects'){
        //   name = 'PAM-asset-metadata-manager';
        //   this.$router.replace({
        //     name:name,
        //     params:{projectId:this.$route.params.projectId,selectedFileInfo:this.selectedFileInfo,assetId:this.selectedFileInfo.asset_id,fromProjects:true,parentinfo:this.$route,subComp:"PAM-asset-metadata-manager",
        //       subComponentToBeUsed:{"subclip-component":"sub-clips-manager-as-child",
        //                             "mediaedit-component":"asset-PartialRetrieve-as-child",
        //                             "asset-video-transcript":"video-transcript-as-child"}},
        //     query:{'project_id':this.$route.params.projectId}
        //   })
        // }else{
        if(this.workspace && this.workspace == 'Projects'){
          name = 'PAM-asset-metadata-manager';
          this.$router.replace({
            name:name,
            params:{projectId:this.$route.params.projectId,selectedFileInfo:this.selectedFileInfo,assetId:this.selectedFileInfo.asset_id,fromProjects:true,parentinfo:this.$route,subComp:"PAM-asset-metadata-manager",
              subComponentToBeUsed:{"subclip-component":"sub-clips-manager-as-child",
                                    "mediaedit-component":"asset-PartialRetrieve-as-child",
                                    "asset-video-transcript":"video-transcript-as-child"}},
            query:{'project_id':this.$route.params.projectId}
          })
        }else{
          let assetIdFromData = this.selectedFileInfo?this.selectedFileInfo.asset_id:this.$route.params.assetId;
          this.$router.push({
          name:name,
          params:{selectedFileInfo:this.selectedFileInfo,assetId:assetIdFromData,parentinfo:this.$route,
            subComponentToBeUsed:{"subclip-component":"sub-clips-manager-as-child",
                                  "mediaedit-component":"asset-PartialRetrieve-as-child",
                                  "asset-video-transcript":"video-transcript-as-child"}}
          })
        }
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = name;
        this.eOMenu = false;
      },
      tMRuestorAction(){
        // this.$router.push({
        //   name:"metadata-requestor",
        // })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "metadata-requestor";
        this.eOMenu = false;
      },
      moveCatalogAction(){
        if(Object.keys(this.selectedFileInfo).length <= 0){
          alert("Please select valid catalog to retrieve.")
          return
        }
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-move-catalog-manager",
        })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "move-catalog-manager"
        this.eOMenu = false;
      },
      setLabelToAsset(){
        if(Object.keys(this.selectedFileInfo).length >= 0 || Object.keys(this.selectedFiles).length >= 0){
          this.isMetadataManagerVisible = true;
          this.openTagMetadataModel = "set-label-to-asset"
          this.eOMenu = false;
        }else{
          alert("Please select valid files.")
          return
        }
      },
      openSetUserDialog(){
        if(Object.keys(this.selectedFileInfo).length >= 0 || Object.keys(this.selectedFiles).length >= 0){
          this.isMetadataManagerVisible = true;
          this.openTagMetadataModel = "set-user-dialog"
          this.eOMenu = false;
        }else{
          alert("Please select valid files.")
          return
        }
      },
      bulkTagMetadataAction(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-bulk-tagmetadata-manager",
        })
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "bulk-tagmetadata-manager"
        this.eOMenu = false;
      },
      createCatalogAction() {
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "create-catalog";
        this.eOMenu = false;
      },
      createPhotoAlbumAction(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "create-photo-album"
        this.eOMenu = false;
      },
      createAssetPackageAction(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "create-asset-package"
        this.eOMenu = false;
      },
      browseAssetsFromFusion(){
        this.browseCoverPhoto = false;
        this.browseInPackage = true;
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "fusion-assets-browser"
        this.eOMenu = false;
      },
      browseCoverPhotoFromFusion(){
        this.browseCoverPhoto = true;
        this.browseInPackage = false;
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "fusion-assets-browser"
        this.eOMenu = false;
      },
      browseImagesFromFusionToPhotoAlbum(){
        this.browseCoverPhoto = false;
        this.browseInPackage = false;
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "fusion-assets-browser"
        this.eOMenu = false;
      },
      browseCoverPhotoFromSystem(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = false;
        this.openTagMetadataModel = "browse-from-system";
        this.eOMenu = false;
      },
      uploadCPFromSystemUpload(ev){
        let file = ev.target.files[0]; // get the file
        let blobURL = URL.createObjectURL(file);
        this.drawImage(blobURL,false)
      },
      drawImage(blobURL){
        this.imageType = "canvas";
        let img = new Image();
        img.src = blobURL;
        img.onerror = ()=> {
          URL.revokeObjectURL(this.src);
          // Handle the failure properly
          alert.log("Could not able to load selected image.");
        };
        img.onload = ()=> {
          URL.revokeObjectURL(this.src);
          let wrh = img.naturalWidth / img.naturalHeight;
          let calculatedImageHeightAsPerAspectRatio = this.PROFILE_IMAGE_ALLOWED_WIDTH / wrh;
          let canvas = document.createElement('canvas');
          canvas.width = this.PROFILE_IMAGE_ALLOWED_WIDTH;
          canvas.height = calculatedImageHeightAsPerAspectRatio
          canvas.getContext("2d").drawImage(img, 0, 0, this.PROFILE_IMAGE_ALLOWED_WIDTH, calculatedImageHeightAsPerAspectRatio);
          this.$nextTick(()=>{
            let payload = {params:{_id:this.selectedFileInfo._id},catalog_cover_photo_file_uid:canvas.toDataURL()}
            this.updatePhotoAlbum(payload).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            })
          });
        };
      },
      browseSVGIconsFromFusion(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "svg-icon-browser"
        this.eOMenu = false;
      },
      submitRetrieveAsAction(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "retrieve-as"
        this.eOMenu = false;
      },
      unsetCoverPhoto(){
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          let payload = {params:{_id:this.selectedFileInfo._id},catalog_cover_photo_file_uid:''}
          this.updatePhotoAlbum(payload).then((data)=>{
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          })
        }else{
          alert("Please select valid catalog.")
        }
      },
      removeAssetFromAlbum(){
        let assetIds = []
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          assetIds.push(this.selectedFileInfo.asset_id)
        }else if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          assetIds = Object.keys(this.selectedFiles)
        }
        if(assetIds && assetIds.length > 0){
          if('catalog_type' in this.rootPathPermission && this.rootPathPermission.catalog_type == 'package'){
            this.addAssetsPackage({params:{_id:this.catalogSelected._id},asset_ids:assetIds, remove_assets:true, catalog_type:'package'}).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
                this.assetsList = this.assetsList.filter(op=>!assetIds.includes(op.asset_id))
              } else {
                this.$toast.error(data.message);
              }
            })
          }else{
            this.addAssetsPhotoAlbum({params:{_id:this.catalogSelected._id},asset_ids:assetIds, remove_assets:true}).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
                this.assetsList = this.assetsList.filter(op=>!assetIds.includes(op.asset_id))
              } else {
                this.$toast.error(data.message);
              }
            })
          }
        }
      },
      setAssetAsCoverPhoto(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = false;
        this.openTagMetadataModel = null;
        this.eOMenu = false;
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          let payload = {params:{_id:this.catalogSelected._id},catalog_cover_photo_file_uid:this.selectedFileInfo.file_uid}
          this.updatePhotoAlbum(payload).then((data)=>{
            if (data.statusCode == 200) {
              this.$toast.success(data.message);
            } else {
              this.$toast.error(data.message);
            }
          })
        }
      },
      setCatalogAsPhotoAlbum(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = false;
        this.openTagMetadataModel = null;
        this.eOMenu = false;
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          if(confirm(`Are you sure, you want to set '${this.selectedFileInfo.catalog_name}' as 'Photo Album'?`)){
            let payload = {params:{_id:this.selectedFileInfo._id},catalog_type: "photo_album"}
            this.updateCatalogAsPhotoAlbum(payload).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            })
          }
        }
      },
      setPhotoAlbumOrPackageAsCatalog(){
        this.closeSubmenu();
        this.isMetadataManagerVisible = false;
        this.openTagMetadataModel = null;
        this.eOMenu = false;
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
          if(confirm(`Are you sure, you want to set '${this.selectedFileInfo.catalog_name}' as 'Catalog'?`)){
            let payload = {params:{_id:this.selectedFileInfo._id},catalog_type: ""}
            this.updateCatalogAsPhotoAlbum(payload).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            })
          }
        }
      },
      handleFusionBrowsedFiles(selectedAssets){
        if(this.browseCoverPhoto){
          //update cover photo
          if(selectedAssets && selectedAssets.length > 0 &&
            this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0){
              let albumCover = selectedAssets[0]
              if(albumCover){
                let payload = {params:{_id:this.selectedFileInfo._id},catalog_cover_photo_file_uid:albumCover.file_uid}
                this.updatePhotoAlbum(payload).then((data)=>{
                  if (data.statusCode == 200) {
                    this.$toast.success(data.message);
                  } else {
                    this.$toast.error(data.message);
                  }
                })
              }
          }
        }else if(selectedAssets && selectedAssets.length > 0){
          //add assets to album
          let payload = {params:{_id: this.catalogSelected._id},"asset_ids":selectedAssets.map(item => item.asset_id)}
          if('catalog_type' in this.rootPathPermission && this.rootPathPermission.catalog_type == 'package'){
            payload["catalog_type"]='package'
            this.addAssetsPackage(payload).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            })
          }else{
            this.addAssetsPhotoAlbum(payload).then((data)=>{
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            })
          }
        }
        this.browseCoverPhoto = false
        this.browseInPackage = false;
        this.closeModal()
      },
      subclipsActions(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.openTagMetadataModel = "sub-clips-manager";
        this.$router.push({
          name:"sub-clips-manager",
          params:{assetId: this.selectedFileInfo._id, fileInfo:Object.assign({}, this.selectedFileInfo),parentinfo:this.$route}
        })
        this.isMetadataManagerVisible = true;
        this.openSubclips = true;
        this.eOMenu = false;
      },
  
      subclipsActionsThroughMetadataDock(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"metadata-dock-sub-clips-manager",
          params:{assetId: this.selectedFileInfo._id, fileInfo:Object.assign({}, this.selectedFileInfo),parentinfo:this.$route}
        })
        this.openTagMetadataModel = "metadata-dock-sub-clips-manager";
        this.isMetadataManagerVisible = true;
        this.openSubclips = true;
        this.eOMenu = false;
      },
  
      editAndShareAction(){
        this.isMetadataManagerVisible = true;
        this.openTagMetadataModel = "edit-and-share";
        this.eOMenu = false;
      },
  
      reviewCatelogAction(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-new-review",
        })
        this.openTagMetadataModel = 'new-review';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
  
      assetCommentsAction(){
        this.ModalParentRoute = Object.assign({}, this.$route);
        let parentRouteInfo = {};
        let routeName = this.$route.name;
        try{
          parentRouteInfo['name'] = routeName;
          parentRouteInfo['query'] = Object.keys(this.$route.query).length ? JSON.stringify(this.$route.query) : '{}';
          parentRouteInfo['params'] = Object.keys(this.$route.params).length ? JSON.stringify(this.$route.params) : '{}';
        }catch(e){console.log(e)}
        this.$router.push({name:"asset-livemedia-comment-review",params:{fileInfo:this.selectedFileInfo,asset_id:this.selectedFileInfo._id,parentinfo:parentRouteInfo}})
        this.openTagMetadataModel = 'asset-livemedia-comment-review';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
  
      submitOBDAction(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-object-detection",
          params:{filesInfo:this.selectedFileInfo,parentinfo:this.$route}
        })
        this.openTagMetadataModel = 'object-detection';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
  
      shareWithUser(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-share-with-user",
          params:{filesInfo:this.selectedFileInfo,parentinfo:this.$route}
        })
        this.openTagMetadataModel = 'share-with-user';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
  
      shareWithUserFromGlobalBtn(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-share-with-user-from-global-btn",
          params:{filesInfo:this.selectedFileInfo,parentinfo:this.$route}
        })
        this.openTagMetadataModel = 'asset-share-with-user-from-global-btn';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
  
      shareViaEmail(){
        this.ModalParentRoute = Object.assign({}, this.$route)
        this.$router.push({
          name:"asset-share-via-email",
        })
        this.openTagMetadataModel = 'share-via-email';
        this.isMetadataManagerVisible = true;
        this.eOMenu = false;
      },
  
  
      taskCatelogAction(){
        // this.openTagMetadataModel = 'new-tasks-issues';
        // this.isMetadataManagerVisible = true;
        this.$emit('handleNewTaskOrIssueAction');
        this.eOMenu = false;
      },
      shareCatelogAction(){
        this.$emit('handleShareAction',{});
        this.eOMenu = false;
      },
      handleShareAction(file){
        this.$emit('handleShareAction', file)
        this.eOMenu = false;
      },
      shareInChatSubclips(){
        this.openShareInChat()
      },
      setUpContextMenuActions(){
        let actions = [];
        Array.prototype.push.apply(actions, this.getRegisteredBinsContextMenu());
        Array.prototype.push.apply(
          actions,
          this.getRegisteredBinsMoreContextMenu()
        );
        Array.prototype.push.apply(
          actions,
          this.getRegisteredBinsNewContextMenu()
        );
        Array.prototype.push.apply(
          actions,
          this.getRegisteredShareContextMenu()
        );
        Array.prototype.push.apply(actions, this.getRegisteredAIToolsContextMenu())
        Array.prototype.push.apply(actions, this.getRegisteresOpenWithContextMenu())
        Array.prototype.push.apply(actions, this.getRegisteredCatalogIconContextMenu())
        Array.prototype.push.apply(actions, this.getRegisteredExportContextMenu())
        console.log("this..............",this.getRegisteredPluginMapper());
        for (let contextMenu of actions) {
          console.log("contextMenucontextMenu",contextMenu.action_name)
          if(contextMenu.action_name == "Archive Request"){
            let event = [
              {
                event_name: "onClick",
                event_handler: this.archiveRequest,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: event,
            });
          }else if(contextMenu.action_name == "Retrieve Request"){
            let event = [
              {
                event_name: "onClick",
                event_handler: this.retrieveRequest,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: event,
            });
          }else if(contextMenu.action_name == "Delivery to Target 1 Request"){
            let event = [
              {
                event_name: "onClick",
                event_handler: this.transcoderTarget1Request,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: event,
            });
          }else if(contextMenu.action_name == "Delivery to Target 2 Request"){
            let event = [
              {
                event_name: "onClick",
                event_handler: this.transcoderTarget2Request,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: event,
            });
          }
          else if(contextMenu.action_name == "manage-assets-links"){
            let assetLinksEvent = [
              {
                event_name: "onClick",
                event_handler: this.manageAssetLinks,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: assetLinksEvent,
            });
          }
          else if (contextMenu.label == "Assets Report"){
            let assetsReportEvents = [{
              "event_name": "onClick",
              "event_handler": this.downloadAssetsReport,
              "handler_args":[]
            }]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.id,
              onEvents: assetsReportEvents,
            })
          }
          else if(contextMenu.label == 'Outbox'){
            let outboxEvents = [{
              "event_name": "onClick",
              "event_handler": this.exportAssetstoOutbox,
              "handler_args":[]
            }]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.id,
              onEvents: outboxEvents,
            })
          }
          else if (contextMenu.action_name == "tag-metadata"){
            let tagMetadataBinsEvents = [{
              "event_name": "onClick",
              "event_handler": this.tagMetadataAction,
              "handler_args":[]
            }]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: tagMetadataBinsEvents,
            })
          }
          else if(contextMenu.action_name == "Chat"){
            let shareInChat = [
              {
                event_name: "onClick",
                event_handler: this.openShareInChat,
                handler_args: [],
              }
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: shareInChat,
            });
          }else if(contextMenu.action_name == "Lock/Unlock"){
            if(contextMenu.label == 'Lock'){
              let shareInChat = [
                {
                  event_name: "onClick",
                  event_handler: this.lockSelectedAsset,
                  handler_args: [],
                }
              ];
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: shareInChat,
              });
            }else if(contextMenu.label == 'Unlock'){
              let shareInChat = [
                {
                  event_name: "onClick",
                  event_handler: this.unlockSelectedAsset,
                  handler_args: [],
                }
              ];
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: shareInChat,
              });
            }
          } else if(contextMenu.action_name == "tag-metadata-requestor"){
            let tMRBinsEvents = [{
                event_name: "onClick",
                event_handler: this.tMRuestorAction,
                handler_args: [],
              }];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: tMRBinsEvents,
            });
          }else if (contextMenu.action_name == "Bulk Field Update"){
            let tagMetadataBinsEvents = [{
              "event_name": "onClick",
              "event_handler": this.bulkTagMetadataAction,
              "handler_args":[]
            }]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: tagMetadataBinsEvents,
            })
          }else if (contextMenu.action_name == "Upload"){
            let uploadEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitUploadAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: uploadEvents,
            })
          }else if (contextMenu.action_name == "Upload Version") {
            let assetNewVersionEvents = [
              {
                event_name: "onClick",
                event_handler: this.uploadAssetNewVersion,
                handler_args: [],
              },
            ];
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.action_name,
                onEvents: assetNewVersionEvents,
              });
          }else if (contextMenu.action_name == "Update Version") {
            let assetExistVersionEvents = [
              {
                event_name: "onClick",
                event_handler: this.updateAssetNewVersion,
                handler_args: [],
              },
            ];
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.action_name,
                onEvents: assetExistVersionEvents,
              });
          }else if (contextMenu.action_name == "manage-catalogs" && contextMenu.label == "Set as Catalog"){
            let CreateCatalogEvents = [
              {
                event_name: "onClick",
                event_handler: this.setPhotoAlbumOrPackageAsCatalog,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.id,
              onEvents: CreateCatalogEvents,
            })
          }else if (contextMenu.action_name == "manage-catalogs"){
            let CreateCatalogEvents = [
              {
                event_name: "onClick",
                event_handler: this.createCatalogAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: "manage-catalogs",
              onEvents: CreateCatalogEvents,
            })
          }else if(["manage-asset-packages"].includes(contextMenu.action_name)){
            if(contextMenu.label == "Create Package"){
              let CreatePackageEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.createAssetPackageAction,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: CreatePackageEvents,
              })
            }else if(contextMenu.label  == "Remove from Package"){
              let event = [
                {
                  event_name: "onClick",
                  event_handler: this.removeAssetFromAlbum,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: event,
              })
            }else if(contextMenu.label == "From Fusion"){
              let event = [
                {
                  event_name: "onClick",
                  event_handler: this.browseAssetsFromFusion,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: event,
              })
            }
            
          }else if(["manage-catalog-thumbnail", "manage-photo-albums"].includes(contextMenu.action_name)){
            if(contextMenu.label == "From your Computer"){
              let catalogThumbEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.browseCoverPhotoFromSystem,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: catalogThumbEvents,
              })
            }else if(contextMenu.label == "From Fusion"){
              //Hardcoding the ID validation because the ID is hardcoded in the backend to support the context menu with duplicate action_ids.
              if (contextMenu.id == "66309bb666d0e4951e429be5-PA-FromFusion"){
              let catalogThumbEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.browseCoverPhotoFromFusion,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: catalogThumbEvents,
              })
            }else{
              let photoAlbumEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.browseImagesFromFusionToPhotoAlbum,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: photoAlbumEvents,
              })
            }
            }else if(["Remove Thumbnail","Remove Cover Photo"].includes(contextMenu.label)){
              let catalogThumbEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.unsetCoverPhoto,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: catalogThumbEvents,
              })
            }else if(contextMenu.label == "Create Photo Album"){
              let CreateAlbumEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.createPhotoAlbumAction,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: CreateAlbumEvents,
              })
            }else if(contextMenu.label  == "Remove from Photo Album"){
              let event = [
                {
                  event_name: "onClick",
                  event_handler: this.removeAssetFromAlbum,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: event,
              })
            }else if(contextMenu.label == "Update SVG Icon"){
              let catalogThumbEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.browseSVGIconsFromFusion,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                id: contextMenu.id,
                action_name: contextMenu.id,
                onEvents: catalogThumbEvents,
              })
            }else if(contextMenu.label == "Set as Cover Photo"){
              let coverPhotoEvent = [
                  {
                    event_name: "onClick",
                    event_handler: this.setAssetAsCoverPhoto,
                    handler_args: [],
                  },
                ]
                this.updateActionCallbacks({
                  id: contextMenu.id,
                  action_name: contextMenu.id,
                  onEvents: coverPhotoEvent,
                });
            }else if(contextMenu.label == "Set as Photo Album"){
              let catalogPhotoAlbumEvent = [
                  {
                    event_name: "onClick",
                    event_handler: this.setCatalogAsPhotoAlbum,
                    handler_args: [],
                  },
                ]
                this.updateActionCallbacks({
                  id: contextMenu.id,
                  action_name: contextMenu.id,
                  onEvents: catalogPhotoAlbumEvent,
                });
            }
          }
          else if (contextMenu.action_name == "rename-catalog") {
            let renameEvents = [
              {
                event_name: "onClick",
                event_handler: this.editCatalogAction,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: renameEvents,
            });
          }
          else if (contextMenu.action_name == "Transcode"){
             let partialRetrieveEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.submitPartialRetrieveAction,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                  id: contextMenu.id,
                  action_name: contextMenu.action_name,
                  onEvents: partialRetrieveEvents
                })
          }
          else if (contextMenu.action_name == "OCR") {
            let ocrEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.submitOCRAction,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                  id: contextMenu.id,
                  action_name: contextMenu.action_name,
                  onEvents: ocrEvents,
                })
          }else if (contextMenu.action_name == "Transcript"){
            let transcriptEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.submitTranscript,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                  id: contextMenu.id,
                  action_name: contextMenu.action_name,
                  onEvents: transcriptEvents,
                })
          }
          else if (contextMenu.action_name == "Object Detection") {
            let obdEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.submitOBDAction,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                  id: contextMenu.id,
                  action_name: contextMenu.action_name,
                  onEvents: obdEvents,
                })
          }
          else if (contextMenu.action_name == "Face Detection") {
          // else if (contextMenu.action_name == "face_detection") {
            let faceDetectionEvents = [
                {
                  event_name: "onClick",
                  event_handler: this.submitFaceDetectionAction,
                  handler_args: [],
                },
              ]
              this.updateActionCallbacks({
                  id: contextMenu.id,
                  action_name: contextMenu.action_name,
                  onEvents: faceDetectionEvents,
                })
          }
          else if (contextMenu.action_name == "Retrieve"){
            let uploadEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitRetrieveAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: uploadEvents,
            }) 
           }
          else if (contextMenu.action_name == "Retrieve As"){
            let retrieveAsEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitRetrieveAsAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: retrieveAsEvents,
            }) 
           }
           else if (contextMenu.action_name == "Move Catalog"){
            let mcatalogEvents = [
              {
                event_name: "onClick",
                event_handler: this.moveCatalogAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: mcatalogEvents,
            }) 
           }
           else if(contextMenu.action_name == "set-asset-label"){
            let setLabelEvents = [
              {
                event_name: "onClick",
                event_handler: this.setLabelToAsset,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: setLabelEvents,
            })
           }
          else if (contextMenu.action_name == "Folder Retrieve"){
            let uploadEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitFolderRetrieveAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: uploadEvents,
            }) 
           }else if (contextMenu.action_name == "Archive"){
            let archiveEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitArchiveAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: archiveEvents,
            })
          }else if (contextMenu.action_name == "Folder Archive"){
            let folderArchiveEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitFolderArchiveAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: folderArchiveEvents,
            })
          }
          else if (contextMenu.action_name == "copy-link") {
            let copyURLEvents = [
              {
                event_name: "onClick",
                event_handler: this.copyAssetURL,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: copyURLEvents,
            });
          }
          else if (contextMenu.action_name == "set-user-id") {
            let copyURLEvents = [
              {
                event_name: "onClick",
                event_handler: this.openSetUserDialog,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: copyURLEvents,
            });
          }
          else if (contextMenu.action_name == "Download"){
            let downloadEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitDownloadAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: downloadEvents,
            })
          }
          else if (contextMenu.action_name == "Download Proxy"){
            let downloadProxyEvents = [
              {
                event_name: "onClick",
                event_handler: this.submitDownloadProxyAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.id,
              onEvents: downloadProxyEvents,
            })
          }
          else if (contextMenu.action_name == "Preview"){
            let previewEvents = [
              {
                event_name: "onClick",
                event_handler: this.handlePreviewAction,
                handler_args: [],
              },
            ]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: previewEvents,
            })
          }
          else if (contextMenu.action_name == "Mark For Delete" && this.isEnabled("Mark For Delete")) {
            let markForDeleteEvents = [
              {
                event_name: "onClick",
                event_handler: this.handleMarkForDeleteEvents,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: markForDeleteEvents,
            });
          }
          else if (contextMenu.action_name == "Restore" && this.isEnabled("Restore")) {
            let restoreEvents = [
              {
                event_name: "onClick",
                event_handler: this.handleRestore,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: restoreEvents,
            });
          }
          else if (contextMenu.action_name == "Delete Permanently" && this.isEnabled("Delete Permanently")) {
            let delPermEvents = [
              {
                event_name: "onClick",
                event_handler: this.handleDeletePermanently,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: delPermEvents,
            })
          }
          else if (contextMenu.action_name == "Force Delete Permanently" && this.isEnabled("Force Delete Permanently")) {
            let forceDelPermEvents = [
              {
                event_name: "onClick",
                event_handler: this.handleForceDeletePermanently,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: forceDelPermEvents,
            })
          }
          else if (contextMenu.action_name == "Sub Clips") {
            let subclipsBinsEvents = [
              {
                event_name: "onClick",
                event_handler: this.subclipsActions,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: subclipsBinsEvents,
            })
          }
          
          else if (contextMenu.action_name == "Review") {
            let reviewBinsEvents = [
              {
                event_name: "onClick",
                event_handler: this.reviewCatelogAction,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: reviewBinsEvents,
            });
          }
         else if (contextMenu.action_name == "Manage Asset Comments"){
            let cEvents = [{
              "event_name": "onClick",
              "event_handler": this.assetCommentsAction,
              "handler_args":[]
            }]
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: cEvents,
            })
          }
          else if(contextMenu.action_name == "Share"){
            let shareCatalogEvents = [
              {
                event_name: "onClick",
                event_handler: this.shareWithUser,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: shareCatalogEvents,
            });
          }
          else if(contextMenu.action_name == "Share via Email"){
            let shareCatalogEvents = [
              {
                event_name: "onClick",
                event_handler: this.shareViaEmail,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: shareCatalogEvents,
            });
          }
          else if (contextMenu.action_name == "PAM") {
            let taskCatalogEvents = [
              {
                event_name: "onClick",
                event_handler: this.taskCatelogAction,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: taskCatalogEvents,
            });
          }
          // else if (contextMenu.action_name == "Hype-SocialMedia") {
          //   let editAndShareEvents = [
          //     {
          //       event_name: "onClick",
          //       event_handler: this.editAndShareAction,
          //       handler_args: [],
          //     },
          //   ];
          //   this.updateActionCallbacks({
          //     id: contextMenu.id,
          //     action_name: contextMenu.action_name,
          //     onEvents: editAndShareEvents,
          //   });
          // }
          else if (contextMenu.action_name == "Modify TTL") {
            let modifyTTLEvents = [
              {
                event_name: "onClick",
                event_handler: this.modifyTTLAction,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: modifyTTLEvents,
            });
          }
          else if (contextMenu.action_name == "Manage Version") {
            let mediaVersionEvents = [
              {
                event_name: "onClick",
                event_handler: this.manageMediaVersion,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: mediaVersionEvents,
            });
          }
          else if (contextMenu.action_name == "manage-asset-annotaion") {
            let imageAnnotation = [
              {
                event_name: "onClick",
                event_handler: this.imageAnnotationAction,
                handler_args: [],
              },
            ];
            this.updateActionCallbacks({
              id: contextMenu.id,
              action_name: contextMenu.action_name,
              onEvents: imageAnnotation,
            });
          }
          // else if (contextMenu.action_name == "GoogleDriveImport"||contextMenu.action_name == "OrgGoogleDriveImport") {
          //   let googleDriveEvents = [
          //     {
          //       event_name: "onClick",
          //       event_handler: this.manageGoogleDrive,
          //       handler_args: [],
          //     },
          //   ];
          //   this.updateActionCallbacks({
          //     id: contextMenu.id,
          //     action_name: contextMenu.action_name,
          //     onEvents: googleDriveEvents,
          //   });
          // }
          /**
           *   Below code will override existing contextmenu click callback  with plugin callback
           *   Based on "contextmenu":{"contextMenuCallback":openOCRtranscriptContextmenu , "action_name":"OCR"} for eg here it will call openOCRtranscriptContextmenu at damplugin side
           */
          try{
              for(let pluginId in this.getRegisteredPluginMapper()){
                  let plugin = this.getRegisteredPluginMapper()[pluginId];
                  if(plugin && plugin.contextmenu){
                      if(Array.isArray(plugin.contextmenu)){
                          for(let eachContextMenu of plugin.contextmenu){
                              if(eachContextMenu.action_name == contextMenu.action_name){
                                  let event = [
                                    {
                                      event_name: "onClick",
                                      event_handler: eachContextMenu.contextMenuCallback,
                                      handler_args: [],
                                    },
                                  ];
                                  this.updateActionCallbacks({
                                    id: contextMenu.id,
                                    action_name: contextMenu.action_name,
                                    onEvents: event,
                                  });
                              }
                          }
                      }
                      else{
                          if(plugin.contextmenu.action_name == contextMenu.action_name){
                              let event = [
                                {
                                  event_name: "onClick",
                                  event_handler: plugin.contextmenu.contextMenuCallback,
                                  handler_args: [],
                                },
                              ];
                              this.updateActionCallbacks({
                                id: contextMenu.id,
                                action_name: contextMenu.action_name,
                                onEvents: event,
                              });
                          }
                      }
                  }
              }
          }catch(e){console.error("Some error occured while registering plugin contextmenu -->",e)}
        }
        this.eventsAttached = true;
      },
      getExportEventHandler(binInfo, eventName){
        if('action_name' in binInfo){
          this.getEventHandler(
            binInfo,
                  'onClick',
                  binInfo.onEvents
                )(eventName, Object.assign({},this.selectedFileInfo),  Object.assign({},this.selectedFiles), {boundComponent: this.getComponent})
          return
        }
        let filesList = [];
        if(Object.keys(this.selectedFileInfo).length){
          filesList = [this.selectedFileInfo]
        } else{
          filesList = this.getSelectedMultipleFilesAsList(this.selectedFiles)
        }
        for(let eachFile of filesList){
          let payload = {
            job_name : "Export",
            element_type : "file",
            file_name : eachFile.file_name,
            path : eachFile.path,
            export_to : [binInfo.bin_id]
          }
          this.createNewJob(payload).then((data) => {
            console.log("Export proxy job response: ", data.statusCode)
          });
        }
        this.$toast.success('Job sumitted successfully.')
      },
      getExportProxyEventHandler(binInfo, eventName){
        if('action_name' in binInfo){
          this.getEventHandler(
            binInfo,
                  'onClick',
                  binInfo.onEvents
                )(eventName, Object.assign({},this.selectedFileInfo),  Object.assign({},this.selectedFiles))
          return
        }
        let payload = {}
        if(Object.keys(this.selectedFileInfo).length){
          payload = {
            job_name : "Export Proxy",
            element_type : "file",
            file_name : this.selectedFileInfo.file_name,
            path : this.selectedFileInfo.path,
            export_to : [binInfo.bin_id]
          }
          this.createNewJob(payload).then((data) => {
            console.log(" Export proxy job : resp keys ",Object.keys(data) )
            if (data.statusCode == 200) {
              this.$toast.success("Export proxy job submitted successfully");
            } else {
              if(data.message){
                this.$toast.error(data.message);
              }else{
                this.$toast.error('Failed to submitted export proxy job.');
              }
            }
          });
        }else{
          let postedJobs = []
          for (const asset_id of Object.keys(this.selectedFiles)) {
            payload = {
              job_name : "Export Proxy",
              element_type : "file",
              file_name : this.selectedFiles[asset_id].file_name,
              path : this.selectedFiles[asset_id].path,
              export_to : [binInfo.bin_id]
            }
            let jobsPostPromise = this.createNewJob(payload)
            jobsPostPromise.file_name = this.selectedFiles[asset_id].file_name;
            postedJobs.push(jobsPostPromise)
          }
          Promise.all(postedJobs).then(allJobsList=>{
              let failedEntries = []
              let exportedEntries = []
              for(let i=0; i<allJobsList.length ; i++){
                let eachJob  = allJobsList[i]
                if (eachJob.statusCode == 200) {
                  exportedEntries.push(eachJob)
                } else {
                  failedEntries.push(eachJob.message)
                }
              }
              if(exportedEntries && exportedEntries.length > 0){
                this.$toast.success("Export proxy job submitted successfully");
              }
              if(failedEntries && failedEntries.length > 0){
                if(failedEntries.length == 1){
                  this.$toast.error(`Failed to export proxy ${failedEntries[0]}.`)
                }else{
                  this.$toast.error(`${failedEntries[0]} \n + Failed to export proxy  ${failedEntries.length-1} More files`);
                }
              }
          })
        }
        this.closeContextMenu();
      },
      getShareEventHandler(){
        //
      },
      getEventHandler(info, eventname, supportedEvents, doNotClosePlayer = false, isFromHover = false){
        console.log("info, eventname, supportedEvents",info, eventname, supportedEvents)
        if(!doNotClosePlayer){
          try {
            this.$parent.closeMinimisedPlayer();
          } catch (error) {
            console.log("e",error)
          }  
        }
          if (
          info != undefined &&
          !info.dialogRequired
        ) {
            let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
            if(event.length != 0){
              if(!isFromHover){
                this.closeContextMenu();
              }
              return event[0]["event_handler"];
            }
        }
        return console.log
        },
      changeComponent(compName,binId=null) {
        this.$emit("clearSearchData");
        this.searchKeyword = null;
        this.unsetLocationHash()
        // Utils.unsetCookie('traverseHistory')
        if (binId!=null){
          this.$emit("changeSelectedMainComponent", compName);
        }else{
          this.$emit("changeSelectedMainComponent", compName,{bin_id:binId});
        }
        
      },
      showCatalogDetails(catalog) {
        Object.assign(this.currentCategoryInfo, catalog)
        if(![undefined,null].includes(this.$route.query) && ('advanceFilter' in this.$route.query || 'keyword' in this.$route.query)){
          let cIdPath = JSON.parse(JSON.stringify(catalog.parent_path));
          if(cIdPath.length > 0){
            let paths = cIdPath[0].value;
            paths = paths.replace("catalog://0/","");
            let ids = cIdPath[0].id;
            ids = ids.replace("catalog_id://0/","");
            let pathList = paths.split("/");
            let idList = ids.split("/");
            let pidPath = "catalog_id://0"
            let traverPathList = []
            for(let i = 0; i<pathList.length;i++){
              traverPathList.push({
                _id:idList[i],
                catalog_name:pathList[i],
                file_name:pathList[i],
                pid:pidPath,
                permissions:catalog.permissions,
                catalog_type:catalog.catalog_type,
                asset_state:catalog.asset_state
              })
              pidPath += "/"+idList[i];
            }
            traverPathList.push({
                _id:catalog._id,
                catalog_name:catalog.catalog_name,
                file_name:catalog.catalog_name,
                pid:catalog.catalog_id_path,
                permissions:catalog.permissions,
                catalog_type:catalog.catalog_type,
                asset_state:catalog.asset_state
              })
            this.catalogTraverseStructure = traverPathList;
            Utils.saveFolderHistory(this.catalogTraverseStructure)
          }
        }
        if(catalog && catalog._id){
          if(this.workspace && this.workspace == 'Projects'){
            let currentRoute = this.$route;
            this.$router.push({
                name:"assets-projects", 
                params:{
                  _id: catalog._id, 
                  pid: catalog.parent_id_path[0],
                  file_name: catalog.catalog_name,
                  catalog_name: catalog.catalog_name,
                  catalog_id:catalog._id,
                  asset_state:catalog.asset_state,
                  permissions:catalog.permissions,
                  catalog_type:catalog.catalog_type
                },
                query:{
                  project_id:currentRoute.params.projectId
                }
              }
            )
          }else{
            this.$router.push({
              name:"catalogs-display", 
              params:{
                _id: catalog._id, 
                pid: catalog.parent_id_path[0],
                file_name: catalog.catalog_name,
                catalog_name: catalog.catalog_name,
                catalog_id:catalog._id,
                asset_state:catalog.asset_state,
                permissions:catalog.permissions,
                catalog_type:catalog.catalog_type
                }
              }
            )
          }
        }
          
        this.$emit("clearSearchData");
        this.searchKeyword = null;
      },
      checkMultiSelectPrivilege(privilege, multiSelect=false){
        if (multiSelect){
          return privilege.multiple_selection_support
        }
        return true
      },
      triggerShowSubmenu(event) {
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if (this.showImportSubMenu) {
          this.showImportSubMenu = false;
        }
        if(this.showExportSubMenu){
          this.showExportSubMenu = false;
        }
        if(this.showExportProxySubMenu){
          this.showExportProxySubMenu = false;
        }
        if(this.showShareSubmenu){
          this.showShareSubmenu = false;
        }
        if(this.showAIToolsSubmenu){
          this.showAIToolsSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        this.showMoreSubMenu = !this.showMoreSubMenu;
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuItems = this.getContextMenuItems(
          this.selectedFileInfo,
          "MOREACTIONS",
          multiFiles
        );
        event.stopPropagation();
      },
      triggerShowExportSubmenu(event) {
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        this.showShareSubmenu = false;
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if (this.showImportSubMenu) {
          this.showImportSubMenu = false;
        }
        if(this.showMoreSubMenu){
          this.showMoreSubMenu = false;
        }
        if(this.showAIToolsSubmenu){
          this.showAIToolsSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        if(this.showExportProxySubMenu){
          this.showExportProxySubMenu = false;
        }
        this.showExportSubMenu = !this.showExportSubMenu;
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuExportItems = []
  
        let fileTypes = [];
        let fileStates =[];
        if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          for(let op of Object.keys(this.selectedFiles)){
            let fileInfo = this.selectedFiles[op]
            fileTypes.push(fileInfo.asset_type)
            fileStates.push(fileInfo.state);
            if(!['file' , 'page'].includes(fileInfo.asset_type)|| fileInfo.state == "GROWING"){
              break;
            }
          }
        }else if(this.selectedFileInfo != undefined && Object.keys(this.selectedFileInfo).includes('asset_type')){
          fileTypes.push(this.selectedFileInfo.asset_type)
          fileStates.push(this.selectedFileInfo.state)
        }
        if ((fileTypes.length > 0 && !fileTypes.includes("catalog") &&
            !fileTypes.includes("subclip") && !fileStates.includes("GROWING") &&
           !fileStates.includes("MARK FOR DELETE") &&
          this.deploymentBinsList != undefined &&
          this.deploymentBinsList.length > 0 && this.isEnabled("Export"))) {
            this.subMenuExportItems = this.subMenuExportItems.concat(this.deploymentBinsList)
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        let exportSubMenu = this.getContextMenuItems(
          this.selectedFileInfo,
          "EXPORTOPTION",
          multiFiles
        );
        if(exportSubMenu && exportSubMenu.length > 0){
          this.subMenuExportItems = this.subMenuExportItems.concat(exportSubMenu)
        }
        event.stopPropagation();
      },
      triggerShowExportProxySubmenu(event) {
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        this.showShareSubmenu = false;
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if (this.showImportSubMenu) {
          this.showImportSubMenu = false;
        }
        if(this.showMoreSubMenu){
          this.showMoreSubMenu = false;
        }
        if(this.showAIToolsSubmenu){
          this.showAIToolsSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        if(this.showExportSubMenu){
          this.showExportSubMenu = false;
        }
        this.showExportProxySubMenu = !this.showExportProxySubMenu;
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        this.subMenuExportProxyItems = []
  
        let fileTypes = [];
        let fileStates =[];
        if(this.selectedFiles && Object.keys(this.selectedFiles).length > 0){
          for(let op of Object.keys(this.selectedFiles)){
            let fileInfo = this.selectedFiles[op]
            fileTypes.push(fileInfo.asset_type)
            fileStates.push(fileInfo.state);
            if(!['file', 'page'].includes(fileInfo.asset_type) || fileInfo.state == "GROWING"){
              break;
            }
          }
        }else if(this.selectedFileInfo != undefined && Object.keys(this.selectedFileInfo).includes('asset_type')){
          fileTypes.push(this.selectedFileInfo.asset_type)
          fileStates.push(this.selectedFileInfo.state)
        }
        if ((fileTypes.length > 0 && !fileTypes.includes("catalog") &&
            !fileTypes.includes("subclip") && !fileStates.includes("GROWING") &&
           !fileStates.includes("MARK FOR DELETE") &&
          this.deploymentBinsList != undefined &&
          this.deploymentBinsList.length > 0 && this.isEnabled("Export Proxy"))) {
            this.subMenuExportProxyItems = this.subMenuExportProxyItems.concat(this.deploymentBinsList)
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        let exportSubMenu = this.getContextMenuItems(
          this.selectedFileInfo,
          "EXPORTPROXYOPTION",
          multiFiles
        );
        if(exportSubMenu && exportSubMenu.length > 0){
          this.subMenuExportProxyItems = this.subMenuExportProxyItems.concat(exportSubMenu)
        }
        event.stopPropagation();
      },
      triggerShowSubmenuNew(event) {
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        if (this.showMoreSubMenu) {
          this.showMoreSubMenu = false;
        }
        if(this.showExportSubMenu){
          this.showExportSubMenu = false;
        }
        if(this.showExportProxySubMenu){
          this.showExportProxySubMenu = false;
        }
        if(this.showShareSubmenu){
          this.showShareSubmenu = false;
        }
        if(this.showAIToolsSubmenu){
          this.showAIToolsSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        if(this.showImportSubMenu){
          this.showImportSubMenu = false;
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        this.showNewSubMenu = !this.showNewSubMenu;
        if(event.clientX > 900){
          this.submenuNewX = this.x - 180;
        }else{
          this.submenuNewX = this.x + 90;
        }
        if(event.layerY > 30){
          this.submenuNewY = event.clientY - 20;
        }else{
          this.submenuNewY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuNewItems = this.getContextMenuItems(
          this.selectedFileInfo,
          "NEWOPTION",
          multiFiles
        );
        event.stopPropagation();
      },
      attachNewOption(contextMenuItems, multiFiles=false){
        let newActions = this.getRegisteredBinsNewContextMenu();
        let assetsNewActions = this.getContextMenuItems(this.selectedFileInfo, "NEWOPTION",multiFiles);
        if(typeof newActions == "undefined" || typeof assetsNewActions == "undefined"){
          return
        }
        if (
          newActions.length != 0 &&
          assetsNewActions.length != 0
        ) {
          contextMenuItems.push({
            sub_menu: "NEWOPTION",
            label: "New",
            iconSvgCallback: Utils.getMoreSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowSubmenuNew,
                handler_args: [],
              },
            ],
          });
        }
      },
      triggerShowSubmenuImport(event) {
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        if (this.showMoreSubMenu) {
          this.showMoreSubMenu = false;
        }
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if(this.showExportSubMenu){
          this.showExportSubMenu = false;
        }
        if(this.showExportProxySubMenu){
          this.showExportProxySubMenu = false;
        }
        if(this.showShareSubmenu){
          this.showShareSubmenu = false;
        }
        if(this.showAIToolsSubmenu){
          this.showAIToolsSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        this.showImportSubMenu = !this.showImportSubMenu;
        if(event.clientX > 900){
          this.submenuImportX = this.x - 180;
        }else{
          this.submenuImportX = this.x + 90;
        }
        if(event.layerY > 30){
          this.submenuImportY = event.clientY - 20;
        }else{
          this.submenuImportY = event.clientY + 20;
        }
        this.subMenuImportItems = this.getContextMenuItems(
          this.selectedFileInfo,
          "IMPORTOPTION",
          multiFiles
        );
        event.stopPropagation();
      },
      attachImportOption(contextMenuItems, multiFiles=false){
        let importActions = this.getRegisteredBinsImportContextMenu();
        let assetsImportActions = this.getContextMenuItems(this.selectedFileInfo, "IMPORTOPTION",multiFiles);
        if(typeof importActions == "undefined" || typeof assetsImportActions == "undefined"){
          return
        }
        if (
          importActions.length != 0 &&
          assetsImportActions.length != 0
        ) {
          contextMenuItems.push({
            sub_menu: "IMPORTOPTION",
            label: "Import",
            iconSvgCallback: Utils.getImportSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowSubmenuImport,
                handler_args: [],
              },
            ],
          });
        }
      },
      attachMoreOption(contextMenuItems, multiFiles=false){
        let moreActions = this.getRegisteredBinsMoreContextMenu();
        let assetsMoreActions = this.getContextMenuItems(this.selectedFileInfo, "MOREACTIONS", multiFiles);
        if(typeof moreActions == "undefined" || typeof assetsMoreActions == "undefined"){
          return
        }
        if (
          moreActions.length != 0 &&
          assetsMoreActions.length != 0
        ) {
          contextMenuItems.push({
            sub_menu: "MOREACTIONS",
            label: "More",
            iconSvgCallback: Utils.getMoreSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowSubmenu,
                handler_args: [],
              },
            ],
          });
        }
      },
      attachExportOption(conteMenuItems, multiFiles=false){
        let assetReportsAction = this.getContextMenuItems(this.selectedFileInfo, "EXPORTOPTION", multiFiles);
        let fileTypes = [];
        let fileStates =[];
        let isAnyFilelocked = false;
        if(multiFiles){
          for(let op of Object.keys(this.selectedFiles)){
            let fileInfo = this.selectedFiles[op]
            fileTypes.push(fileInfo.asset_type)
            fileStates.push(fileInfo.state);
            if(!isAnyFilelocked && 'lock' in fileInfo && fileInfo.lock){
              isAnyFilelocked = true
            }
            if(!['file','page'].includes(fileInfo.asset_type)|| fileInfo.state == "GROWING"){
              break;
            }
          }
        }else if(this.selectedFileInfo != undefined && Object.keys(this.selectedFileInfo).includes('asset_type')){
          fileTypes.push(this.selectedFileInfo.asset_type)
          fileStates.push(this.selectedFileInfo.state)
          if('lock' in this.selectedFileInfo && this.selectedFileInfo.lock){
            isAnyFilelocked = true
          }
        }
        if (((fileTypes.length > 0 && !fileTypes.includes("catalog") &&
            !fileTypes.includes("subclip") && !fileStates.includes("GROWING") &&
           !fileStates.includes("MARK FOR DELETE") &&
          this.deploymentBinsList != undefined &&
          this.deploymentBinsList.length > 0 && this.isEnabled("Export")) || (assetReportsAction && assetReportsAction.length > 0)) &&
          ((isAnyFilelocked && (!('lock_restricted_actions' in this.barcodeInfoFromStartup) ||
           (('lock_restricted_actions' in this.barcodeInfoFromStartup &&
            !this.barcodeInfoFromStartup.lock_restricted_actions.includes("Export"))))) || !isAnyFilelocked)) {
          conteMenuItems.push({
            sub_menu: "EXPORTOPTION",
            label: "Export",
            iconSvgCallback: Utils.getDownloadSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowExportSubmenu,
                handler_args: [],
              },
            ],
          });
        }
      },
      attachExportProxyOption(conteMenuItems, multiFiles=false){
        let fileTypes = [];
        let fileStates =[];
        let isAnyFilelocked = false;
        if(multiFiles){
          for(let op of Object.keys(this.selectedFiles)){
            let fileInfo = this.selectedFiles[op]
            fileTypes.push(fileInfo.asset_type)
            fileStates.push(fileInfo.state);
            if(!isAnyFilelocked && 'lock' in fileInfo && fileInfo.lock){
              isAnyFilelocked = true
            }
            if(!['file','page'].includes(fileInfo.asset_type) || fileInfo.state == "GROWING"){
              break;
            }
          }
        }else if(this.selectedFileInfo != undefined && Object.keys(this.selectedFileInfo).includes('asset_type')){
          fileTypes.push(this.selectedFileInfo.asset_type)
          fileStates.push(this.selectedFileInfo.state)
          if('lock' in this.selectedFileInfo && this.selectedFileInfo.lock){
            isAnyFilelocked = true
          }
        }
        if ((fileTypes.length > 0 && !fileTypes.includes("catalog") &&
            !fileTypes.includes("subclip") && !fileStates.includes("GROWING") &&
           !fileStates.includes("MARK FOR DELETE") &&
          this.deploymentBinsList != undefined &&
          this.deploymentBinsList.length > 0 && this.isEnabled("Export Proxy")) &&
          ((isAnyFilelocked && (!('lock_restricted_actions' in this.barcodeInfoFromStartup) ||
           (('lock_restricted_actions' in this.barcodeInfoFromStartup &&
            !this.barcodeInfoFromStartup.lock_restricted_actions.includes("Export Proxy"))))) || !isAnyFilelocked)) {
          conteMenuItems.push({
            sub_menu: "EXPORTPROXYOPTION",
            label: "Export Proxy",
            iconSvgCallback: Utils.getDownloadSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowExportProxySubmenu,
                handler_args: [],
              },
            ],
          });
        }
      },
      attachShareOption(contextMenuItems, multiFiles=false){
        let shareActions = this.getRegisteredShareContextMenu();
        let assetShareActions = this.getContextMenuItems(this.selectedFileInfo, "SHAREACTIONS", multiFiles);
        if(typeof shareActions == "undefined" || typeof assetShareActions == "undefined"){
          return
        }
        if (
          shareActions.length != 0 &&
          assetShareActions.length != 0
        ) {
          contextMenuItems.push({
            sub_menu: "SHAREACTIONS",
            label: "Share",
            iconSvgCallback:Utils.getShareSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowShareSubmenu,
                handler_args: [],
              },
            ],
          });
        }
      },
      attachCatalogIconOption(contextMenuItems, multiFiles=false){
        let assetCatalogIconAction = this.getContextMenuItems(this.selectedFileInfo, "CATALOGICON", multiFiles);
        if(typeof assetCatalogIconAction == "undefined"){
          return
        }
        let contextLabel = "Catalog Thumbnail"
        if(this.selectedFileInfo  && Object.keys(this.selectedFileInfo).length > 0 && 'catalog_type' in this.selectedFileInfo){
          if(this.selectedFileInfo.catalog_type == 'package'){
            return
          }else if(this.selectedFileInfo.catalog_type == 'photo_album'){
            contextLabel = "Cover Photo"
           }
        }
        if (assetCatalogIconAction.length != 0) {
          contextMenuItems.push({
            sub_menu: "CATALOGICON",
            label: contextLabel,
            iconSvgCallback:Utils.getPhotoAlbumSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowCatalogIconSubmenu,
                handler_args: [],
              },
            ],
          });
        }
      },
      attachAIToolOption(contextMenuItems, multiFiles=false){
        let AIToolActions = this.getRegisteredAIToolsContextMenu();
        let assetAIToolActions = this.getContextMenuItems(this.selectedFileInfo, "AITOOLACTIONS", multiFiles);
        if(typeof AIToolActions == "undefined" || typeof assetAIToolActions == "undefined"){
          return
        }
        if (
          AIToolActions.length != 0 &&
          assetAIToolActions.length != 0
        ) {
          contextMenuItems.push({
            sub_menu: "AITOOLACTIONS",
            label: "AI Tools",
            iconSvgCallback:Utils.getAIToolsSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowAIToolsSubmenu,
                handler_args: [],
              },
            ],
          });
        }
      },
      attachOpenWithToolOption(contextMenuItems, multiFiles=false){
        let opneWithActions = this.getRegisteresOpenWithContextMenu();
        let assetOpenWithActions = this.getContextMenuItems(this.selectedFileInfo, "OPENWITHACTIONS", multiFiles);
        if(typeof opneWithActions == "undefined" || typeof assetOpenWithActions == "undefined"){
          return
        }
        if (
          opneWithActions.length != 0 &&
          assetOpenWithActions.length != 0
        ) {
          contextMenuItems.push({
            sub_menu: "OPENWITHACTIONS",
            label: "Open in",
            iconSvgCallback:Utils.getOpenWithSvg,
            onEvents: [
              {
                event_name: "onClick",
                event_handler: this.triggerShowOpenWithoolsSubmenu,
                handler_args: [],
              },
            ],
          });
        }
      },
      triggerShowAIToolsSubmenu(event){
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if (this.showImportSubMenu) {
          this.showImportSubMenu = false;
        }
        if(this.showMoreSubMenu){
          this.showMoreSubMenu = false;
        }
        if(this.showShareSubmenu){
          this.showShareSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        this.showAIToolsSubmenu = true;
  
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuAIToolItems = this.getContextMenuItems(
          this.selectedFileInfo,
          "AITOOLACTIONS",
          multiFiles
        );
        event.stopPropagation();
      },
      triggerShowOpenWithoolsSubmenu(event){
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if (this.showImportSubMenu) {
          this.showImportSubMenu = false;
        }
        if(this.showMoreSubMenu){
          this.showMoreSubMenu = false;
        }
        if(this.showShareSubmenu){
          this.showShareSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        this.showAIToolsSubmenu = false;
        this.showOpenWithToolSubmenu = true;
  
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuOpenWithItems = this.getContextMenuItems(
          this.selectedFileInfo,
          "OPENWITHACTIONS",
          multiFiles
        );
        event.stopPropagation();
      },
      triggerShowShareSubmenu(event) {
        this.showOpenWithToolSubmenu = false
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if (this.showImportSubMenu) {
          this.showImportSubMenu = false;
        }
        if(this.showMoreSubMenu){
          this.showMoreSubMenu = false;
        }
        if(this.showAIToolsSubmenu){
          this.showAIToolsSubmenu = false;
        }
        if(this.showCatalogsIconSubmenu){
          this.showCatalogsIconSubmenu = false;
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        this.showShareSubmenu = !this.showShareSubmenu;
  
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuShareItems = this.getContextMenuItems(
          this.selectedFileInfo,
          "SHAREACTIONS",
          multiFiles
        );
        event.stopPropagation();
      },
      triggerShowCatalogIconSubmenu(event){
        this.showOpenWithToolSubmenu = false
        this.showArchiveToSubMenu = false
        this.showRetrieveFromSubmenu = false
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        if (this.showNewSubMenu) {
          this.showNewSubMenu = false;
        }
        if (this.showImportSubMenu) {
          this.showImportSubMenu = false;
        }
        if(this.showMoreSubMenu){
          this.showMoreSubMenu = false;
        }
        if(this.showAIToolsSubmenu){
          this.showAIToolsSubmenu = false;
        }
        if(this.showShareSubmenu){
          this.showShareSubmenu = false;
        }
        let multiFiles = false
        if (Object.keys(this.selectedFiles).length != 0){
          multiFiles = true
        }
        this.showCatalogsIconSubmenu = !this.showCatalogsIconSubmenu;
  
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuCatalogIconItems = this.getContextMenuItems(
          this.selectedFileInfo,
          "CATALOGICON",
          multiFiles
        );
        event.stopPropagation();
      },
      triggerShowArchiveSubmenu(event){
        this.showMoreSubMenu = false;
        this.showNewSubMenu = false;
        this.showImportSubMenu = false;
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        this.showRetrieveFromSubmenu = false;
        this.showShareSubmenu = false;
        this.showAIToolsSubmenu = false;
        this.showOpenWithToolSubmenu = false
        
        this.showArchiveToSubMenu = !this.showArchiveToSubMenu
  
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuArchiveItems = []
        for (const pool of Object.values(this.getPoolsfromInMem()) ) {
            this.subMenuArchiveItems.push(pool)
        }
        
        event.stopPropagation();
      },
      triggerShowRetrieveSubmenu(event){
        this.showMoreSubMenu = false;
        this.showNewSubMenu = false;
        this.showImportSubMenu = false;
        this.showExportSubMenu = false;
        this.showExportProxySubMenu = false;
        this.showArchiveToSubMenu = false;
        this.showOpenWithToolSubmenu = false;
        this.showShareSubmenu = false;
        this.showAIToolsSubmenu = false;
        
        this.showRetrieveFromSubmenu = !this.showRetrieveFromSubmenu
  
        if(event.clientX > 900){
          this.submenuX = this.x - 190;
        }else{
          this.submenuX = this.x + 100;
        }
        if(event.layerY > 30){
          this.submenuY = event.clientY - 20;
        }else{
          this.submenuY = event.clientY + 20;
        }
        // this.$nextTick(() => {
        //   this.showMenu = true
        // })
        this.subMenuRetrieveItems = []
        for (const pool of Object.values(this.getPoolsfromInMem()) ) {
            this.subMenuRetrieveItems.push(pool)
        }
        
        event.stopPropagation();
      },
      addArchiveToOption(contextMenuItems){
        let enableArchiveToUA = true
        if('ARCHIVE_TO_REQUIRED' in this.getStartUpDataFromInCache()){
          enableArchiveToUA = this.getStartUpDataFromInCache()['ARCHIVE_TO_REQUIRED'];
        }
        if(enableArchiveToUA){
          let hasArchivePrivilege = contextMenuItems.filter((item)=>item.action_name=="Archive"&&item.supportedTypes.includes('file'))
          if (hasArchivePrivilege.length){
              contextMenuItems.push({
                  sub_menu: "ArchiveTo",
                  label: "Archive to",
                  iconSvgCallback: Utils.getArchiveSvg,
                  onEvents: [
                  {
                      event_name: "onClick",
                      event_handler: this.triggerShowArchiveSubmenu,
                      handler_args: [],
                  },
              ],
              })
          }
        }
      },
      addRetrieveFromOption(contextMenuItems){
          let hasRetrievePrivilege = contextMenuItems.filter((item)=>item.action_name=="Retrieve"&&item.supportedTypes.includes('file'))
          if (hasRetrievePrivilege.length){
              contextMenuItems.push({
                  sub_menu: "RetrieveFrom",
                  label: "Retrieve From",
                  iconSvgCallback: Utils.getImportSvg,
                  onEvents: [
                  {
                      event_name: "onClick",
                      event_handler: this.triggerShowRetrieveSubmenu,
                      handler_args: [],
                  },
              ],
              })
          }
      },
      getContextMenuItems(info, submenu="DEFAULT", multiFiles=false){
        let contextMenuItems = []
        let targetFile = {}
        if (multiFiles){
          let selectedFilesState = new Set()
          let selectedMimeType = new Set()
          let selectedPermission = new Set()
          let assetType = "file"
          for (const file_uid of Object.keys(this.selectedFiles)){
            selectedFilesState.add(this.selectedFiles[file_uid].asset_state)
            if(this.selectedFiles[file_uid].asset_type == 'subclip'){
              selectedMimeType.add("video")
              assetType = "subclip"
            }else{
              selectedMimeType.add(this.selectedFiles[file_uid].mime_type.split("/")[0])
            }
            selectedPermission.add(this.selectedFiles[file_uid].permissions)
          }
          let targetState = selectedFilesState.size ==1?Array.from(selectedFilesState)[0]:
                                 selectedFilesState.has("GROWING")?"GROWING":selectedFilesState.has("ERROR")?"ERROR":
                                 selectedFilesState.has("DELETED")?"DELETED":selectedFilesState.has("MARK FOR DELETE")?"MARK FOR DELETE":
                                 selectedFilesState.has("READING")?"READING":selectedFilesState.has("WRITING")?"WRITING":
                                 selectedFilesState.has("LOCKED")?"LOCKED":selectedFilesState.has("READY")?"READY":"READY"
  
          
          let targetMimeType = selectedMimeType.size == 1?Array.from(selectedMimeType)[0]:"unknown"
          let targetPerm = selectedPermission.size == 1?Array.from(selectedPermission)[0]:
                           selectedPermission.has("no-access")?"no-access":selectedPermission.has("default-access")?"default-access":
                           selectedPermission.has("browse")?"browse":selectedPermission.has("read")?"read":
                           selectedPermission.has("read-write")?"read-write":selectedPermission.has("read-modify")?"read-modify":
                           selectedPermission.has("full-control")?"full-control":"no-access"
  
          Object.assign(targetFile,{asset_type: assetType,file_type:assetType, permissions:targetPerm, state:targetState, mime_type: targetMimeType,  "multi_mime_type_list": selectedMimeType})
        }else{
          Object.assign(targetFile, info)
        }
        if (Object.keys(targetFile).length !=0){
          if (Object.keys(targetFile).includes("asset_type")){
            // if (this.isActive != info._id){
            //   this.selectElement(null,info, false)
            // }  
            
            contextMenuItems = this.getContextMenuItemsForAssets(targetFile, submenu, multiFiles);
          }else{
            this.selectCatalog(null,info._id)
            contextMenuItems = this.getContextMenuItemsForCatalog(info,"SelfElement", submenu);
          } 
        }else if(this.isActive ==null){
          contextMenuItems = this.getContextMenuItemsForCatalog(this.selectedCatalog, "ParentElement", submenu)
        }
        return contextMenuItems
      },
      openURLinNewTab(event, fileInfo){
          let url = Utils.getPDFPATHFromFileInfo(fileInfo)
          console.log(`opening URL<${url}> in new tab for ${event} and `, fileInfo)
          window.open(url, "_blank");    
      },
      createViewPDFAction() {
        let events = [{
            event_name: "onClick",
            event_handler: this.openURLinNewTab,
            handler_args: ["fileInfo"],
          },
        ];
  
        let viewPDFAction = new BinContextMenu("viewpdf","View PDF","View PDF",Utils.getClipboardSvg,events,["full-control"],["READY"],"active",["files", "assets"],["file", "folder"],"SelfElement",null,"MOREACTIONS", false, false, ["doc"]);
        viewPDFAction.register();
      },
      showViewPDFAction(fileInfo){
          try {
              if (Utils.getPDFPATHFromFileInfo(fileInfo)){
                  return true
              }
          } catch (error) {
              console.error(`exception-->${error}`)
          }
          return false
      },
      show(event, info) {
        this.showMenu = false;
        this.showMoreSubMenu = false;
        this.showNewSubMenu = false;
        this.showImportSubMenu = false;
        this.showMoreSubMenu = false;
        this.showArchiveToSubMenu = false
        this.showOpenWithToolSubmenu = false
        this.showRetrieveFromSubmenu = false
        this.removeBinMoreContextMenu({id:"viewpdf"})
        if(!this.searchKeyword && ["no-access","browse"].includes(this.currentCatalogPermission.permission) && !['catalog'].includes(info.asset_type)){
          event.preventDefault()
          return false
        }
        let multiFiles;
        if (Object.keys(this.selectedFiles).length == 0){
          multiFiles = false
          if (Object.keys(info).length != 0) {
  
            this.selectElement(null, info,false);
          }
        }else{
          multiFiles = true
        }
        if (!this.eventsAttached) {
            this.setUpContextMenuActions();
        }
  
         event.stopImmediatePropagation();
        // let multiFiles = false;
        // if (Object.keys(this.selectedFiles).length != 0){
        //   multiFiles = true;
        // }
        // if (!multiFiles){
        //     if (this.showViewPDFAction(info)){
        //         this.createViewPDFAction()
        //     }
        // }
        this.contextMenuItems = this.getContextMenuItems(info, "DEFAULT", multiFiles)
        if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length){
          if(this.selectedFileInfo.archived){
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Archive')
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Folder Archive')
          }
          if(this.selectedFileInfo.asset_type == 'subclip' && ((this.selectedFileInfo.subclip_type && this.selectedFileInfo.subclip_type == 'soft') || !this.selectedFileInfo.subclip_type)){
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Archive')
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Retrieve')
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Retrieve As')
          }
        }else if(this.getSelectedMultipleFilesAsList(this.selectedFiles) && this.getSelectedMultipleFilesAsList(this.selectedFiles).length){
          let archivedFiles = this.getSelectedMultipleFilesAsList(this.selectedFiles).filter(e => e.archived);
          if(archivedFiles.length == this.getSelectedMultipleFilesAsList(this.selectedFiles).length){
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Archive')
          }
          let hardSubclipFiles = this.getSelectedMultipleFilesAsList(this.selectedFiles).filter(e => (e.asset_type == 'subclip' && (e.subclip_type && e.subclip_type == 'soft')) || (e.asset_type == 'subclip' && !e.subclip_type));
          if(hardSubclipFiles.length == this.getSelectedMultipleFilesAsList(this.selectedFiles).length){
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Archive')
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Retrieve')
            this.contextMenuItems = this.contextMenuItems.filter(e => e.action_name != 'Retrieve As')
          }
        }
  
        this.addArchiveToOption(this.contextMenuItems)
        // this.addRetrieveFromOption(this.contextMenuItems)
        this.attachMoreOption(this.contextMenuItems, multiFiles)
        this.attachNewOption(this.contextMenuItems, multiFiles)
        this.attachImportOption(this.contextMenuItems, multiFiles)
        this.attachExportOption(this.contextMenuItems, multiFiles)
        this.attachExportProxyOption(this.contextMenuItems, multiFiles)
        this.attachShareOption(this.contextMenuItems, multiFiles)
        this.attachAIToolOption(this.contextMenuItems, multiFiles)
        this.attachOpenWithToolOption(this.contextMenuItems, multiFiles)
        this.attachCatalogIconOption(this.contextMenuItems, multiFiles)
        event.preventDefault();
  
        this.x = event.clientX;
        this.y = event.clientY;
        this.$nextTick(() => {
          this.showMenu = true;
          this.$nextTick(() => {
            this.adjustMainContextMenuPosition();
          });
        });
      },
      adjustMainContextMenuPosition() {
        window.requestAnimationFrame(() => {
          const menuElements = Array.from(
            document.querySelectorAll(".catalog-list-main-context-menu")
          ).reverse();
      
          const menuElement = menuElements.find(element => {
            const rect = element.getBoundingClientRect();
      
            return rect.width > 0 && rect.height > 0;
          });
      
          if (!menuElement || !this.showMenu) {
            return;
          }
      
          const footerElement =
            this.$el && this.$el.querySelector(".catalog-footer-safe");
      
          const footerTop = footerElement
            ? footerElement.getBoundingClientRect().top
            : window.innerHeight;
      
          const menuRect = menuElement.getBoundingClientRect();
          const safeGap = 8;
      
          let adjustedY = this.y;
      
          /*
           * Move the menu upward only when it crosses the footer.
           * For assets in the upper half, the clicked position is retained.
           */
          if (menuRect.bottom > footerTop - safeGap) {
            adjustedY -= menuRect.bottom - (footerTop - safeGap);
          }
      
          /*
           * Do not allow the menu to move outside the top of the screen.
           */
          if (menuRect.top < safeGap) {
            adjustedY += safeGap - menuRect.top;
          }
      
          adjustedY = Math.max(safeGap, adjustedY);
      
          if (adjustedY !== this.y) {
            this.y = adjustedY;
          }
        });
      },
      checkMimetype(privilege, fileInfo){
        if (privilege.supported_mime_types.length !=0){
          
          try {
              if ("multi_mime_type_list" in fileInfo){
                  if (fileInfo["multi_mime_type_list"].size > 1){
                      for (const src_mime_type of fileInfo["multi_mime_type_list"]) {
                          if (!(privilege.supported_mime_types.includes(src_mime_type))){
                              return false
                          }
                      }
                      return true
                  }
              }   
          } catch {
              () => undefined 
          }
          if(fileInfo.asset_type == 'subclip'){
            if(privilege.supported_mime_types.includes('video')){
              return true
            }
          }
          if ("mime_type" in fileInfo){
              for (const mime_type of privilege.supported_mime_types) {
                  if (fileInfo.mime_type.includes(mime_type)){
                      return true 
                  }
              }
          }
          return false
        }else  if(privilege.action_name == "Folder Archive"){
          let lastIndexOfDot = fileInfo.file_name.lastIndexOf('.');
          let extension = fileInfo.file_name.slice(lastIndexOfDot, fileInfo.file_name.length);
          if(fileInfo.mime_type == "application/x-tar" || fileInfo.mime_type=="zip/zip" || [".gz", ".xz"].includes(extension)){
            return true;
          }else{
            return false;
          }  
        }
        return true
      },
      getGroupActions(fileInfo, elementType="SelfElement", submenu="DEFAULT", multiSelect=false){
        let binFilesActionsList = [];
        if (submenu == "MOREACTIONS") {
          binFilesActionsList = this.getRegisteredBinsMoreContextMenu();
        } else if (submenu == "NEWOPTION") {
          binFilesActionsList = this.getRegisteredBinsNewContextMenu();
        } else if (submenu == "IMPORTOPTION") {
          binFilesActionsList = this.getRegisteredBinsImportContextMenu();
        } else if(submenu == "EXPORTOPTION"){
          return this.subMenuExportItems
        } else if(submenu == "EXPORTPROXYOPTION"){
          return this.subMenuExportProxyItems
        } else if(submenu == "ArchiveTo"){
          return this.subMenuArchiveItems
        } else if(submenu == "RetrieveFrom"){
          return this.subMenuRetrieveItems
        } else if(submenu == "SHAREACTIONS"){
          binFilesActionsList = this.getRegisteredShareContextMenu();
        }else if(submenu == "AITOOLACTIONS"){
          binFilesActionsList = this.getRegisteredAIToolsContextMenu();
        }else if(submenu == "OPENWITHACTIONS"){
          binFilesActionsList = this.getRegisteresOpenWithContextMenu();
        }else if(submenu == "CATALOGICON"){
          binFilesActionsList = this.getRegisteredCatalogIconContextMenu();
        }else if(submenu == "EXPORTOPTION"){
          binFilesActionsList = this.getRegisteredExportContextMenu();
        } else {
          binFilesActionsList = this.getRegisteredBinsContextMenu();
        }
        return binFilesActionsList.filter(
        (privilege)=>
        (privilege.supportedResources.includes("assets")) &&
        this.checkMultiSelectPrivilege(privilege, multiSelect) &&
        (privilege.supportedTypes.includes("group")) && (privilege.targetType == elementType) &&
        ((privilege.requiredPermissions.includes(fileInfo.permissions))  || (fileInfo.permissions == "full-control" )))
      },
      getFilesActions(fileInfo, elementType="SelfElement", submenu="DEFAULT", multiSelect=false){
        let binFilesActionsList = [];
        if (submenu == "MOREACTIONS") {
          binFilesActionsList = this.getRegisteredBinsMoreContextMenu();
          try{
            if(fileInfo && Object.prototype.hasOwnProperty.call(fileInfo,'mime_type') 
                && ['image'].indexOf(Utils.getMediaType(fileInfo.mime_type)) == -1){
                 binFilesActionsList =  binFilesActionsList.filter(op => op && op.action_name != 'manage-asset-annotaion');
            }
          }catch(e){console.log(e)}
        } else if (submenu == "NEWOPTION") {
          binFilesActionsList = this.getRegisteredBinsNewContextMenu();
        } else if (submenu == "IMPORTOPTION") {
          binFilesActionsList = this.getRegisteredBinsImportContextMenu();
        } else if(submenu == "EXPORTOPTION"){
          binFilesActionsList = this.getRegisteredExportContextMenu();
        } else if(submenu == "EXPORTPROXYOPTION"){
          console.log("Ignore this case, As no other user actions will be servered from server for EXPORTPROXYOPTION")
        } else if(submenu == "ArchiveTo"){
          return this.subMenuArchiveItems
        } else if(submenu == "RetrieveFrom"){
          return this.subMenuRetrieveItems
        } else if(submenu == "SHAREACTIONS"){
          binFilesActionsList = this.getRegisteredShareContextMenu();
        }else if(submenu == "AITOOLACTIONS"){
          binFilesActionsList = this.getRegisteredAIToolsContextMenu();
        }else if(submenu == "OPENWITHACTIONS"){
          binFilesActionsList = this.getRegisteresOpenWithContextMenu();
        }else if(submenu == "CATALOGICON"){
          binFilesActionsList = this.getRegisteredCatalogIconContextMenu();
        } else {
          binFilesActionsList = this.getRegisteredBinsContextMenu();
          // if(this.rootPathPermission &&'catalog_type' in this.rootPathPermission && ){
            if(this.rootPathPermission){
              if(this.rootPathPermission.name_path == 'catalog://0/CATALOG'){
                binFilesActionsList = binFilesActionsList.filter(op=>!['Set as Cover Photo', 'Remove from Package', 'Remove from Photo Album'].includes(op.label))
              }else if('catalog_type' in this.rootPathPermission && this.rootPathPermission.catalog_type){
                if(this.rootPathPermission.catalog_type == 'package'){
                  binFilesActionsList = binFilesActionsList.filter(op=>!['Set as Cover Photo', 'Remove from Photo Album'].includes(op.label))
                }else if(this.rootPathPermission.catalog_type == 'photo_album'){
                  binFilesActionsList = binFilesActionsList.filter(op=>!['Remove from Package'].includes(op.label))
                }else{
                  binFilesActionsList = binFilesActionsList.filter(op=>!['Remove from Package', 'Remove from Photo Album'].includes(op.label))
                }
              }else{
                binFilesActionsList = binFilesActionsList.filter(op=>!['Remove from Package', 'Remove from Photo Album'].includes(op.label))
              }
            }
        }
  
        let removeLockAction = false;
        let removeUnlockAction = false;
        let isFileTypePagePresent = false;
        if(multiSelect){
          let lockedFileEntries = [];
          let unlockedFileEntries = [];
          for(let _id in this.selectedFiles){
            if(this.selectedFiles[_id].asset_type == 'page' && !isFileTypePagePresent){
              isFileTypePagePresent = true
            }
            if(this.selectedFiles[_id].asset_type == 'subclip'){
              removeLockAction = true;
              removeUnlockAction = true;
              break
            }
            if('lock' in this.selectedFiles[_id] && this.selectedFiles[_id].lock){
              lockedFileEntries.push(_id);
            }else{
              unlockedFileEntries.push(_id);
            }
          }
          if(lockedFileEntries.length > 0 && unlockedFileEntries.length > 0){
            //Selected files are the combination of lock,Unlock hence removing the actions
            removeLockAction = true;
            removeUnlockAction = true;
          }else if(lockedFileEntries.length > 0 && unlockedFileEntries.length == 0){
            //Selected files are Only locked files, hence enabling only Unlock action to Unlock
            removeLockAction = true;
            removeUnlockAction = false;
          }else if(lockedFileEntries.length == 0 && unlockedFileEntries.length > 0){
            //Selected files are Only Unlocked files, hence enabling only lock action to lock
            removeLockAction = false;
            removeUnlockAction = true;
          }
        }else{
          if(fileInfo && 'lock' in fileInfo && fileInfo.lock){
            removeLockAction = true
          }else if(fileInfo && ('lock' in fileInfo && !fileInfo.lock) || !('lock' in fileInfo)){
            removeUnlockAction = true
          }
          if(fileInfo.asset_type == 'page'){
            isFileTypePagePresent = true
          }
        }
        if(removeLockAction){
          binFilesActionsList = binFilesActionsList.filter(op=>!['Lock'].includes(op.label))
          //Restrict the useraction that are configured from 'Locked Files' global settings
          binFilesActionsList = binFilesActionsList.filter(op=>!('lock_restricted_actions' in this.barcodeInfoFromStartup && this.barcodeInfoFromStartup.lock_restricted_actions.includes(op.id)))
        }
        if(removeUnlockAction){
          binFilesActionsList = binFilesActionsList.filter(op=>!['Unlock'].includes(op.label))
        }
        if(isFileTypePagePresent){
          binFilesActionsList = binFilesActionsList.filter(op=>!['Set as Cover Photo', 'Remove from Package', 'Remove from Photo Album', 'Review', 'Download Proxy', 'in Hype'].includes(op.label))
        }
        return binFilesActionsList.filter(
          (privilege)=>
          (((privilege.supportedResources.includes("assets") && fileInfo.asset_type != 'subclip') ||
            (privilege.supportedResources.includes("subclip") && fileInfo.asset_type == 'subclip') ||
            (privilege.supportedResources.includes("pages") && fileInfo.asset_type == 'page'))) &&
          this.checkMultiSelectPrivilege(privilege, multiSelect) &&
          this.checkMimetype(privilege, fileInfo, multiSelect) &&
          (privilege.supportedTypes.includes("file") || privilege.supportedTypes.includes("page")) && (privilege.targetType == elementType) && 
          (privilege.requiredPermissions.includes(fileInfo.permissions)) &&
          (privilege.requiredStates.includes(fileInfo.state) || privilege.requiredStates.includes(fileInfo.asset_state))) 
      },
      getContextMenuItemsForCatalog(catalog, elementType="SelfElement", submenu="DEFAULT"){
        let currentCatalogDetails = this.currentCategoryInfo;
        if(typeof currentCatalogDetails == "undefined" || Object.keys(currentCatalogDetails).length <= 0){
          currentCatalogDetails = catalog;
        }
        if (this.selectedFileInfo && this.selectedFileInfo.asset_type == "catalog" &&  this.isActive == this.selectedFileInfo._id){
          currentCatalogDetails = catalog
        }
        if (Object.keys(currentCatalogDetails).length != 0) {
          // let catalogAccessRight = this.getCatalogAccessRight(currentCatalogDetails)
          //let accessRight = {permissions : "no-access"}
          let accessRight = {}
          Object.assign(accessRight, currentCatalogDetails)
          // try {
          //   if (catalogAccessRight.length != 0){
          //     accessRight.permissions = catalogAccessRight[0]["access_right"]
          //   }
          // } catch (error) {
          //   console.error(`[getCurrentCatalogActions][CatalogsDisplay][Error occurred while getting catalog permission->${error}]`)
          //   accessRight.permissions = "no-access"
          // }
          let binFilesActionsList = [];
          if (submenu == "MOREACTIONS") {
            binFilesActionsList = this.getRegisteredBinsMoreContextMenu();
          } else if (submenu == "NEWOPTION") {
            let appendNewContxtMenu = true
            if(this.rootPathPermission &&
              'catalog_type' in this.rootPathPermission &&
              ['photo_album','package'].includes(this.rootPathPermission.catalog_type)){
                appendNewContxtMenu = false
            }
            if(appendNewContxtMenu){
              binFilesActionsList = this.getRegisteredBinsNewContextMenu();
            }
          }  else if (submenu == "IMPORTOPTION") {
            binFilesActionsList = this.getRegisteredBinsImportContextMenu();
          }
          else if(submenu == "EXPORTOPTION"){
            binFilesActionsList = this.getRegisteredExportContextMenu();
          } else if(submenu == "EXPORTPROXYOPTION"){
            console.log("Ignore this case, As no other user actions will be servered from server for EXPORTPROXYOPTION")
          } else if(submenu == "ArchiveTo"){
              return this.subMenuArchiveItems
          } else if(submenu == "RetrieveFrom"){
              return this.subMenuRetrieveItems
          } else if(submenu == "SHAREACTIONS"){
            binFilesActionsList = this.getRegisteredShareContextMenu();
          }else if(submenu == "AITOOLACTIONS"){
            binFilesActionsList = this.getRegisteredAIToolsContextMenu();
          }else if(submenu == "OPENWITHACTIONS"){
            binFilesActionsList = this.getRegisteresOpenWithContextMenu();
          }else if(submenu == "CATALOGICON"){
            binFilesActionsList = this.getRegisteredCatalogIconContextMenu();
            if((!('catalog_cover_photo_file_uid' in currentCatalogDetails) ||
                currentCatalogDetails.catalog_cover_photo_file_uid.trim() <= 0)){
              binFilesActionsList = binFilesActionsList.filter(op=> !(['Remove Cover Photo','Remove Thumbnail'].includes(op.label)))
            }
          } else {
            binFilesActionsList = this.getRegisteredBinsContextMenu();
          }
          let privList = []
          for(let privilege of binFilesActionsList){
            if(((currentCatalogDetails.catalog_type != 'photo_album' && privilege.supportedResources.includes("catalogs")) ||
                (['photo_album','package'].includes(currentCatalogDetails.catalog_type) &&
                 privilege.supportedResources.includes(currentCatalogDetails.catalog_type)) ) && (this.selectedFileInfo.asset_type != 'subclip') &&
              (privilege.targetType == elementType) && (privilege.requiredStates.includes(currentCatalogDetails.asset_state)) &&
              (privilege.requiredPermissions.includes(accessRight.permissions))){
              if(privilege.action_name == 'Move Catalog'){
                if(currentCatalogDetails.catalog_type && currentCatalogDetails.catalog_type == 'photo_album'){
                  privilege.label = "Move Photo Album"
                }else if(currentCatalogDetails.catalog_type && currentCatalogDetails.catalog_type == 'package'){
                  privilege.label = "Move Package"
                }else{
                  privilege.label = "Move Catalog"
                }
              }
                privList.push(privilege)
            }
          }
          return privList
        }
      },
      getContextMenuItemsForAssets(fileInfo, submenu, multiFiles=false){
        if (fileInfo.asset_type == "group"){
          return this.getGroupActions(fileInfo, 'SelfElement', submenu, multiFiles)
        }else if(["file","subclip", "page"].includes(fileInfo.asset_type)){
          return this.getFilesActions(fileInfo, 'SelfElement', submenu, multiFiles)
        }else{
          if (fileInfo.asset_type == "catalog" && this.isActive == fileInfo._id){
            return this.getContextMenuItemsForCatalog(fileInfo, "SelfElement", submenu)
          }else{
            return this.getContextMenuItemsForCatalog(this.selectedCatalog, "SelfElement", submenu)
          }
        }
      },
      getSvgIconsForContextMenu(menu){
          if (menu.includes("Download"))return Utils.getDownloadSvg();
          if (menu.includes("Generate Proxy"))return Utils.getDoubleSideArrow();
          if (menu.includes("Upload") || menu.includes("Upload Version")) return Utils.getUploadSvg();
          if(menu.includes("Update Version")) return Utils.getAssetUpdateVersionSvg();
          if (menu.includes("tag-metadata") || menu.includes("Bulk Tag Metadata"))return Utils.getTagSvg();
          if (menu.includes("Modify TTL")) return Utils.getModifyTTLSvg();
      },
      getHoverMenuActionIcon(menuName){
        return Utils.getHtmlOfSvgIconForContextMenu(menuName)
      },
      getSvgIconsOfMediaTypes(path,type){
        return Utils.determineSvgIconForType(path,type)
      },
      getSvgIconForCoverPhoto(type){
        return Utils.getSVGIconsBasedOnType(type)
      },
      getCatalogAccessRight(catalog){
        let accessRight = this.getLoggedInUserAccessControl.categories.filter((catalogAccessRight)=>(catalogAccessRight.catalog_id == catalog._id) )
        return accessRight.length != 0?accessRight:this.getLoggedInUserAccessControl.categories.filter((catalogAccessRight)=>(catalogAccessRight.catalog_id == this.workspace && this.workspace == 'Projects'?this.rootCatalogInfo._id:this.getRootElement()._id) )
      },
      getRootElement() {
        return Object.assign({}, this.rootElement);
      },
      selectCatalog(event, id) {
        if (event != null){
          event.stopImmediatePropagation()
        }
        this.closeContextMenu()
        this.isActive = id;
      },
      isCatalogExists(catalogName, pid){
        let catalogInfo = this.children.filter(
                        (catalog)=>(catalog.name==catalogName)&&
                                  (catalog.pid==pid)
                        )
        if (Object.keys(catalogInfo).length !=0){
          return true
        }
        return false
      },
      getSelectedAssetsCount(){
        let countInfo = {}
        if(Object.keys(this.selectedFileInfo).length){
          let opKey = "Selected File"
          let fVal = ""
          if(this.selectedFileInfo.asset_type == 'catalog'){
            opKey = "Selected Catalog"
            fVal = this.selectedFileInfo["catalog_name"]
          }else if('slug_name' in this.selectedFileInfo){
            fVal = this.selectedFileInfo.slug_name
          }else if('file_name' in this.selectedFileInfo){
            fVal = this.selectedFileInfo["file_name"]
          }
          countInfo[opKey] = "1 ("+ fVal + ")"
        }else if(Object.keys(this.selectedFiles).length){
          let fList = []
          let cList = []
          for(let obKey of Object.keys(this.selectedFiles)){
            let fInfo = this.selectedFiles[obKey]
            if(fInfo.asset_type == 'catalog'){
              cList.push(fInfo["catalog_name"])
            }else if('slug_name' in fInfo){
              fList.push(fInfo.slug_name)
            }else if('file_name' in fInfo){
              fList.push(fInfo["file_name"])
            }
          }
          if(fList.length > 0){
            let opKey = "Selected File";
            if(fList.length > 1){
              opKey += "s"
            }
            countInfo[opKey] = fList.length
          }
          if(cList.length > 0){
            let opKey = "Selected Catalog";
            if(cList.length > 1){
              opKey += "s"
            }
            countInfo[opKey] = cList.length
          }
        }
        return countInfo
      },
      compareValuesOfCustomMetadata(fieldsInSearch,fieldsInAssetInfo){
        for(let i = 0; i < fieldsInAssetInfo.length; i++){
          if((fieldsInAssetInfo[i].type == "INTEGER" || fieldsInAssetInfo[i].type == "FREETEXT" || fieldsInAssetInfo[i].type == "PICKLIST") && fieldsInSearch[fieldsInAssetInfo[i].key_id] == fieldsInAssetInfo[i].value[0]
           || fieldsInAssetInfo[i].type == "DATE" && this.checkDateInBetweenTwoDates(fieldsInSearch[fieldsInAssetInfo[i].key_id].from_value,fieldsInSearch[fieldsInAssetInfo[i].key_id].to_value,fieldsInAssetInfo[i].value[0])
           || fieldsInAssetInfo[i].type == "PICKLIST_MULTIVALUE" && this.findElementInArrayFromAnotherArray(JSON.parse(fieldsInSearch[fieldsInAssetInfo[i].key_id]),fieldsInAssetInfo[i].value)){
              return true;
          }
          return false;
        }
      },
      findElementInArrayFromAnotherArray(array1, array2, catalogId){
        for(let i = 0; i< array2.length; i++){
            if(catalogId){
              array2[i] = array2[i] + "/" + catalogId;
            }
            let aIndex = array1.findIndex(e=>e == array2[i]);
            if(aIndex > -1){
              return true;
            }
            return false;
        }
      },
      formatDateToCompare(input) {
        let datePart = input.match(/\d+/g),
        year = datePart[0],
        month = datePart[1], day = datePart[2];
  
        return day+'/'+month+'/'+year;
      },
      checkDateInBetweenTwoDates(from,to,toCheck){
        let dateFrom = this.formatDateToCompare(from);
        let dateTo = this.formatDateToCompare(to);
        let dateCheck = this.formatDateToCompare(toCheck);
  
        let d1 = dateFrom.split("/");
        let d2 = dateTo.split("/");
        let c = dateCheck.split("/");
  
        let fromDate = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
        let toDate   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
        let check = new Date(c[2], parseInt(c[1])-1, c[0]);
  
        if(check >= fromDate && check <= toDate){
          return true;
        }
        return false;
      },
      sortfilesByDate(){
        this.assetsList.sort((first, second)=>{
                let d1 = new Date(first.modified_datetime)
                let d2 = new Date(second.modified_datetime)
                return d2 - d1;
              })
      },
      addAssetToList(asset_info, sort_by_date=false){
        // this.assetsList = this.assetsList.filter((asset)=>asset.parent_id_path[0].endsWith(this.selectedCatalog._id))
        let asset_exists = this.assetsList.filter((asset)=>asset._id==asset_info._id);
        if (asset_exists.length==0){
            this.assetsList.push(asset_info)
            if(this.promiseAssetsList && this.promiseAssetsList.assetsArrayOnResolve)this.promiseAssetsList.assetsArrayOnResolve.resolve(this.assetsList);
          if (sort_by_date){
            this.sortfilesByDate()
          }
        }   
        // if("master_asset_id" in asset_info && asset_info.master_asset_id != null){
        //   let asset_id_check = this.assetsList.filter((asset)=>asset._id==asset_info.master_asset_id)
        //    if(asset_id_check.length > 0){
        //       if(asset_info.master_asset_id == asset_id_check[0]._id){
        //         alert("ues")
        //         asset_id_check[0].subclips_present = true;
        //       }
        //     }
        //   } //Subclip icon display is removed from backend
      },
      updateAssetInList(asset_info, sort_by_date=false){
        if(this.barcodeInfoFromStartup.enable_department && this.$refs['departmentsComponent'] && this.$refs['departmentsComponent'].getAllDepartmentsList()){
          let departmentsArr = this.$refs['departmentsComponent'].getAllDepartmentsList();
          if(this.selectedProjectsArr && ((asset_info.department_info && asset_info.department_info._id && asset_info.department_info._id.length > 0 && ((this.selectedProjectsArr.includes('all') && departmentsArr.includes(asset_info.department_info._id)) || (this.selectedProjectsArr.length > 0 && this.selectedProjectsArr.includes(asset_info.department_info._id))))
          || this.selectedProjectsArr.includes('all'))){
            let indx = this.assetsList.findIndex((asset)=>asset._id==asset_info._id)
            if (indx >= 0){
              if(!('version_id' in asset_info) && 'latest_version_id' in asset_info){
                asset_info['version_id'] = asset_info['latest_version_id']
              }
              this.$set(this.assetsList, indx, { ...asset_info });
              this.assetsList = [...this.assetsList];
                if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0 && this.selectedFileInfo.asset_id == asset_info.asset_id){
                  this.$set(this.selectedFileInfo, "custom_metadata", asset_info.custom_metadata);
                }
              if (sort_by_date){
                this.sortfilesByDate()
              }
            }
          }else{
            this.assetsList = this.assetsList.filter((asset)=>asset._id!=asset_info._id)
          }
        }else{
          let indx = this.assetsList.findIndex((asset)=>asset._id==asset_info._id)
          if (indx >= 0){
            this.$set(this.assetsList, indx, { ...asset_info });
            this.assetsList = [...this.assetsList];
              if(this.selectedFileInfo && Object.keys(this.selectedFileInfo).length > 0 && this.selectedFileInfo.asset_id == asset_info.asset_id){
                  this.$set(this.selectedFileInfo, "custom_metadata", asset_info.custom_metadata);
                }
            if (sort_by_date){
              this.sortfilesByDate()
            }
          }
        }
      },
      // functionCallAfterSearchFieldsChange(searchQuery,keyword){
      //     this.advanceSearchKeys = searchQuery;
      //     this.searchKeyword = keyword;
      //     this.refreshAssetsList(this.selectedCatalog)
      // },
      // functionCallForGlobalKeywordSearch(keyword){
      //     this.searchKeyword = keyword;
      //     this.refreshAssetsList(this.selectedCatalog)
      // },
      refreshAssetsList(catalogInfo = {}) {
        this.isLoaded = false
        let payload = { params: {} };
        payload.params.page = this.currentPage;
        payload.params.view_type = "list";
        payload.params.sort_by= this.sortBy.sortOn;
        payload.params.sort_order= this.sortBy.ascDesc;
        payload.params.browse = true;
        if (Object.keys(catalogInfo).length != 0) {
          let alreadyInCatalog = false;
          for (let dir of this.catalogTraverseStructure) {
            if (dir._id === catalogInfo._id) {
              alreadyInCatalog = true;
            }
          }
          
          if (!alreadyInCatalog) {
            if(Object.hasOwnProperty.call(catalogInfo,'catalog_name') && catalogInfo.catalog_name != 'undefined'){
                this.catalogTraverseStructure.push({ 
                      _id: catalogInfo._id, 
                      file_name: catalogInfo.catalog_name,
                      pid: catalogInfo.pid, 
                      catalog_name:catalogInfo.catalog_name,
                      permissions:catalogInfo.permissions,
                      catalog_type:catalogInfo.catalog_type,
                      asset_state: catalogInfo.asset_state
                });
                if (this.selectedCatalog._id != catalogInfo._id){
                  this.selectedCatalog = Object.assign({}, { 
                    _id: catalogInfo._id, 
                    file_name: catalogInfo.catalog_name,
                    pid: catalogInfo.pid, 
                    catalog_name:catalogInfo.catalog_name,
                    permissions:catalogInfo.permissions,
                    catalog_type:catalogInfo.catalog_type,
                    asset_state: catalogInfo.asset_state
                  })
                }
                
              this.setSelectedCategoryInCategoryBrowse(this.selectedCatalog)
            }
          }
        } else {
          if(this.selectedCatalog && this.selectedCatalog._id);
          // if("parent_id_path" in this.selectedCatalog){
          //    this.setLocationHash({type:"catalog-browse", catalog_id: this.selectedCatalog._id, catalog_name: this.selectedCatalog.catalog_name, catalog_pid:this.selectedCatalog.parent_id_path[0]})
          // }else{
          //    this.setLocationHash({type:"catalog-browse", catalog_id: this.selectedCatalog._id, catalog_name: this.selectedCatalog.name, catalog_pid:this.selectedCatalog.pid})
          // }
        }
        payload.params.catalog_id = this.selectedCatalog._id;
        if (this.searchKeyword && (this.searchKeyword != null && this.searchKeyword != undefined) && this.searchKeyword.length){
          payload.params.keyword = this.searchKeyword;
          delete payload.params.browse;
        }else{
          delete payload.params.keyword 
        }
  
        let fileStateFromFilter = JSON.parse(localStorage.getItem('file-status-filter-state'));
        if(this.fileStateCheck && this.fileStateCheck.state.length){
          payload.params.state = JSON.stringify(this.fileStateCheck.state);
        }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length){
          if(fileStateFromFilter.state && fileStateFromFilter.state.length){
            payload.params.state = JSON.stringify(fileStateFromFilter.state);
          }
        }else{
          delete payload.params.state;
        }
        
        if(this.fileStateCheck && this.fileStateCheck.storage_class.length){
          payload.params.storage_class = JSON.stringify(this.fileStateCheck.storage_class);
        }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
          if(fileStateFromFilter.storage_class && fileStateFromFilter.storage_class.length){
            payload.params.storage_class = JSON.stringify(fileStateFromFilter.storage_class);
          }
        }else{
          delete payload.params.storage_class;
        }
  
        if(this.fileStateCheck && this.fileStateCheck.filter && this.fileStateCheck.filter.length > 0){
          if(typeof(fileStateFromFilter.filter) == 'string'){
            payload.params.filter = this.fileStateCheck.filter;
          }else{
            payload.params.filter = JSON.stringify(this.fileStateCheck.filter);
          }
        }else if(fileStateFromFilter && Object.keys(fileStateFromFilter).length>0){
          if(fileStateFromFilter.filter && fileStateFromFilter.filter.length > 0){
            if(typeof(fileStateFromFilter.filter) == 'string'){
              payload.params.filter = fileStateFromFilter.filter;
            }
            else{
              payload.params.filter = JSON.stringify(fileStateFromFilter.filter);
            }
          }
        }else{
          delete payload.params.filter;
        }
        
       if(this.advanceSearchKeys != undefined && Object.keys(this.advanceSearchKeys).length){
            if('fields' in this.advanceSearchKeys && Object.keys(this.advanceSearchKeys.fields).length == 0){
                if(Object.keys(this.advanceSearchKeys).length > 1){
                  payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
                  delete payload.params.browse;
                }
            }else{
                payload.params = Object.assign({},payload.params,this.advanceSearchKeys);
                delete payload.params.browse;
            }
          if(Object.keys(this.advanceSearchKeys).includes("fields") && Object.keys(this.advanceSearchKeys.fields).length == 0){
            delete payload.params.fields;
          }
        }
  
        if(this.barcodeInfoFromStartup.enable_department && Utils.getLocalStorageValue('selectedDepartmentsArr') && Utils.getLocalStorageValue('selectedDepartmentsArr').length > 0){
          if(JSON.parse(Utils.getLocalStorageValue('selectedDepartmentsArr').includes('all'))){
            payload.params['department'] = 'all';
          }else{
            payload.params['department'] = Utils.getLocalStorageValue('selectedDepartmentsArr');
          }
        }else if(payload.params.department){
          delete payload.params.department;
        }
  
        if(this.isNLPSearchMode && this.barcodeInfoFromStartup.enable_nlp_search){
          payload['nlp_search'] = true;
          if(this.barcodeInfoFromStartup.selected_model_for_nlp){
            payload.params['ai_model'] = this.barcodeInfoFromStartup.selected_model_for_nlp;
          }else{
            payload.params['ai_model'] = '';
          }
        }
        
        payload.params.limit = this.perPage;
  
        Utils.saveFolderHistory(this.catalogTraverseStructure)
        this.getAllAssetsFromServer(payload).then((data) => {
          console.log(`[getAllAssetsFromServer]`,data);
          if(data && typeof data == 'string' && data == "REQUEST_CANCELLED_BY_FUSION"){
            return;
          }
          this.totalPages = data["page_count"];
          this.currentPage = data["page"];
          this.page = data["page"];
          this.totalAssets = data["total_assets"];
          // this.perPage = data["limit"];
          this.assetsPerpage = data["assets_per_page"]
          this.assetsList = [];
          this.children = [];
          for (const asset of data.assets) {
            if(asset.asset_type == 'catalog'){
              this.addCatalogInfoToChildren(asset);
            }else{
              this.addAssetToList(asset)
            }
          }
          this.isLoaded = true
          if("root_path_permissions" in data){
            this.currentCatalogPermission = data["root_path_permissions"];
            this.$emit("rootPathPermissionUpdated",this.currentCatalogPermission);
          }
          this.$nextTick(() => {
             this.scrollToTheSelectedFile();
          });
          
        });
      },
      totalAssetsDisplay(totalFiles){
        return Utils.displayTotalPageCountWithRange(totalFiles,this.assetsPerpage,this.currentPage);
      },
      changeToCatalogFromUrl(catalogInfo) {
        this.closeContextMenu();
        if ((this.workspace && this.workspace == 'Projects' && this.rootCatalogInfo._id == catalogInfo._id) || catalogInfo._id == this.getRootElement()._id ) {
          this.currentCategoryInfo = {}
          this.selectedCatalog = this.workspace && this.workspace == 'Projects'?this.rootCatalogInfo:this.getRootElement();
          this.setSelectedCategoryInCategoryBrowse(this.selectedCatalog)
          this.catalogTraverseStructure = [{ _id: this.selectedCatalog._id, file_name: this.selectedCatalog.catalog_name, pid: this.selectedCatalog.parent_id_path[0], catalog_name:this.selectedCatalog.catalog_name, permissions:this.selectedCatalog.permissions}];
          // this.updateCatalogChildren(catalogInfo._id).then(()=>{
            this.refreshAssetsList();
          // })
        } else {
          let newStructure = [];
          for (let dir of this.catalogTraverseStructure) {
            if (dir._id === catalogInfo._id) {
              // this.getFileInfoFromServer({params:{fileId:fileInfo._id}}).then((data)=>{
              //   this.currentCategoryInfo = data.file
              // })
              break;
            } else {
              newStructure.push(dir);
            }
          }
          this.catalogTraverseStructure = newStructure;
          // this.updateCatalogChildren(catalogInfo._id).then(()=>{
            this.refreshAssetsList(catalogInfo);
          // })
        }
        // this.unselectElement()
        if(this.lastClosedDialogMap.isAssetUnselectRequired){
           this.unselectElement()
          //  this.lastClosedDialogMap.isAssetUnselectRequired = true;
        }
      },
      initBrowse() {
          this.selectedCatalog = this.workspace && this.workspace == 'Projects'?this.rootCatalogInfo:this.getRootElement();
        if(Object.hasOwnProperty.call(this.selectedCatalog,'catalog_name') && this.selectedCatalog.catalog_name != 'undefined'){
            this.setSelectedCategoryInCategoryBrowse(this.selectedCatalog)
            let catalogInfo = { _id: this.selectedCatalog._id, file_name: this.selectedCatalog.catalog_name , pid: this.selectedCatalog.parent_id_path[0], catalog_name:this.selectedCatalog.catalog_name, catalog_type:this.selectedCatalog.catalog_type, asset_state: this.selectedCatalog.asset_state};
            this.catalogTraverseStructure.push(catalogInfo);
        }
        this.refreshAssetsList();
        // this.setLocationHash({
        //         type:"catalog-browse",
        //         catalog_id: this.selectedCatalog._id, 
        //         catalog_name: this.selectedCatalog.catalog_name,
        //         catalog_pid: this.selectedCatalog.pid
        // });
      },
      getMimeType(type){
        let givenType = type.split("/")[0];
        if(givenType == "application"){
          givenType = "app";
        }
        return givenType;
      },
      loadData(catalogInfo={}) {
        this.closeContextMenu()
        if (this.isdestroyed){
          return
        }
        if (Object.keys(catalogInfo).length == 0){
          if (this.selectedCatalog != null){
            this.setSelectedCategoryInCategoryBrowse(this.selectedCatalog)
          }
        } else{
          Object.assign(this.selectedCatalog, catalogInfo)
          this.setSelectedCategoryInCategoryBrowse(this.selectedCatalog)
        }
        if (Object.keys(this.selectedCatalog).length != 0) {
          if(this.workspace && this.workspace == 'Projects'){
            let traverseData = Utils.getCookieValue("traverseHistory");
              if (traverseData != null){
                this.catalogTraverseStructure = traverseData
              }
          }
            if (this.loadFromCookie){
              let traverseData = Utils.getCookieValue("traverseHistory")
              if (traverseData != null){
                if (this.catalogTraverseStructure.length ==0){
                  this.catalogTraverseStructure = traverseData
                }
              }
              this.loadFromCookie = false
            }
            this.changeToCatalogFromUrl(catalogInfo);
        }
        else {
          this.initBrowse();
        }
      },
      updatedSelectedProjectsArr(projectIds){
        this.selectedProjectsArr = projectIds;
        this.page = 1;
        this.refreshAssetsList(this.selectedCatalog);
      },
      async setRootElement(){
        let payload = {params:{catalog_id: Constants.rootCategory,asset_type:"catalog"}}
        let data = await this.getAllAssetsFromServer(payload);
        if (Constants.acceptedStatusCodes.includes(data.statusCode)){
          this.rootElement = data.assets[0]
          if("root_path_permissions" in data){
            this.currentCatalogPermission = data["root_path_permissions"];
            this.$emit("rootPathPermissionUpdated",this.currentCatalogPermission);
          }
        }
      },
      addCatalogInfoToChildren(catalog_info, newlyCreatedCatalog = false){
        let catalog_exists = this.children.filter((catalog)=>catalog._id==catalog_info._id)
        if (catalog_exists.length==0){
          if(newlyCreatedCatalog){
            this.children.unshift(catalog_info)
          }else{
            this.children.push(catalog_info)
          }
        }
      },
      updateCatalog(catalogInfo){
        let catIndex = this.children.findIndex((catalog)=>catalog._id==catalogInfo._id)
        if (catIndex >= 0){
          this.children[catIndex] = catalogInfo
        }
      },
      async updateCatalogChildren(pid){
        let payload={ params: {page:1, catalog_id: pid,asset_type:"catalog",browse:"true" } }
        let data = await this.getAllAssetsFromServer(payload)
        if (Constants.acceptedStatusCodes.includes(data.statusCode)){
          this.children = []
          // for (const catalog_info of data.assets) { //Commented as asset_type check is noy added
          //   this.addCatalogInfoToChildren(catalog_info)
          // }
          for (const catalog_info of data.assets) {
            if(catalog_info.asset_type == 'catalog'){
              this.addCatalogInfoToChildren(catalog_info);
            }else{
              this.addAssetToList(catalog_info)
            }
          }
          if("root_path_permissions" in data){
            this.currentCatalogPermission = data["root_path_permissions"];
            this.$emit("rootPathPermissionUpdated",this.currentCatalogPermission);
          }
        }
      },
      changeJobsPanelState(state){
        this.$emit('changeJobsPanelState',state)
      },
      handleCatalogCreateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let CatalogName = notification.message.catalog_name
          let notificationMessage = notification.message;
          if(Object.keys(notificationMessage).includes("parent_id_path") &&
            typeof notificationMessage.parent_id_path != undefined && notificationMessage.parent_id_path.length > 0){
            let category_parent_id = notificationMessage.parent_id_path[0]
            if (category_parent_id.endsWith(this.selectedCatalog._id)){
              this.addCatalogInfoToChildren(notification.message, true)
              console.log(`[handleCatalogCreateNotification][CatalogDisplay][New Catalog(<${CatalogName}>)]`)
            }
          }
        }
      },
      handleCatalogUpdateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let CatalogName = notification.message.catalog_name
          let CatalogId = notification.message._id
          let notificationMessage = notification.message;
          if(Object.keys(notificationMessage).includes("parent_id_path") &&
            typeof notificationMessage.parent_id_path != undefined && notificationMessage.parent_id_path.length > 0){
            let category_parent_id = notificationMessage.parent_id_path[0]
            if (category_parent_id.endsWith(this.selectedCatalog._id)){
              let indx = this.children.findIndex((catalog)=>catalog._id==CatalogId)
              if (indx >= 0){
                this.children[indx] = notification.message;
                console.log(`[handleCatalogUpdateNotification][CatalogDisplay][Catalog(<${CatalogName}>) updated]`)
                if (notificationMessage.asset_state == "MARK FOR DELETE"){
                  let assetStateFromFilter = JSON.parse(localStorage.getItem('file-status-filter-state'));
                  if(assetStateFromFilter && Object.keys(assetStateFromFilter).length){
                    if(assetStateFromFilter.state && !(assetStateFromFilter.state.includes('MARK FOR DELETE'))){
                      this.handleAssetRemovedNotification(notification)
                    }
                  }
                }
                this.$forceUpdate();
              }
            }
          }
        }
      },
      handleCatalogRemovedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let CatalogId = notification.message._id
          this.children = this.children.filter((catalog)=>catalog._id!=CatalogId)
          console.log(`[handleCatalogRemovedNotification][CatalogDisplay][Catalog(<${CatalogId}>) Removed]`)
          this.unselectElement()
        }
      },
      handleAssetCreatedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let asset_id = notification.message._id
          let notificationMessage = notification.message;
          if('asset_type' in notificationMessage && notificationMessage['asset_type'] == "catalog"){
            this.handleCatalogCreateNotification(notification)
            return;
          }
          if(Object.keys(notificationMessage).includes("parent_id_path") &&
            typeof notificationMessage.parent_id_path != undefined && notificationMessage.parent_id_path.length > 0){
            let category_parent_id = notificationMessage.parent_id_path[0]
            if (category_parent_id.endsWith(this.selectedCatalog._id)){
              if(document.getElementsByClassName("advanced-search-wrapper").length == 0){
                  this.addAssetToList(notification.message, true,true)
                console.log(`[handleAssetCreatedNotification][CatalogDisplay][Asset(<${asset_id}>) created in Category(<${this.selectedCatalog.name}>) ]`)
              }
            }
          }
        }
      },
      handleFileUpdatedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let fileInfo =  notification.message;
          if(fileInfo){
            let indx = this.assetsList.findIndex(op=>op.latest_version_id == fileInfo.version_id)
            if(indx >= 0){
              if('asset_ttl' in fileInfo && fileInfo.asset_ttl){
                this.$set(this.assetsList[indx], "asset_ttl", fileInfo.asset_ttl);
              }
              if('asset_lock' in fileInfo && fileInfo.asset_lock){
                this.$set(this.assetsList[indx], "asset_lock", fileInfo.asset_lock);
              }else{
                this.$set(this.assetsList[indx], "asset_lock", false);
              }
              if('user_id' in fileInfo && fileInfo.user_id){
                this.$set(this.assetsList[indx], "user_id", fileInfo.user_id);
              }
            }
          }
        }
      },
      handleAssetUpdatedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let asset_id = notification.message._id
          let notificationMessage = notification.message;
          if('asset_type' in notificationMessage && notificationMessage['asset_type'] == "catalog"){
            this.handleCatalogUpdateNotification(notification)
            return;
          }
          if(Object.keys(notificationMessage).includes("parent_id_path") &&
            typeof notificationMessage.parent_id_path != undefined && notificationMessage.parent_id_path.length > 0){
            let categoryPIDExists = false;
            for(let op of notificationMessage.parent_id_path){
              if(op.endsWith(this.selectedCatalog._id)){
                categoryPIDExists = true;
                break;
              }
            }
            let assetIndx = -1;
            if(this.assetsList && this.assetsList.length > 0){
              assetIndx = this.assetsList.findIndex((asset)=>asset._id==notification.message._id)
            }
            if(categoryPIDExists || (assetIndx >= 0)){
              if(document.getElementsByClassName("advanced-search-wrapper").length == 0){
                this.addAssetToList(notification.message, true)
              }
              this.updateAssetInList(notification.message, false)
              this.updateCatalog(notificationMessage)
              console.log(`[handleAssetUpdatedNotification][CatalogDisplay][Asset(<${asset_id}>) upodated in Category(<${this.selectedCatalog.name}>) ]`)
              if (notification.message.asset_state == "MARK FOR DELETE"){
                let assetStateFromFilter = JSON.parse(localStorage.getItem('file-status-filter-state'));
                if(assetStateFromFilter && Object.keys(assetStateFromFilter).length){
                  if(assetStateFromFilter.state && !(assetStateFromFilter.state.includes('MARK FOR DELETE'))){
                    this.handleAssetRemovedNotification(notification)
                  }
                }
              }
              this.$forceUpdate();
            }
          }
        }
      },
      handleAssetRemovedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let asset_id = notification.message.asset_id
          let notificationMessage = notification.message;
          if('asset_type' in notificationMessage && notificationMessage['asset_type'] == "catalog"){
            this.handleCatalogRemovedNotification(notification)
            return;
          }
          if(Object.keys(notificationMessage).includes("parent_id_path") &&
            typeof notificationMessage.parent_id_path != undefined && notificationMessage.parent_id_path.length > 0){
            let category_parent_id = notificationMessage.parent_id_path[0]
            if (category_parent_id.endsWith(this.selectedCatalog._id)){
              if("master_asset_have_subclips" in notification.message && "master_asset_id" in notification.message){
                let asset_id_check = this.assetsList.filter((asset)=>asset._id==notification.message.master_asset_id)
                if(asset_id_check.length > 0){
                      if(notification.message.master_asset_have_subclips == false)
                        asset_id_check[0].subclips_present = false;
                }
              }
              this.assetsList = this.assetsList.filter((asset)=>asset._id!=asset_id)
              console.log(`[handleAssetRemovedNotification][CatalogDisplay][Asset(<${asset_id}>) removed in Category(<${this.selectedCatalog.name}>) ]`)
              this.unselectElement()
            }else if(asset_id == this.selectedFileInfo._id){
              let categoryPIDExists = false
              for(let op of notificationMessage.parent_id_path){
                if(op.endsWith(this.selectedCatalog._id)){
                  categoryPIDExists = true;
                  break;
                }
              }
              if (!categoryPIDExists){
                this.assetsList = this.assetsList.filter((asset)=>asset._id!=asset_id)
                console.log(`[handleAssetRemovedNotification][CatalogDisplay][Asset(<${asset_id}>) removed in Category(<${this.selectedCatalog.name}>) ]`)
                this.unselectElement()
              }
            }
          }
        }
      },
      handleAssetOutdatedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
          let asset_info = notification.message.asset_info;
          this.assetsList = this.assetsList.filter((file_)=>file_._id != asset_info._id);
        }
      },
      handleAssetArchivedNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let job_info = notification.message
        let job = this.assetsList.filter((job_)=>job_.path == job_info.path);
        if (job.length != 0){
          job = job[0];
          job.storage_class = job_info.storage_class;
          job.archived = job_info.archived;
        }
      },
      handleJobUpdateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        let job_info = notification.message
        if(job_info.job_name == "Lock/Unlock" && job_info.state == 'COMPLETED'){
          if('asset_id' in job_info && job_info.asset_id.length > 0){
            // Iterate over the assetsList
            this.assetsList.forEach(asset => {
              // Check if the _id exists in array job_info.asset_id
              if (job_info.asset_id.includes(asset._id)) {
                // Add the 'lock' property to the matched entry
                this.$set(asset, 'lock', job_info.asset_lock);
              }
            });
          }
        }
      },
      registerforWebsocketNotifications(){
        this.addWSEventListener({eventname:["JOB_STATUS_UPDATE"], callback:this.handleJobUpdateNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.catalogCreatedNotification, callback:this.handleCatalogCreateNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.catalogModifiedNotification, callback:this.handleCatalogUpdateNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.catalogRemovedCreatedNotification, callback:this.handleCatalogRemovedNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.assetModifiedNotification , callback:this.handleAssetUpdatedNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification , callback:this.handleFileUpdatedNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.assetRemovedCreatedNotification, callback:this.handleAssetRemovedNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.assetOutdatedNotification, callback:this.handleAssetOutdatedNotification,parent:"CatalogsDisplay"})
        this.addWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleAssetArchivedNotification,parent:"BinsBrowse"})
      },
      unRegisterforWebsocketNotifications(){
        this.removeWSEventListener({eventname:["JOB_STATUS_UPDATE"], callback:this.handleJobUpdateNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.catalogCreatedNotification, callback:this.handleCatalogCreateNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.catalogModifiedNotification, callback:this.handleCatalogUpdateNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.catalogRemovedCreatedNotification, callback:this.handleCatalogRemovedNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.assetCreatedNotification, callback:this.handleAssetCreatedNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.assetModifiedNotification , callback:this.handleAssetUpdatedNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification , callback:this.handleFileUpdatedNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.assetRemovedCreatedNotification, callback:this.handleAssetRemovedNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.assetOutdatedNotification, callback:this.handleAssetOutdatedNotification,parent:"CatalogsDisplay"})
        this.removeWSEventListener({eventname:NotifierConstants.fileArchivedNotification, callback:this.handleAssetArchivedNotification,parent:"BinsBrowse"})
      },
      getCatalogInfobyIdFromInMem(catalog_id){
        if(this.workspace && this.workspace == 'Projects'){
          if (catalog_id == this.catalogSelected._id){
            return this.catalogSelected;
          }
        }else{
          if (catalog_id == this.getRootElement()._id){
            return this.getRootElement()
          }
        }
        let catalog_found = this.children.filter((catalog)=>catalog._id == catalog_id);
        if (catalog_found.length != 0){
          return catalog_found[0]
        }
        return {}
      },
      async getCatalogInfoFromCatalogStructure(catalog_id){
        let catalog_found = this.catalogTraverseStructure.filter((info)=>info._id==catalog_id)
        if (catalog_found.length !=0){
          return Object.assign({},catalog_found[0])
        }else {
          let catalogInfo = this.getCatalogInfobyIdFromInMem(catalog_id)
          if (Object.keys(catalogInfo) == 0){
            try{
  
              // let payload = {params:{catalog_id: catalog_id, asset_type:"catalog"}}
              // let data = await this.getAllAssetsFromServer(payload);
              // if (Constants.acceptedStatusCodes.includes(data.statusCode)){
              //   if (data.assets[0]){
              //     let info = data.assets[0]
              //     catalogInfo = {
              //         _id: info._id, 
              //         pid: info.parent_id_path[0],
              //         file_name: info.catalog_name,
              //         catalog_name: info.catalog_name,
              //       }
              //   }
              // }
              let traverseStructre = await this.getCatalogStructureFromCatalogID({params: { catalog_id: catalog_id }})
              this.catalogTraverseStructure = traverseStructre.catalog_structure?traverseStructre.catalog_structure:[]
              if (this.catalogTraverseStructure.length !=0){
                catalogInfo = Object.assign({}, this.catalogTraverseStructure[this.catalogTraverseStructure.length -1])
              }
  
            }catch {
              return {}
            }
          }
          if (catalogInfo){
            return catalogInfo
          }
        }
        return {}
      },
      async handleBrowse(){
        let params = {}, route_params = Object.assign({}, this.$route.params), query=Object.assign({}, this.$route.query) 
        this.searchKeyword = query.keyword?query.keyword:null
        this.$emit("retainSearchedKeywordToExplorer", this.searchKeyword);
        if (route_params.catalog_id && (!route_params.pid || !route_params.file_name || !route_params.catalog_name)){
          route_params = Object.assign( {
            _id: this.$route.params.catalog_id, 
            catalog_type:this.$route.params.catalog_type
          }, await this.getCatalogInfoFromCatalogStructure(this.$route.params.catalog_id))
        }
        if (!route_params.pid){
          route_params.pid = (route_params.parent_id_path && route_params.parent_id_path[0])?route_params.parent_id_path[0]:null
        }
        if (!route_params.file_name){
          route_params.file_name = route_params.catalog_name?route_params.catalog_name:null
        }
  
        if(Utils.getLocalStorageValue('selectedDepartmentsArr')){
          this.selectedProjectsArr = JSON.parse(Utils.getLocalStorageValue('selectedDepartmentsArr'))
        }
  
  
        if (!(this.selectedCatalog) || (this.selectedCatalog._id != route_params._id) ){
          this.selectedCatalog = Object.assign({}, route_params)
          Object.assign(this.currentCategoryInfo, this.selectedCatalog)
        }
        this.currentPage = query.page?query.page:1
        try {
            this.advanceSearchKeys = JSON.parse(query.advanceFilter)
        } catch  {
            this.advanceSearchKeys = {}
        }
        if (route_params && route_params._id && route_params.pid && route_params.file_name && route_params.catalog_name){
          params = {
            _id: route_params._id, 
            pid: route_params.pid,
            file_name: route_params.file_name,
            catalog_name: route_params.catalog_name,
            permissions: route_params.permissions,
            catalog_type: route_params.catalog_type,
            asset_state: route_params.asset_state
            }
        }else{
            this.catalogTraverseStructure = []
        }
        this.$emit("handleCatalogPageReferesh", this.selectedCatalog)
        this.loadData(params);
      },
      fetchDeploymentBinsFromServer(){
        this.deploymentBinsList = []
        let payload = {};
          payload.params = {bin_type:"deployment",status:"active",filter:JSON.stringify(["bin_type"])}
          this.getAllBinsFromServer(payload).then((data)=>{
              this.deploymentBinsList = data.bins;
        });
      },
      handleBrowseComponent(compOnReload){
        if(compOnReload){
          this.routerComponentMapper[compOnReload]()
        }else{
          this.routerComponentMapper[this.$route.name]()
        }
      },
      reloadThePage(){
        this.unselectAllFiles()
        this.handleBrowse();
        this.keyToUpdate = Utils.getUUID();
      },
      closeOCBrowser(){
          this.enableOICBrowse = false;
      },
      ...mapActions("bins",["getAllBinsFromServer"]),
      ...mapActions("jobs", ["createNewJob"]),
      ...mapMutations("categories", ["setSelectedCategoryInCategoryBrowse"]),
      ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
      ...mapActions("assets", ["getAllAssetsFromServer", "getCatalogStructureFromCatalogID","updateAssetVersionDetails","getAssetInfoFromServer", "addAssetsPhotoAlbum", "addAssetsPackage", "updatePhotoAlbum", "downloadAssetsReportFromServer", "updateCatalogAsPhotoAlbum",
                                "updateLabelsForArchiveRequest", "updateLabelsForRetrieveRequest", "updateLabelsForTranscoderTarget1Request", "updateLabelsForTranscoderTarget2Request", "exportFilesToOutbox"]),
      ...mapGetters("privileges", ["getPrivilegeFromInMem"]),
      ...mapActions("privileges", ["updateAllUserActionstoInMem"]),
      ...mapMutations("registry", ["updateActionCallbacks","removeBinMoreContextMenu","exposeDamComponents"]),
      ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
      ...mapGetters("registry",[
                                  "getRegisteredBinsContextMenu", 
                                  "getRegisteredBinsMoreContextMenu",
                                  "getRegisteredBinsNewContextMenu",
                                  "getRegisteredBinsImportContextMenu",
                                  "getRegisteredShareContextMenu",
                                  "getRegisteredAIToolsContextMenu",
                                  "getRegisteresOpenWithContextMenu",
                                  "getRegisteredCatalogIconContextMenu","getRegisteredExportContextMenu" , "getRegisteredPluginMapper"
                              ]),
      ...mapMutations("locations", ["setLocationHash", "unsetLocationHash","changeLocationCallback", "unsetLocationChangeEventListenerCallback"]),
      ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
      ...mapGetters("pools", ["getPoolsfromInMem","getPoolDevicesfromInMem"]),
      ...mapMutations("download",["setDownloadFilesArr"]),
      ...mapActions("files",["updateFileInfo"])
    },
    created() {
      Object.assign(this.currentCatalogPermission, this.rootPathPermission);
      this.perPage = localStorage.getItem("perPageValue") || 50;
      
      const savedSortBy = localStorage.getItem("catalogs_sort_by_value");
      if (savedSortBy) {
        try {
          this.sortBy = JSON.parse(savedSortBy);
        } catch (error) {
          console.error("Invalid catalogs_sort_by_value in localStorage", error);
        }
      }

      this.setRootElement().then(()=>{
        // this.updateCatalogChildren(this.rootElement._id).then(()=>{
          // this.loadData(true);
          // if(this.$route.meta.componentType == "asset_modal_component"){
          //   this.isMetadataManagerVisible = true;
          //   if(this.$route.name == 'asset-properties'){
          //     this.openTagMetadataModel = 'properties';
          //   }else{
          //     this.openTagMetadataModel = this.$route.name;
          //   }
          // }else{
            this.handleBrowse();
          // }
          // this.keyToUpdate = Utils.getUUID();
        // })
      });
      this.updateAllUserActionstoInMem().then(()=>{
            // this.setUpContextMenuActions() // not required as it used to call it earlier
      })
  
      this.registerforWebsocketNotifications()
      this.fetchDeploymentBinsFromServer();
      this.exposeDamComponents({catalogs:()=>{return this}});
      this.loadEnabledMetadataColumns();
    },
    mounted(){
      this.$emit("selectedSingleFile", {});
      this.$emit("selectedMultipleFiles", {});
      this.loadColumnResizeWidths();
      if (this.$route.params && ((this.$route.params.requestedRoute 
            && Object.keys(this.$route.params.requestedRoute).length != 0 && 
            this.$route.params.requestedRoute.matched[this.$route.params.requestedRoute.matched.length-1].parent.name == "catalogs-display"))){
          let rParams = this.$route.params
          if('subComp' in rParams){
            this.handleBrowseComponent(rParams.subComp)
          }else{
            this.changeToSelectedComponent(this.$route.params.requestedRoute.name, 
              this.$route.params.requestedRoute.params.pluginId?this.$route.params.requestedRoute.params.pluginId:this.$route.params.requestedRoute.name.split("-")[0]
              , true)
          }
        }
    },
    beforeDestroy(){
      Utils.saveFolderHistory([])
      // Utils.unsetCookie("traverseHistory")
      // this.unsetLocationChangeEventListenerCallback()
      this.unRegisterforWebsocketNotifications()
      this.isdestroyed = true
    },
    watch:{
      immediate:true,
      deep:true,
      // searchKeyword(){
      //   this.refreshAssetsList(this.selectedCatalog);
      // },
      // isAdvancedSearchEnabled(newVal){
      //   if(newVal == false){
      //     this.advanceSearchKeys = {};
      //     this.refreshAssetsList(this.selectedCatalog);
      //   }
      // },
      openTagMetadataModel(newVal,oldVal){
        console.log("Watcher : openTagMetadataModel ",typeof(oldVal))
        if(newVal){
          this.closeContextMenu()
        }
      },
      "$route" : function(newVal, oldVal){
          this.eventsAttached = false;
        if (newVal.fullPath != oldVal.fullPath){
          try{
            let modalComponentList = ['modal_component','asset_modal_component','tag_modal_component','catalog_modal_component'];
            let routeNamesList = ['share', 'asset-object-detection'];
            if(oldVal.meta && (modalComponentList.indexOf(oldVal.meta.componentType) > -1 || routeNamesList.indexOf(oldVal.name) > -1)){
                  this.lastClosedDialogMap.modalName = oldVal.name;
                  this.lastClosedDialogMap.isAssetUnselectRequired = this.determineUnselectOfAssets(oldVal);
            }
          }catch(e){console.log(e)}
          if (["catalogs-display","assets-projects"].includes(this.$route.name)) {
            this.handleBrowse()
            if(this.$route.params && Object.keys(this.$route.params).includes('fromNotification') && this.$route.params.fromNotification){
              this.$emit("openAdvancedSearch")
            }
          }else if ((this.$route.matched[this.$route.matched.length-1].parent.name == "catalogs-display" || this.$route.matched[this.$route.matched.length-1].parent.name == "assets-projects") && 
                     this.$route.matched[this.$route.matched.length-1].parent.name != undefined &&
                     this.$route.meta.componentType != "asset_modal_component" 
                     && this.$route.name.replace("asset-", "") != this.openTagMetadataModel){
            this.handleBrowseComponent();
          }
        }
      },
      'rootCatalogInfo':function(newVal,oldVal){
        if(newVal != oldVal){
          this.currentCategoryInfo = {}
          this.selectedCatalog = this.workspace && this.workspace == 'Projects'?newVal:this.getRootElement();
          this.setSelectedCategoryInCategoryBrowse(this.selectedCatalog)
          this.catalogTraverseStructure = [{ _id: this.selectedCatalog._id, file_name: this.selectedCatalog.catalog_name, pid: this.selectedCatalog.parent_id_path[0], catalog_name:this.selectedCatalog.catalog_name, permissions:this.selectedCatalog.permissions}];
            this.refreshAssetsList();
        }
      },
      isMetadataView:{
        immediate : true,
        handler(newVal){
            if(newVal){
              this.resetContextMenuOptions();
              this.keyToUpdate = Utils.getUUID();
            }
        }
      },
      viewType:{
        immediate: true,
        handler(){
            if(!this.isMetadataView){
                this.resetContextMenuOptions();
                this.keyToUpdate = Utils.getUUID();
            }
        }
      },
    //   selectedCatalog(newVal, oldVal){
    //     if (newVal._id == undefined){
    //       this.children = []
    //     }else{
    //       if (newVal._id!=oldVal._id){
    //         this.updateCatalogChildren(newVal._id)
    //       }
    //     }
    //   }
    },
    data() {
      return {
        currentCatalogPermission:{
          "permission":"no-access"
        },
        transcriptSearchEntry:null,
        eOMenu:false,
        eventsAttached: false,
        rootElement:{},
        children:[],
        isLoaded : false,
        isdestroyed: false,
        loadFromCookie:true,
        selectedCatalog: {},
        selectedInfo:{},
        assetsList: [],
        catalogTraverseStructure:[],
        showMenu: false,
        x: 0,
        y: 0,
        submenuX: 0,
        submenuY: 0,
        submenuNewX: 0,
        submenuNewY: 0,
        showMoreSubMenu: false,
        showExportSubMenu: false,
        showExportProxySubMenu: false,
        showShareSubmenu: false,
        showAIToolsSubmenu: false,
        showCatalogsIconSubmenu: false,
        showNewSubMenu: false,
        showImportSubMenu: false,
        subMenuItems: [],
        subMenuNewItems: [],
        subMenuImportItems: [],
        subMenuShareItems: [],
        subMenuAIToolItems:[],
        subMenuOpenWithItems:[],
        subMenuExportItems:[],
        subMenuExportProxyItems:[],
        subMenuCatalogIconItems:[],
        deploymentBinsList: [],
        contextMenuItems: [],
        isActive: null,
        currentCategoryInfo:{},
        page: 1,
        currentPage:1,
        totalPages: -1,
        totalAssets: -1,
        perPage: -1,
        isMetadataManagerVisible:false,
        openTagMetadataModel:null,
        vdialogComponents:["retrieve-as","edit-catalog","create-catalog","create-photo-album", "create-asset-package", "fusion-assets-browser", "svg-icon-browser","metadata-requestor", "files-browser", "edit-and-share", "modify-ttl", "manage-version", "set-label-to-asset", "manage-assets-link","set-user-dialog"],
        ModalParentRoute:{},
        selectedFileInfo:{},
        selectedFiles:{},
        options:{chunk:5},
        dragSelected:false,
        sortBy:{label:'Relevance',sortOn:'added_datetime',ascDesc:-1},
        growingFileGif: Utils.getLoadingGif(),
        markForDeleteIcn: Utils.getMarkForDeleteIcon(),
        openSubclips:false,
        openVideoTranscript:false,
        showFiles:true,
        showCatalogs:true,
        showPackages: true,
        showAlbums:true,
        showCatalogsInListView:true,
        showPackagesInListView:true,
        showAlbumsInListView:true,
        showFilesInListView:true,
        assetsPerpage:-1,
        searchKeyword:null,
        fileStateCheck:null,
        subMenuArchiveItems:[],
        subMenuRetrieveItems:[],
        showArchiveToSubMenu:false,
        showOpenWithToolSubmenu:false,
        showRetrieveFromSubmenu:false,
        routerComponentMapper:{
          "asset-move-catalog-manager":this.moveCatalogAction,
          "asset-bulk-tagmetadata-manager":this.bulkTagMetadataAction,
          "asset-metadata-manager":this.handleTagMetadataAssetHoverAction,
          "PAM-asset-metadata-manager":this.handleTagMetadataAssetHoverAction,
          "asset-new-review":this.reviewCatelogAction,
          "asset-PartialRetrieve":this.submitPartialRetrieveAction,
          "asset-properties":this.openProperties,
          "PAM-asset-properties":this.openProperties,
          "asset-share-in-chat": this.openShareInChat,
          "asset-OCR": this.submitOCRAction,
          "asset-object-detection":this.submitOBDAction,
          "asset-facedetection":this.submitFaceDetectionAction,
          "asset-audio-transcript": this.submitTranscript,
          "asset-video-transcript": this.submitTranscript,
          "sub-clips-manager": this.subclipsActions,
          "metadata-dock-sub-clips-manager": this.subclipsActionsThroughMetadataDock,
          "metadata-dock-video-transcript-manager":this.submitSubclipTranscript,
          "PartialRetrieve-from-metadata-dock": this.submitPartialRetrieveActionFromMetadataDock,
          "asset-share-with-user":this.shareWithUser,
          "asset-share-via-email":this.shareViaEmail,
          "asset-share-with-user-from-global-btn": this.shareWithUserFromGlobalBtn,
          "asset-livemedia-comment-review": this.assetCommentsAction,
        },
        altoLogo:Utils.getAltoLogo(),
        descriptionVisibilityArr:[],
        allFilesSelected:false,
        lastClosedDialogMap:{isAssetUnselectRequired:true,modalName:''},
        enableOICBrowse:false,
        parentIPList:[],
        selectedAssetId:"",
        storyboardPreviewActiveId:null,
        browseCoverPhoto:false,
        browseInPackage:false,
        keyToUpdate:Utils.getUUID(),
        MAX_WIDTH: 320,
        MAX_HEIGHT: 180,
        PROFILE_IMAGE_ALLOWED_WIDTH:128,
        selectedProjectsArr:'all',
        updateDepartments:false,
        advanceSearchKeys:{},
        componentThis:null,
        promiseAssetsList:null,
        tempAssetsList:null,
        enableCustomMessage:false,
        openCustomPaginationModal:false,
        enabledMetadataColumnIds: [],
        columnWidths: {},
        resizingColumnKey: null,
        resizeStartX: 0,
        resizeStartWidth: 0,
        tableScrollWidth: 1400,
        columnResizeWidths: {},
        isResizingColumn: false,
        expandedMultilineFields: {},
        metadataColumnsRefreshKey:0
      };
    },
  };
  
  